export default {
    VIETNAMESE: "Tiếng việt",
    ENGLISH: "English",
    JAPANESE: "日本語",
    KOREAN: "한국어",
    CHINESE: "中文",
    LAO: "ພາສາລາວ",
    KHMER: "ភាសាខ្មែរ", //tiếng campuchia
    SYNC: "ຊິງຄ໌",
    PLEASE_SELECT_DATE_LESS_6_MONTH: "ກະລຸນາເລືອກຊ່ວງວັນທີທີ່ບໍ່ເກີນ 6 ເດືອນ",
    //#region chainManager
    CHAIN_DASHBOARD_INFO: "ແຊ່ນ",
    CHAIN_DASHBOARD: "ແຊ່ນແດສບອດ",
    BOOKING_DASHBOARD: "ແດສບອດການຈອງ",
    USE_HOTEL: "ໃຊ້ໂຮງແຮມ",
    //#endregion
    //#region alert
    CANCEL_SUCCESS: "ອັບເດດສຳເລັດ",
    BOOKING_PAID: "ຈ່າຍແລ້ວ",
    BOOKING_CANCELED: "ບໍ່ສາມາດຍົກເລີກການຈອງໄດ້, ກະລຸນາກວດສະຖານະ",
    LOCATION_IS_NOT_EXIST: "ບ່ອນທີ່ບໍ່ມີຢູ່",
    ROOM_AVAILS_INCORRECT: "ຈຳນວນຫ້ອງຫວ່າງບໍ່ຄວນຫຼາຍກວ່າຈຳນວນຫ້ອງທີ່ລົງທະບຽນ",
    PROMOTION_NULL: "ໂປຣໂມຊັ່ນບໍ່ມີຢູ່",
    CANCLE_FAILE: "ຍົກເລີກບໍ່ສຳເລັດ",
    DELETE_FAILE: "ລຶບບໍ່ສຳເລັດ",
    GROUP_USED: "ກຸ່ມຜູ້ໃຊ້ກຳລັງໃຊ້ງານ",
    TRANSDATE_INCORRECT: "ວັນທີຊຳລະຕ້ອງຢູ່ລະຫວ່າງວັນທີຈອງແລະວັນທີອອກ",
    AMOUNT_INCORRECT: "ຈຳນວນເງິນບໍ່ຖືກຕ້ອງ",
    HAS_NO_DATA: "ບໍ່ມີຂໍ້ມູນ",
    LOCATION_NOT_EXIST: "ບ່ອນທີ່ບໍ່ມີຢູ່",
    UPDATE_SUCCESS: "ອັບເດດສຳເລັດ",
    UPDATE_CUCCESS: "ອັບເດດສຳເລັດ",
    DELETE_SUCCESS: "ລຶບສຳເລັດ",
    CREATE_SUCCESS: "ສ້າງສຳເລັດ",
    REGISTER_SUCCESS: "ລົງທະບຽນສຳເລັດ",
    UPLOAD_SUCCESS: "ອັບໂຫຼດສຳເລັດ",
    PROMOTIONS_ARE_BEING_USED: "ໂປຣໂມຊັ່ນກຳລັງໃຊ້ງານ",
    PROMOTIONS_DO_NOT_BELONG_TO_HOTELS: "ໂປຣໂມຊັ່ນບໍ່ໄດ້ສັງກັດໂຮງແຮມ",
    COUNPON_EXIST: "ຄູປອງມີຢູ່ແລ້ວ",
    USER_IS_EXIST: "ຊື່ຜູ້ໃຊ້ມີຢູ່ແລ້ວ",
    EMAIL_USER_IS_EXIST: "ອີເມວມີຢູ່ແລ້ວ",
    EMAIL_HOTEL_IS_EXIST: "ອີເມວຂອງໂຮງແຮມມີຢູ່ແລ້ວ",
    ACCOUNT_IS_TAKEN: "ຊື່ຜູ້ໃຊ້ນີ້ຖືກໃຊ້ແລ້ວ",
    USER_NAME_OR_EMAIL_IS_EXISTED: "ຊື່ຜູ້ໃຊ້ ຫຼື ອີເມວມີຢູ່ແລ້ວ",
    CANNOT_FIND_SOURCE: "ບໍ່ສາມາດຊອກຫາແຫຼ່ງຂໍ້ມູນໄດ້",
    IMAGE_CAPACITY_NOT_BIGGER_THAN: "ຂະໜາດຮູບພາບສູງສຸດ:",
    FILE_CAPACITY_NOT_BIGGER_THAN: "ຂະໜາດໄຟລ໌ສູງສຸດ:",
    IMAGE_SIZE_NOT_BIGGER_THAN: "ຮູບຕ້ອງມີຂະໜາດຕ່ຳສຸດ",
    INVALID_IMAGE_FORMAT: "ຟອຣ໌ແມັດຮູບພາບບໍ່ຖືກຕ້ອງ",
    INVALID_FILE_FORMAT: "ຟອຣ໌ແມັດໄຟລ໌ບໍ່ຖືກຕ້ອງ",
    DELETE_FAIL: "ລຶບບໍ່ສຳເລັດ",
    IMAGE_MAIN_EMPTY: "ບໍ່ມີຮູບຫຼັກ",
    ROOM_EMPTY: "ບໍ່ມີຫ້ອງ",
    ROOM_IS_SELECTING: "ຫ້ອງກຳລັງເລືອກ",
    NOT_SELECTED_PROMOTION: "ບໍ່ໄດ້ເລືອກໂປຣໂມຊັ່ນ",
    MISSING_FIELD: "ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບຖ້ວນ",
    CONFIRM_DELETE_PHOTOS: "ຢືນຢັນການລຶບຮູບ",
    MAIN_IMAGES_MUST_EXIST: "ຕ້ອງມີຮູບພາບຫຼັກ",
    CONFIRM_DELETE_POLICY: "ຢືນຢັນການລຶບນະໂຍບາຍ",
    CONFIRM_DELETE_SALE_PACKAGE: "ຢືນຢັນລຶບແພັກແກັດຂາຍຫ້ອງ",
    CONFIRM_DELETE_PROMOTION_PACKAGE: "ຢືນຢັນລຶບແພັກແກັດໂປຣໂມຊັ່ນນີ້",
    CONFIRM_DELETE_ROOM: "ຢືນຢັນລຶບຫ້ອງ",
    UPLOAD_EXPIRED: "ອັບໂຫຼດໝົດອາຍຸ",
    PAYMENT_METHOD_HAS_NOT_SELECTED: "ບໍ່ໄດ້ເລືອກວິທີການຊຳລະເງິນ",
    SETTING_GATEWAY_EMPTY: "ບໍ່ມີການຕັ້ງຄ່າ Gateway",
    DEPOSIT_COMPARE_PAYMENT: "ວັນກຳນົດຈ່າຍບໍ່ຄວນຫຼາຍກວ່າເງື່ອນໄຂການວາງມັດ",
    TIP_MAIN_IMAGE: "ຮູບໂຮງແຮມແມ່ນຮູບທຳອິດ. ລາກແລະວາງເພື່ອປ່ຽນລຳດັບການສະແດງ",
    TIP_MAIN_ROOM_IMAGE: "ຮູບຫ້ອງແມ່ນຮູບທຳອິດ. ລາກແລະວາງເພື່ອປ່ຽນລຳດັບການສະແດງ",
    CUSTOMER_PACKAGE_NOT_BIGGER_THAN_ROOM: "ຈຳນວນຜູ້ເຂົ້າພັກທີ່ນຳໃຊ້ແພັກແກັດບໍ່ຄວນຫຼາຍກວ່າຈຳນວນແຂກສູງສຸດຂອງຫ້ອງ",
    FIELD_NUMBER_FORMAT: "ອະນຸຍາດໃຫ້ປ້ອນແຕ່ຕົວເລກ, ບໍ່ມີຊ່ອງວ່າງ",
    FIELD_POSITIVE_FORMAT: "ອະນຸຍາດໃຫ້ປ້ອນແຕ່ຕົວເລກບວກ, ບໍ່ມີຊ່ອງວ່າງ",
    FIELD_DISTANCE_FORMAT: "ປ້ອນໄດ້ແຕ່ຕົວເລກ, ຈຸດ (.), ບໍ່ມີຊ່ອງວ່າງ",
    CHAIN_NAME_EMPTY: "ບໍ່ມີຊື່ແຊ່ນ",
    USER_IS_NOT_EXIT: "ບໍ່ມີຜູ້ໃຊ້ນີ້",
    USER_IS_NOT_EXIST: "ບໍ່ມີຜູ້ໃຊ້ນີ້",
    HOTEL_WAS_IN_CHAIN: "ໂຮງແຮມຢູ່ໃນແຊ່ນ",
    //#endregion

    DESCRIPTION_INFO: "ລາຍລະອຽດ",
    REQUIRED: "*",
    SELECT_ALL: "ເລືອກທັງໝົດ",
    IMAGES: "ຮູບພາບ",
    HOTEL_PHOTO: "ຮູບໂຮງແຮມ",
    LIBRARY: "ຄັງຮູບ",
    ADD_NEW: "ສ້າງໃໝ່",
    AND: "ແລະ",
    BACK: "ກັບຄືນ",
    SAVE: "ບັນທຶກ",
    EDIT: "ແກ້ໄຂ",
    DELETE: "ລົບ",
    COPY: "ຄັດລອກ",
    POLICY: "ນະໂຍບາຍ",
    ALWAYS: "ຕະຫຼອດເວລາ",
    IN_PERIOD: "ໄລຍະເວລາ",
    GENERAL_SETTING: "ການຕັ້ງຄ່າທົ່ວໄປ",
    PAYMENT_POLICY: "ນະໂຍບາຍການຈ່າຍເງິນ",
    CANCELATION_POLICY: "ນະໂຍບາຍການຍົກເລີກ",
    PAY_GATE: "ປະຕູການຈ່າຍເງິນ",
    AGENT_STOP_CONNECT: "ຕົວແທນຢຸດເຊື່ອມຕໍ່",
    WARNING_METHOD: "ວິທີແຈ້ງເຕືອນ",
    ALERT_RECEIVING_METHOD: "ວິທີແຈ້ງເຕືອນ",
    SELECT_WARNING_METHOD: "ເລືອກວິທີແຈ້ງເຕືອນ",
    WARNING_QTY_ROOM: "ແຈ້ງເຕືອນເມື່ອຈຳນວນຫ້ອງຫຼຸດລົງຈາກຄ່າກຳນົດ",
    SETTING_WARNING_ROOM: "ແຈ້ງເຕືອນເມື່ອຫ້ອງຖືກໃຊ້ເຖິງຄ່າທີ່ກຳນົດ",
    SEND_WARNING_ANY_ROOM: "ແຈ້ງເຕືອນເມື່ອຫ້ອງໃດກໍ່ຕາມເຫຼືອຕ່ຳກວ່າຄ່າທີ່ກຳນົດ",
    SEND_WARNING_ROOM: "ແຈ້ງເຕືອນເມື່ອຈຳນວນຫ້ອງຖືກໃຊ້ເຖິງຄ່າທີ່ກຳນົດ",
    QTY_ROOM_LESS_THAN: "ຈຳນວນຫ້ອງໜ້ອຍກວ່າ",
    HOTEL_WARNING: "ວິທີແຈ້ງເຕືອນ",
    SETTING_AT_LEAST_1_ROOM: "ກະລຸນາເລືອກຢ່າງໜ້ອຍ 1 ຫ້ອງເພື່ອຕັ້ງຄ່າແຈ້ງເຕືອນ",

    // HOTEL INFOMATION
    REGISTER_INFO: "ຂໍ້ມູນການລົງທະບຽນ",
    EXTENSION: "ສິ່ງອຳນວຍຄວາມສະດວກ",
    NEARBY_PLACE: "ສະຖານທີ່ໃກ້ຄຽງ",
    HOTEL_CHAIN: "ໂຮງແຮມໃນເຄรືອ",
    HOTEL_REGISTER_INFO: "ຂໍ້ມູນການລົງທະບຽນໂຮງແຮມ",

    //#region Register information
    HOTEL_CODE: "ລະຫັດໂຮງແຮມ",
    STAR_RATING: "ດາວ",
    HOTEL_LOGO: "ໂລໂກ້",
    CONTACT_PHONE: "ເບີໂທລະສັບ",

    HOTEL_TYPE: "ປະເພດໂຮງແຮມ",
    COUNTRY: "ປະເທດ",
    CITY: "ແຂວງ/ເມືອງ",
    DISTRICT: "ເມືອງ/ເມືອງ/ເມືອງ",
    WARD: "ຕຳບล",
    HOTEL_NAME: "ຊື່ໂຮງແຮມ",
    ADDRESS: "ທີ່ຢູ່",
    MAP_LOCATION: "ຕຳແໜ່ງໃນແຜນທີ່",
    LONGITUDE: "ລອງຈິຈູດ",
    LATITUDE: "ລາຕິຈູດ",
    //#endregion

    // LEFT MENU
    DASHBOARD: "ແຜງຄວບຄຸມ",
    MANAGE: "ຈັດການ",
    BOOK_ROOM: "ຈອງຫ້ອງ",
    ROOM_SALE: "ຂາຍຫ້ອງ",
    ROOM_AVAILABLE_AND_PRICE: "ຄົງຄ່າແລະລາຄາ",
    SALE_AND_PROMOTION_PACKAGES: "ແພັກແກັຈຂາຍແລະໂປຣໂມຊັ່ນ",
    SETTING: "ການຕັ້ງຄ່າ",
    ACCOUNT_INFO: "ການຕັ້ງຄ່າບັນຊີ",
    ACCOUNT_SETTING: "ບັນຊີສ່ວນຕົວ",
    USER_MANAGE: "ຈັດການຜູ້ໃຊ້",
    CONTRACT: "ສັນຍາ",
    HOTEL_INFOMATION: "ການຕັ້ງຄ່າໂຮງແຮມ",
    GENERAL_INFO: "ການຕັ້ງຄ່າທົ່ວໄປ",
    TYPE_ROOM: "ປະເພດຫ້ອງ",
    HOTEL_CONFIG: "ການຕັ້ງຄ່າ",
    GALLERY_MANAGER: "ຈັດການຮູບ",
    TRAVEL_AGENT: "ຕົວແທນທ່ອງທ່ຽວ",
    ACTIVITY_DAIRY: "ບັນທຶກລະບົບ",
    ACTIVITY_DIARY_UPDATE_BULK: "ບັນທຶກການອັບເດດຈຳນວນຫຼາຍ",
    ACTIVITY_DIARY_UPDATE_ROOM_AVAIL: "ບັນທຶກອັບເດດຫ້ອງ",
    SUPPORT: "ຊ່ວຍເຫຼືອ",
    INSTRUCTION_DOCUMENT: "ເອກະສານຄຳແນະນຳ",
    INSTRUCTION_DOCUMENT_CONNECT_BE: "ການເຊື່ອມເວັບໄຊທ໌",
    COPYED: "ຄັດລອກແລ້ວ",
    VIEW_DEMO: "ມອງຫນ້າຄົມວິທີການຈອງ",
    HOTLINE: "ເບີສາຍດ່ວນ",
    BOOKING_LIST: "ການຈອງ",
    REQUEST_BOOKING_LIST: "ຄຳຂໍການຈອງ",
    REVENUE_AND_EXPENDITURE_TRANSACTION: "ທຸລະກຳ",
    AGENT_LIST: "ລາຍຊື່ຕົວແທນ",
    UNLINKED_LIST: "ຕົວແທນທີ່ຢຸດເຮັດວຽກ",
    PREVIEW_ON_BE: "ມອງຫນ້າຈອງຫຼັງ",
    PREVIEW_ON_TA: "ເບິ່ງຫນ້າ TA",
    SALE_CHANNEL: "ຊ່ອງທາງຂາຍ",
    CHANNEL_GROUP: "ກຸ່ມຊ່ອງທາງ",
    // END LEFT MENU

    SUNDAY: "ວັນອາທິດ",
    MONDAY: "ວັນຈັນ",
    TUESDAY: "ວັນອັງຄານ",
    WEDNESDAY: "ວັນພຸດ",
    THURSDAY: "ວັນພະຫັດ",
    FRIDAY: "ວັນສຸກ",
    SATURDAY: "ວັນເສົາ",

    _DATE_RANGE: {
        SUNDAY: "ອາ",
        MONDAY: "ຈ",
        TUESDAY: "ອັງ",
        WEDNESDAY: "ພ",
        THURSDAY: "ພະ",
        FRIDAY: "ສຸ",
        SATURDAY: "ເສົາ",
        JAN: "ມັງກອນ",
        FEB: "ກຸມພາ",
        MAR: "ມີນາ",
        APR: "ເມສາ",
        MAY: "ພຶດສະພາ",
        JUN: "ມິຖຸນາ",
        JUL: "ກໍລະກົດ",
        AUG: "ສິງຫາ",
        SEP: "ກັນຍາ",
        OTC: "ຕຸລາ",
        NOV: "ພະຈິກ",
        DEC: "ທັນວາ"
    },

    //#region PAYGATE
    _PAYGATE: {
        PAYMENT_THROUGH: "ການຈ່າຍເງິນຜ່ານ",
        PAYMENT_METHOD: "ວິທີການຈ່າຍເງິນ",
        ONLINE_PAYMENT_GATEWAY: "ປະຕູການຈ່າຍເງິນອອນໄລນ໌",
        CONFIGURATION: "ການຕັ້ງຄ່າ",
        CONFIG_PAYMENT_GATE: "ຕັ້ງຄ່າປະຕູຈ່າຍເງິນ",
        HOTEL: "ໂຮງແຮມ",
        TRANSFER_PAYMENT: "ການໂອນເງິນ",
        ONLINE_PAYMENT: "ການຈ່າຍເງິນອອນໄລນ໌",
        PAYMENT_TYPE_EMPTY: "ບໍ່ມີປະເພດການຈ່າຍເງິນ",
        PAYMENT_METHOD_HAS_NOT_SELECTED: "ຍັງບໍ່ໄດ້ເລືອກວິທີການຈ່າຍເງິນ",
        PAYMENT_GATEWAY_IS_NOT_EXIST: "ຍັງບໍ່ໄດ້ເລືອກປະຕູຈ່າຍເງິນອອນໄລນ໌",
        CASH: "ຈ່າຍເງິນສົດ",
        DEBT: "ການຊຳລະໜີ້",
        PAYMENT_CARD: "ບັດຈ່າຍເງິນ"
    },
    //#endregion

    //#region nearby place
    NEAREST_POPULAR_LOCATION: "ສະຖານທີ່ນິຍົມໃກ້ທີ່ສຸດ",
    MOST_POPULAR_LOCATION: "ສະຖານທີ່ນິຍົມທີ່ສຸດ",
    RESTAURANT_AND_MARKET: "ຮ້ານອາຫານແລະຕະຫຼາດ",
    TRAVEL_PLACE: "ສະຖານທີ່ທ່ອງທ່ຽວ",
    NEAREST_AIRPORT: "ສະໜາມບິນໃກ້ທີ່ສຸດ",
    VIETNAMESE_NAME: "ຊື່ພາສາຫວຽດ",
    ENGLISH_NAME: "ຊື່ພາສາອັງກິດ",
    ADD_LOCATION: "ເພີ່ມສະຖານທີ່",
    DISTANCE: "ລະຍະທາງ",
    //#endregion

    //#region room information
    ROOM_INFOMATION: "ຂໍ້ມູນຫ້ອງ",
    ROOM_AMENITIES: "ສິ່ງອຳນວຍຄວາມສະດວກໃນຫ້ອງ",
    ROOM_IMAGE: "ຮູບຫ້ອງ",
    ROOM_NAME: "ປະເພດຫ້ອງ",
    ROOM_TYPE: "ປະເພດຫ້ອງ",
    MEAL: "ອາຫານ",
    NAME_ROOM_TYPE: "ຊື່ປະເພດຫ້ອງ",
    NAME_ROOM_TYPE_DEFAULT: "ຫົວຂໍ້ (ຄ່າເລີ່ມຕົ້ນ)",
    TOTAL_ROOM: "ຈຳນວນຫ້ອງ",
    MAX_CUSTOMER_COUNT: "ຈຳນວນແຂກສູງສຸດ",
    ROOM_DIMENSION: "ຂະໜາດຫ້ອງ",
    BED_BONUS_COUNT: "ຈຳນວນຕຽງເພີ່ມ",
    PRICE_NORMAL_DAY: "ລາຄາວັນທຳອິດ",
    PRICE_WEEKEND: "ລາຄາວັນສຸດສັບດາ",
    ROOM_DIRECTION: "ທິດຂອງຫ້ອງ",
    BED_TYPE: "ປະເພດຕຽງ",
    ADULT: "ຜູ້ໃຫຍ່",
    CHILDREN: "ເດັກນ້ອຍ",
    ACTION: "ການດຳເນີນການ",
    COMMON_BED_TYPE: "ປະເພດຕຽງທົ່ວໄປ",
    COMBINATION_BED_TYPE: "ການລວມປະເພດຕຽງ",
    MORE_OPTIONS: "ຕົວເລືອກເພີ່ມເຕີມ",
    REMOVE_OPTIONS: "ລຶບຕົວເລືອກ",
    ADD_TYPE_BED: "ເພີ່ມປະເພດຕຽງ",
    FREE: "ຟຣີ",
    SURCHARGE: "ຄ່າບໍລິການເພີ່ມ",
    //#endregion

    //#region selling room
    PACKAGE: "ແພັກເກດ",
    SELLING_PACKAGE_INFO: "ຂໍ້ມູນແຜນລາຄາ",
    SELLING_PACKAGE: "ແຜນລາຄາ",
    SERVICE_PACKAGE: "ແພັກເກດສະວັນດີ",
    PROMOTION: "ໂປຣໂມຊັນ",
    PROMOTION_INFO: "ຂໍ້ມູນໂປຣໂມຊັນ",
    NAME_SELLING_PACKAGE: "ຊື່ແຜນລາຄາ",
    PACKEAGE_APPLY_FOR: "ແພັກເກດຂາຍນຳໃຊ້ສໍາລັບ",
    MEALS_INCLUDE: "ລວມອາຫານ",
    EXTRA_BED_PRICE: "ລາຄາຕຽງເພີ່ມ",
    EXTRA_ADULT_PRICE: "ລາຄາຜູ້ໃຫຍ່ເພີ່ມ",
    EXTRA_CHILD_PRICE: "ລາຄາເດັກເພີ່ມ",
    MIN_NIGHT: "ຈໍານວນຄືນຂັ້ນຕ່ໍາ",
    MAX_NIGHT: "ຈໍານວນຄືນສູງສຸດ",
    DAYS_NOT_APPLY: "ວັນທີບໍ່ນຳໃຊ້",
    NOT_APPLY: "ວັນທີບໍ່ນຳໃຊ້",
    ADD_DAYS_NOT_APPLY: "ເພີ່ມວັນທີບໍ່ນຳໃຊ້",
    TYPE_ROOM_APPLIED: "ປະເພດຫ້ອງທີ່ນຳໃຊ້ໄດ້",
    PLAN_IS_SELECTING: "ແຜນຂາຍໄດ້ຖືກເຊື່ອມກັບ OTA",
    PLAN_NULL: "ບໍ່ມີແຜນລາຄາ",
    ERROR: "ຂໍອະໄພ, ເກີດຂໍ້ຜິດພາດບໍ່ຄາດຄິດ. ກະລຸນາລອງໃໝ່ພາຍຫຼັງ.",
    COPY_SUCCESS: "ຄັດລອກສໍາເລັດ",
    COPPY_SUCCESS: "ຄັດລອກສໍາເລັດ",
    NOT_SELECTED_PLAN: "ຍັງບໍ່ໄດ້ເລືອກແຜນລາຄາ",
    NOT_SELECTED_ROOM: "ຍັງບໍ່ໄດ້ເລືອກຫ້ອງ",
    MAX_STAY_NOT_SMALL_THAN_MIN_STAY: "ຈໍານວນຄືນສູງສຸດບໍ່ສາມາດນ້ອຍກວ່າຂັ້ນຕ່ໍາໄດ້",
    CBALERT_LB_AVAISEARCH: "ເລືອກຢ່າງໜ້ອຍໜຶ່ງລາຍການ",

    PROMOTION_PACKAGE_NAME: "ຊື່ໂປຣໂມຊັນ",
    PROMOTION_TYPE: "ປະເພດໂປຣໂມຊັນ",
    APPLY: "ນຳໃຊ້",
    APPLY_WITH: "ນຳໃຊ້ກັບ",
    DISCOUNT_AND_SURCHARGES: "ອັດຕາສ່ວນຫຼຸດ/ຄ່າບໍລິການ",
    DAYS_APPLY: "ວັນທີ່ນຳໃຊ້",
    TIME_STAY: "ວັນພັກ",
    TIME_SET: "ວັນຈອງ",
    TARGET_APPLY: "ຜູ້ຮັບສິດ",
    ARGENT_LEVEL_APPLY: "ເລືອກລະດັບເອເຢນ",
    ARGENT_APPLY: "ເລືອກເອເຢນ",
    PACKAGE_APPLY: "ແຜນລາຄາ",
    X_DAYS: "x ມື້",
    FROM_DATE: "ແຕ່ວັນທີ",
    TO_DATE: "ເຖິງວັນທີ",
    MIN_COUNT: "ຈໍານວນຂັ້ນຕ່ໍາ",
    NIGHT_STAY: "ຈໍານວນຄືນ",
    ROOM_BOOK_QUANTITY: "ຈໍານວນຫ້ອງທີ່ຈອງ",
    QUANTITY_IS_FREE: "ຈໍານວນຟຣີ (y)",
    COUPON: "ຄູປອງ",
    STATUS: "ສະຖານະ",
    ACTIVE: "ເປີດໃຊ້ງານ",
    DEACTIVE: "ປິດໃຊ້ງານ",
    STATE_ACTIVE_OR_DEACTIVE: "ເປີດ/ປິດໃຊ້ງານ",
    //#endregion

    //#region booking room
    CONTACT_BOOKING_DETAIL: "ລາຍລະອຽດຜູ້ຕິດຕໍ່",
    BOOKING_DETAIL: "ລາຍລະອຽດການຈອງ",
    NORMAL_ROOM_DETAIL: "ລາຍລະອຽດຫ້ອງທົ່ວໄປ",
    VIP_ROOM_DETAIL: "ລາຍລະອຽດຫ້ອງ VIP",
    SERVICES: "ບໍລິການ",
    PAYMENT_HISTORY: "ປະຫວັດການຈ່າຍເງິນ",
    //#endregion

    //#region common
    FILE_NAME: "ຊື່ໄຟລ໌",
    FILE_TYPE: "ປະເພດໄຟລ໌",
    UPLOAD_BY: "ອັບໂຫຼດໂດຍ",
    FILE_CAPACITY: "ຄວາມຈຸໄຟລ໌",
    SIZE: "ຂະໜາດ",
    UPLOAD_TIME: "ເວລາອັບໂຫຼດ",
    CLOSE: "ປິດ",
    TOTAL: "ລວມ",
    OR: "ຫຼື",
    CHOOSE: "ເລືອກ",
    NO_PHOTOS_FOUND: "ບໍ່ພົບຮູບພາບ",
    //#endregion

    //#region upload controller
    DRAG_DROP_PHOTOS_HERE: "ລາກແລ້ວວາງຮູບພາບທີ່ນີ້",
    SELECT_PHOTOS_TO_UPLOAD: "ເລືອກຮູບພາບເພື່ອອັບໂຫຼດ",
    MAXIMUM_CAPACITY: "ຄວາມຈຸສູງສຸດ",
    LOADING: "ກຳລັງໂຫຼດ",
    //#endregion

    //#region hotel setting
    EMAIL_CONFIGURATION: "ການຕັ້ງຄ່າອີເມວ",
    HOTEL_EMAIL: "ອີເມວໂຮງແຮມ",
    EMAIL_RECEIVE_BOOKING_ALERT_CC: "ອີເມວແຈ້ງເຕືອນ",
    EMAIL_CO_RECEIVE_BOOKING_ALERT_CC: "ອີເມວແຈ້ງເຕືອນ (ສຳເນົາ)",
    EMAIL_RECEIVE_BOOKING_ALERT_BCC: "ອີເມວແຈ້ງເຕືອນ (ສຳເນົາປິດ)",
    DISPLAY_LANGUAGE_AND_WEEKEND: "ພາສາແລະວັນສຸດສັບດາ",
    DISPLAY_LANGUAGE: "ພາສາ",
    WEEKEND: "ວັນສຸດສັບດາ",
    CURRENCY_AND_TAXES_FEES: "ສະກຸນເງິນ ແລະ ພາສີ/ຄ່າບໍລິການ",
    CURRENCY_USED_IN_SYSTEM: "ສະກຸນເງິນ",
    VAT_RATE_IS_APPLIES: "VAT%",
    SERVICE_TAX_RATE_APPLIES: "ຄ່າບໍລິການ",
    PRICES_INCLUDE_TAXES_FEES: "ລາຄາລວມພາສີ/ຄ່າບໍລິການ",
    REGULATIONS_ON_CHILD_AGE_AND_ACCOMPANING_FEE: "ຂໍ້ກໍານົດອາຍຸເດັກ ແລະຄ່າເສີມ",
    YOUTH_IS_FREE_OF_CHARGE: "ອາຍຸເດັກທີ່ພັກຟຣີ",
    AGE_CHILD_EXTRA_CHARGE: "ອາຍຸເດັກທີ່ຄິດຄ່າເພີ່ມ",
    OTHER_INFOMATION: "ຂໍ້ມູນອື່ນໆ",
    CHECKIN_TIME: "ເວລາເຂົ້າພັກ",
    CHECKOUT_TIME: "ເວລາອອກຈາກພັກ",
    YEAR_BUILT: "ປີກໍ່ສ້າງ",
    TOTAL_NUMBER_OF_FLOORS: "ຈໍານວນຊັ້ນ",
    DISTANCE_TO_AIRPORT: "ລະຍະທາງໄປສະຫນາມບິນ",
    DISTANCE_TO_CITY_CENTER: "ລະຍະທາງໄປກາງເມືອງ",
    TIME_TO_AIRPORT: "ເວລາໄປສະຫນາມບິນ (ນາທີ)",
    VOLTAGE_USED: "ໄຟຟ້າທີ່ໃຊ້",
    ROOM_SERVICE: "ບໍລິການຫ້ອງ",
    HOTEL_RULES: "ນະໂຍບາຍໂຮງແຮມ",
    //#endregion

    //#region payment policy
    EFFECTIVE_DATE: "ວັນທີ່ໃຊ້ງານ",
    DEPOSIT_BEFORE_CHECKIN: "ມັດຈໍາກ່ອນເຂົ້າພັກ",
    PERCENT: "ເປີເຊັນ",
    AMOUNT_OF_MONEY: "ຈໍານວນເງິນ",
    PREPAYMENT_BEFORE_CHECKIN_DATE: "ຈ່າຍເງິນກ່ອນເຂົ້າພັກ",
    PAYMENT_BEFORE_CHECKOUT_DATE: "ຈ່າຍເງິນກ່ອນອອກຈາກພັກ",
    PAYMENT_BEFORE_DAY_CHECKIN_DATE: "ຈ່າຍເງິນຂະນະເຂົ້າພັກ",
    ADD_NEW_PAYMENT_POLICY: "ເພີ່ມນະໂຍບາຍການຈ່າຍໃໝ່",
    DEPOSIT_LEVEL_APPLIES: "ລະດັບການມັດຈໍາທີ່ນໍາໃຊ້",
    TIME_APPLICATION: "ວັນພັກ",
    //#endregion

    //#region cancellation policy
    CANCEL_ROOM_IN_ROUND_X_DAY_BEFORE_CHECKIN: "ຍົກເລີກການຈອງພາຍໃນ x ມື້ກ່ອນວັນເຂົ້າພັກ",
    FIXED_MONEY: "ຈໍານວນເງິນຄົງທີ່",
    ADD_NEW_CANCELLATION_POLICY: "ເພີ່ມນະໂຍບາຍການຍົກເລີກໃໝ່",
    FINES_APPLY: "ຄ່າປັບທີ່ນໍາໃຊ້",
    //#endregion

    //#region Header
    PERSONAL_ACCOUNT_SETTING: "ຕັ້ງຄ່າບັນຊີສ່ວນຕົວ",
    LOG_OUT: "ອອກຈາກລະບົບ",
    FEEDBACK_SUCCESS: "ການສົ່ງຄໍາແນະນໍາສໍາເລັດ",
    //#endregion

    _LOGIN: {
        LOGIN: "ເຂົ້າລະບົບ",
        USERNAME: "ຊື່ຜູ້ໃຊ້",
        PASSWORD: "ລະຫັດຜ່ານ",
        FORGOT_PASSWORD: "ລືມລະຫັດຜ່ານ",
        REGISTER_NOW: "ລົງທະບຽນຕອນນີ້",
        LOOKING_AGENT: "ກຳລັງມອງຫາເອເຈັນທ໌ບໍ?",
        LOGIN_HERE: "ເຂົ້າລະບົບທີ່ນີ້",
        INVALID_ACCOUNT_INFO_MESSAGE: "ຊື່ຜູ້ໃຊ້ ຫຼື ລະຫັດຜ່ານບໍ່ຖືກຕ້ອງ!",
        SESSION_EXPIRED: "ເວລາໃນການໃຊ້ງານໝົດອາຍຸ!",
        HAS_NO_ACCESS: "ບັນຊີນີ້ບໍ່ສາມາດເຂົ້າໃຊ້ງານໄດ້!",
        SESSION_EXPIRED_MESSAGE: "ດ້ວຍເຫດຜົນຄວາມປອດໄພ, ເວລາໃນການໃຊ້ງານໝົດອາຍຸ. ກະລຸນາໃສ່ຊື່ຜູ້ໃຊ້ ແລະ ລະຫັດເພື່ອເຂົ້າໃໝ່.",
        ARE_YOU_FORGOT_PASSWORD: "ທ່ານລືມລະຫັດບໍ?",
        ENTER_EMAIL_USERNAME: "ໃສ່ອີເມວ ຫຼື ຊື່ຜູ້ໃຊ້ເພື່ອຮັບລິ້ງການຕັ້ງຄ່າລະຫັດໃໝ່!",
        EMAIL_USERNAME: "ອີເມວ ຫຼື ຊື່ຜູ້ໃຊ້",
        EMAILADDRESS_ERROR_REQUIRED: "ກະລຸນາກວດສອບອີເມວຂອງທ່ານ!",
        EMAIL_NOT_EXIST: "ອີເມວ ຫຼື ຊື່ຜູ້ໃຊ້ບໍ່ມີຢູ່, ກະລຸນາລອງໃໝ່!",
        REQUEST_RESET_PASS_NOTICE: "ຄຳຮ້ອງຂໍຕັ້ງລະຫັດໃໝ່ສຳເລັດແລ້ວ",
        SEND_NEW_PASS: "ລະຫັດໃໝ່ໄດ້ສົ່ງໄປທີ່ອີເມວຂອງທ່ານແລ້ວ!",
        CANCEL: "ຍົກເລີກ",
        RESET: "ຢືນຢັນ",
        HOTELID: "ID ໂຮງແຮມ",
        EZID_LOGIN: "ເຂົ້າລະບົບດ້ວຍ ezID"
    },
    _RESET: {
        NOT_VALID_REQUEST: "ຄໍາຂໍຂອງທ່ານບໍ່ມີຜົນອີກຕໍ່ໄປ"
    },
    _REGISTER: {
        OTA_GROUP: "ກຸ່ມຊ່ອງທາງຂາຍ",
        OTA: "ຊ່ອງທາງຂາຍ",
        WELCOME: "ຍິນດີຕ້ອນຮັບສູ່ ezCrs - ອອກແບບພິເສດສໍາລັບໂຮງແຮມ",
        SOLOGAN: "ລົງທະບຽນກັບເຮົາວັນນີ້ ແລະ ເຮົາຈະຊ່ວຍໃຫ້ທ່ານຕັ້ງແຕ່ເລີ່ມຈົນສິ້ນສຸດ!",
        PERSONAL_DETAIL: "ຂໍ້ມູນສ່ວນຕົວ",
        HOTEL_DETAIL: "ຂໍ້ມູນໂຮງແຮມ",
        CREATE_ACCOUNT: "ສ້າງບັນຊີ",
        ENTER: "ໃສ່",
        HOTEL_EMAIL: "ອີເມວໂຮງແຮມ",
        ENTER_EMAIL: "ໃສ່ອີເມວ",
        ENTER_TAX_CODE: "ໃສ່ລະຫັດພາສີ",
        ENTER_ROOM_QUANTITY: "ໃສ່ຈຳນວນຫ້ອງ",
        YOUR_COMPANY_NAME: "ຊື່ບໍລິສັດ/ແບຣນຂອງທ່ານ",
        YOUR_WEBSITE_LINK: "ລິ້ງເວັບໄຊຂອງໂຮງແຮມ",
        SELECT: "ເລືອກ",
        REQUIRED: "ຈໍາເປັນ",
        FULLNAME: "ຊື່ເຕັມ",
        YOUR_FULLNAME: "ຊື່ເຕັມຂອງທ່ານ",
        PERSONAL_PHONE: "ເບີໂທສ່ວນຕົວ",
        MALE: "ຊາຍ",
        FEMALE: "ຍິງ",
        EMAIL: "ອີເມວ",
        YOUR_EMAIL: "ອີເມວຂອງທ່ານ",
        POSITION: "ຕຳແໜ່ງ",
        YOUR_POSITION: "ຕຳແໜ່ງຂອງທ່ານ",
        HOTEL_NAME: "ຊື່ໂຮງແຮມ",
        HOTEL_TYPE: "ປະເພດໂຮງແຮມ",
        TAX_CODE: "ລະຫັດພາສີ",
        COUNTRY: "ປະເທດ",
        WARD: "ເຂດ/ບ້ານ",
        WEBSITE: "ເວັບໄຊ",
        STAR: "ດາວ",
        CITY: "ເມືອງ",
        ADDRESS: "ທີ່ຢູ່",
        HOTEL_PHONE: "ເບີໂທໂຮງແຮມ",
        NUMBER_OF_ROOMS: "ຈໍານວນຫ້ອງ",
        DISTRICT: "ເມືອງ/ເຂດ/ເມືອງ",
        USERNAME: "ຊື່ຜູ້ໃຊ້",
        CREATE_NEW_ACCOUNT_NAME: "ສ້າງຊື່ຜູ້ໃຊ້ໃໝ່",
        PASSWORD: "ລະຫັດຜ່ານ",
        CREATE_PASSWORD: "ສ້າງລະຫັດຜ່ານ",
        RETYPE_PASSWORD: "ພິມລະຫັດຜ່ານອີກຄັ້ງ",
        PASSWORD_NOT_MATCH: "ລະຫັດບໍ່ກົງກັນ",
        PHONE_NUMBER_NOT_LESS_THAN: "ເບີໂທຕ້ອງມີຢ່າງນ້ອຍ 8 ຕົວເລກ",
        PASSWORD_NOT_LESS_THAN: "ລະຫັດຜ່ານຕ້ອງຢ່າງນ້ອຍ 8 ຕົວເລກ",
        VALID_USERNAME_MESSAGE: "ຊື່ຜູ້ໃຊ້ຕ້ອງໃຊ້ຕົວອັກສອນ ຫຼື ຕົວເລກເທົ່ານັ້ນ",
        BY_CLICKING_REGISTER: "ໂດຍການຄລິກລົງທະບຽນ, ທ່ານຍອມຮັບ",
        TERM_AND_CONDITIONS: "ເງື່ອນໄຂການໃຊ້ງານ",
        PRIVACY_POLICY: "ນະໂຍບາຍຄວາມປອດໄພ",
        AGREE_POLICY_MESSAGE: "ໂດຍການລົງທະບຽນ, ທ່ານຍອມຮັບເງື່ອນໄຂ ແລະ ນະໂຍບາຍຄວາມປອດໄພ",
        THANKS_FOR_REGISTER: "ຂອບໃຈສໍາລັບການລົງທະບຽນ!",
        WAIT_APPROVE: "ບັນຊີຖືກສ້າງແລ້ວ ແລະ ລໍຖ້າການອະນຸມັດ.",
        UPLOAD_CERTIFICATE_MESSAGE: "ກະລຸນາອັບໂຫຼດໃບຢັ້ງຢືນການຈົດທະບຽນ ເພື່ອໃຫ້ເຮົາຢືນຢັນບັນຊີຂອງທ່ານໄດ້ພາຍໃນ 48 ຊົ່ວໂມງ.",
        REQUIRED_FIELD: "ຈໍາເປັນຕ້ອງຕື່ມ",
        ACCOUNT_ALREADY_EXISTS: "ບັນຊີນີ້ມີຢູ່ແລ້ວ",
        REGISTER: "ລົງທະບຽນ",
        NEXT: "ຕໍ່ໄປ",
        BACK: "ກັບຄືນ",
        UPLOAD_FILE: "ອັບໂຫຼດໄຟລ໌",
        COMPLETE_AND_LOGIN: "ສໍາເລັດແລະກັບໄປໜ້າຫຼັກ"
    },
    _SUPPORT: {
        TITLE: "ຄໍາແນະນຳໃນການເຊື່ອມຕໍ່ເຄື່ອງມືຈອງຫ້ອງເຂົ້າກັບເວັບໄຊ"
    },
    _DASHBOARD: {
        TITLE: "ແຜງຄວບຄຸມ",
        IN_MONTH_REVENUE: "ລາຍຮັບໃນເດືອນນີ້ (VND)",
        SEVEN_DAY_REVENUE: "ລາຍຮັບ 7 ມື້ຜ່ານມາ (VND)",
        COLLECTION: "ຍອດຮັບຄ້າງຮັບ (VND)",
        ROOM_FILLING_RATE: "ອັດຕາການເຕັມຫ້ອງໃນເດືອນ",
        BOOKING_EMPTY: "ການຈອງໃໝ່ຈະປະກົດຢູ່ທີ່ນີ້",
        BOOKING_TIME: "ເວລາຈອງ",
        BOOKING_CODE: "ລະຫັດການຈອງ",
        AGENCY: "ຕົວແທນ",
        TIME_STAY: "ວັນທີ່ເຂົ້າພັກ",
        PACKAGE: "ແພັກເກັດການໃຊ້ງານ",
        TOTAL: "ລວມທັງໝົດ (VND)",
        PAYMENT_STATUS: "ສະຖານະການຈ່າຍເງິນ",
        BOOKING_NOT_PAYMENT: "ການຈອງທີ່ຍັງບໍ່ໄດ້ຈ່າຍ",
        BOOKING_PART_PAYMENT: "ການຈອງທີ່ຈ່າຍບາງສ່ວນ",
        BOOKING_CANCELED: "ການຈອງຖືກຍົກເລີກໂດຍລູກຄ້າ",
        GO_TO_BOOKING_LIST: "ເບິ່ງລາຍການຈອງທັງໝົດ",
        STATUS: "ສະຖານະ",
        HOTEL_STATUS: "ຂໍ້ມູນໂຮງແຮມ",
        CONTRACT: "ສັນຍາ",
        DEBT: "ໜີ້ສິນ",
        SYNC_PMS: "ຊິງຂໍ້ມູນກັບ PMS",
        MISSING_INFO: {
            SYNC_OTA: "ການຊິງຊ່ອງທາງຂາຍ",
            SYNC_OTA_SUB_TITLE: "ຊິງຢ່າງນ້ອຍ 1 ຊ່ອງທາງ",
            LIMITATIONS: "ກໍານົດຂໍ້ຈໍາກັດ",
            RESTRICTION_SUB_TITLE: "ກໍານົດຢ່າງນ້ອຍ 1 ຂໍ້ຈໍາກັດ",
            RATE_PLAN: "ກຳນົດລາຄາ ແລະ ຫ້ອງວ່າງ",
            RATE_PLAN_SUB_TITLE: "ກໍານົດຄ່າຕ່ໍາສຸດສໍາລັບ 1 ຊ່ອງທາງ ແລະ ຈໍານວນຫ້ອງ",
            TITLE: "ກະລຸນາກອກຂໍ້ມູນໃຫ້ຄົບຖ້ວນ",
            HOTEL_INFO: "ຂໍ້ມູນໂຮງແຮມ",
            HOTEL_INFO_SUB_TITLE: "ກອກຂໍ້ມູນທີ່ຈໍາເປັນ",
            ROOM_TYPE: "ຂໍ້ມູນປະເພດຫ້ອງ",
            ROOM_TYPE_SUB_TITLE: "ກຳນົດຢ່າງນ້ອຍ 1 ປະເພດຫ້ອງ",
            HOTEL_IMAGE: "ຮູບໂຮງແຮມ",
            HOTEL_IMAGE_SUB_TITLE: "ອັບໂຫຼດຮູບຢ່າງນ້ອຍ 1 ຮູບ",
            ROOM_PRICE: "ແຜນລາຄາ",
            ROOM_PRICE_SUB_TITLE: "ກຳນົດແຜນລາຄາຢ່າງນ້ອຍ 1 ຮາຍການ",
            HOTEL_SETTING: "ການຕັ້ງຄ່າໂຮງແຮມ",
            HOTEL_SETTING_SUB_TITLE: "ກອກຂໍ້ມູນທີ່ຈໍາເປັນ",
            BOOKING_CANCEL_POLICY: "ນະໂຍບາຍການຍົກເລີກຈອງ",
            BOOKING_CANCEL_POLICY_SUB_TITLE: "ກຳນົດນະໂຍບາຍຢ່າງນ້ອຍ 1 ລາຍການ",
            PAYMENT_GATE: "ຊ່ອງທາງຈ່າຍເງິນ",
            PAYMENT_GATE_SUB_TITLE: "ກຳນົດຢ່າງນ້ອຍ 1 ຊ່ອງທາງ",
            CONTRACT: "ສັນຍາ",
            CONTRACT_SUB_TITLE: "ກອກຂໍ້ມູນທີ່ຈໍາເປັນ",
            PAYMENT_POLICY: "ນະໂຍບາຍການຈ່າຍເງິນ",
            PAYMENT_POLICY_SUB_TITLE: "ກຳນົດນະໂຍບາຍຢ່າງນ້ອຍ 1 ລາຍການ",
            CLOSE: "ປິດໃຊ້ງານ",
            ROOM_PLAN: "ແຜນລາຄາຂາຍຫ້ອງ",
            ROOM_PLAN_SUB_TITLE: "ກຳນົດຢ່າງນ້ອຍ 1 ແຜນຂາຍ",
            HOTEL_CONFIG: "ການຕັ້ງຄ່າໂຮງແຮມ",
            HOTEL_CONFIG_SUB_TITLE: "ກອກຂໍ້ມູນທີ່ຈໍາເປັນ"
        },
        CONFIRM: "ຢືນຢັນ",
        CONFIRM_SELL_ROOM: "ຂ້ອຍຢືນຢັນວ່າຂໍ້ມູນທີ່ປ້ອນແມ່ນຖືກຕ້ອງ ແລະຍອມຮັບໃຫ້ໂພສຫ້ອງຂາຍໃນ OneInventory",
        CONFIRM_SELL_ROOM_BUTTON: "ຢືນຢັນຂາຍຫ້ອງ",
        _HOTEL_STATUS_INFO: {
            CREATE: "ສ້າງ",
            WAIT_CONFIRM: "ລໍຖ້າຢືນຢັນ",
            WAIT_APPROVE: "ລໍຖ້າອະນຸມັດ",
            APPROVED: "ອະນຸມັດແລ້ວ",
            SENT_BACK: "ສົ່ງກັບ",
            ONSITE: "ດຳເນີນງານ",
            OFFSITE: "ຢຸດດຳເນີນງານ"
        },
        _HOTEL_STATUS_CONTRACT: {
            NOT_CREATED: "ຍັງບໍ່ສ້າງ",
            CREATE: "ສ້າງ",
            RELEASED: "ອອກໃຊ້",
            WAIT_SIGN: "ລໍຖ້າເຊັນ",
            COMPLETED: "ສຳເລັດ",
            SIGNED: "ເຊັນແລ້ວ",
            IN_DISPUTE: "ຢູ່ໃນການໂຕ້ຖຽງ",
            LIQUIDATED: "ຍົກເລີກ",
            CLOSED: "ປິດ"
        },
        _HOTEL_STATUS_DEBT: {
            NOT_CONFIGURED: "ຍັງບໍ່ກຳນົດ",
            CONFIGURED: "ກຳນົດແລ້ວ"
        },
        _HOTEL_STATUS_SYNC_PMS: {
            SYNCHRONIZED: "ຊິງສໍາເລັດ",
            UNSYNCHRONIZED: "ຍັງບໍ່ຊິງ",
            RECEIVED: "ໄດ້ຮັບແລ້ວ",
            NOT_RECEIVED: "ຍັງບໍ່ໄດ້ຮັບ"
        }
    },
    // END
    _BATCH_UPDATE: {
        TITLE: "ການອັບເດດພ້ອມກັນຫຼາຍລາຍການ",
        ADD: "ເພີ່ມ",
        SELECT_ROOM_TYPE: "ເລືອກປະເພດຫ້ອງ",
        SELECT_UPDATE_TYPE: "ເລືອກປະເພດອັບເດດ",
        ALL_ROOM: "ທຸກຫ້ອງ",
        AVAILABLE_ROOM: "ຈໍານວນຫ້ອງ",
        PRICE: "ລາຄາ",
        STOP_SELL: "ຢຸດຂາຍ",
        CTA: "ບໍ່ຮັບເຂົ້າພັກ",
        CTD: "ບໍ່ຮັບອອກ",
        MIN_NIGHT_STAY: "ຈໍານວນຄືນພັກຂັ້ນຕ່ໍາ",
        MAX_NIGHT_STAY: "ຈໍານວນຄືນພັກສູງສຸດ",
        ROOM_TYPE_AND_SALE_PACKAGE: "ປະເພດຫ້ອງ / ລາຄາຂາຍ",
        FROM: "ຈາກ",
        TO: "ຫາ",
        MESSAGE: {
            OVERLAP_TIME: "ໄລຍະເວລາອັບເດດຕ້ອງບໍ່ຊໍ້າກັນ"
        },
        APPLY: "ນໍາໃຊ້",
        DELETE_STOP_SELL: "ລຶບການຢຸດຂາຍ",
        DELETE_CTA: "ລຶບບໍ່ຮັບເຂົ້າພັກ",
        DELETE_CTD: "ລຶບບໍ່ຮັບອອກ"
    },

    // Booking
    _BOOKING: {
        TITLE: "ລາຍການການຈອງ",
        BOOKING: "0 ການຈອງ | 1 ການຈອງ | {count} ການຈອງ",
        BOOKING_DATE: "ວັນທີຈອງ",
        BOOKING_CODE: "ລະຫັດການຈອງ",
        REQUEST_CODE: "ລະຫັດຄໍາຮ້ອງ",
        REQUEST_DATE: "ວັນທີສົ່ງຄໍາຮ້ອງ",
        REQUEST_STATUS: "ສະຖານະຄໍາຮ້ອງ",
        AGENT_NAME: "ຕົວແທນ",
        TIME_STAY: "ວັນທີເຂົ້າ-ອອກ",
        COMBO: "ແພັກແກັດຂາຍ",
        COMBO_REQUEST: "ຄໍາຮ້ອງແພັກແກັດ",
        AMOUNT: "ຈໍານວນເງິນລວມ",
        BOOKING_STATUS: "ສະຖານະການຈອງ",
        EXPORT: "ສົ່ງອອກ Excel",
        SEARCH: "ຄົ້ນຫາ",
        RESET: "ຣີເຊັດ",
        ENTER_BOOKING_CODE: "ໃສ່ລະຫັດການຈອງ",
        ENTER_BOOKING_CODE_OTA: "ໃສ່ລະຫັດການຈອງ OTA",
        ENTER_BOOKING_GROUP_CODE: "ໃສ່ລະຫັດການຈອງແບບກຸ່ມ",
        SEARCH_CONDITION: "ຄົ້ນຫາຕາມ",
        SEARCH_BOOKING_CODE: "ລະຫັດການຈອງ",
        SEARCH_DATE: "ເລືອກຊ່ວງວັນທີ",
        EDIT: "ດໍາເນີນການ",
        CONFIRM_FEEDBACK: "ຢືນຢັນສົ່ງຄໍາຮ້ອງໄປຕົວແທນ",
        CONFIRM_FEEDBACK_REASON: "ເນື້ອໃນຄໍາຕິຊົມ",
        SEARCH_BY: {
            BOOKING_CODE: "ລະຫັດການຈອງ",
            REQUEST_DATE: "ວັນສົ່ງຄໍາຮ້ອງ",
            BOOKING_DATE: "ວັນທີຈອງ",
            CHECKIN_DATE: "ວັນເຂົ້າພັກ",
            CHECKOUT_DATE: "ວັນອອກ",
            STAYING_DATE: "ວັນເຂົ້າ-ອອກ"
        },
        STATUS: {
            ALL: "ທັງໝົດ",
            CANCEL: "ຍົກເລີກໂດຍລູກຄ້າ",
            AWAIT_PAYMENT: "ລໍຖ້າການຊໍາລະ",
            CLOSE: "ປິດແລ້ວ",
            IN_SERVICE: "ກໍາລັງໃຫ້ບໍລິການ",
            PAYMENT_FAILED: "ການຈ່າຍເງິນລົ້ມເຫຼວ",
            CONFIRM: "ຍືນຢັນແລ້ວ",
            AWAIT_FULLY_PAYMENT: "ຈ່າຍບາງສ່ວນ",
            VOID: "ຍົກເລີກໂດຍໂຮງແຮມ",
            STATUS_WAIT_FEEDBACK: "ລໍຖ້າຄໍາຕິຊົມ",
            STATUS_FEEDBACK: "ຄໍາຕິຊົມ",
            STATUS_COMPLETE: "ສໍາເລັດແລ້ວ",
            STATUS_CANCEL: "ຍົກເລີກແລ້ວ"
        },
        SEARCH_PMS_STATUS: "ສະຖານະການຊິງ",
        SEARCH_PMS_CODE: "ປະເພດ PMS",
        CHECKIN_STATUS: "ສະຖານະເຂົ້າພັກ",
        AGENT: "ຕົວແທນ",
        MARKET: "ກຸ່ມຕະຫຼາດ",
        PDF: "ສົ່ງອອກເປັນ PDF",
        UNMAP_BOOKING: {
            UNMAP_BOOKING_TITLE: "Mapping status",
            ALL: "All",
            MAPPED: "Mapped",
            UNMAP_ROOM_TYPE: "Unmapped room",
            UNMAP_RATE_PLAN: "Unmapped rate",
            UNMAP_ROOMRATE: "Unmapped room_rate",
        }
    },
    _BOOKING_DETAIL: {
        TITLE: "ລາຍລະອຽດການຈອງ",
        CONTACT: {
            TITLE: "ຂໍ້ມູນຕິດຕໍ່",
            NAME: "ຊື່ແຂກ",
            PHONE: "ເບີໂທລະສັບ",
            EMAIL: "ອີເມວ",
            GROUP_NAME_TOUR: "ຊື່ກຸ່ມ",
            AGENT_NAME: "ຕົວແທນ"
        },
        BOOKING_DETAIL: {
            TITLE: "ຂໍ້ມູນການຈອງ",
            CODE: "ລະຫັດການຈອງ",
            OTACODE: "ລະຫັດການຈອງ OTA",
            STATUS: "ສະຖານະການຈອງ",
            CREATED: "ວັນທີຈອງ",
            CHECK_IN: "ວັນເຂົ້າພັກ",
            CHECK_OUT: "ວັນອອກ",
            UPDATED: "ວັນທີປັບປຸງ",
            NOTE: "ໝາຍເຫດ"
        },
        ROOM: {
            TITLE: "ລາຍລະອຽດຫ້ອງ -",
            APPLY_DATE: "ວັນທີ",
            NAME: "ແພັກແກັດລາຄາ",
            UNIT_PRICE: "ລາຄາ / ຄືນ (VND)",
            QUANTITY: "ຈໍານວນຫ້ອງ",
            ADULTS: "ຜູ້ໃຫຍ່",
            CHILDREN: "ເດັກນ້ອຍ",
            BABY: "ທາລົກ",
            TOTAL: "ລວມເງິນ (VND)"
        },
        PROMOTION_ONEI: {
            TITLE: "ໂປຣໂມຊັ່ນ One Inventory",
            NAME: "ຊື່ໂປຣໂມຊັ່ນ",
            COST_TYPE: "ປະເພດຄ່າໃຊ້ຈ່າຍ",
            TOTAL: "ລວມເງິນ (VND)"
        },
        PROMOTION: {
            TITLE: "ໂປຣໂມຊັ່ນ",
            NAME: "ຊື່ໂປຣໂມຊັ່ນ",
            ROOM_PLAN_NAME: "ແພັກແກັດລາຄາ",
            ROOM_NAME: "ປະເພດຫ້ອງ",
            TOTAL: "ລວມເງິນ (VND)"
        },
        SERVICE: {
            TITLE: "ບໍລິການ",
            NAME: "ຊື່ບໍລິການ",
            DATE: "ວັນໃຊ້ບໍລິການ",
            COST: "ລາຄາ",
            COUNT: "ຈໍານວນ",
            TOTAL: "ລວມເງິນ (VND)"
        },
        PAYMENT_LOG: {
            TITLE: "ປະຫວັດການຈ່າຍເງິນ",
            METHOD: "ວິທີຈ່າຍ",
            AMOUNT: "ຈໍານວນເງິນ",
            TRANS_NO: "ລະຫັດທຳການ",
            TRANS_DATE: "ວັນທຳການ",
            RES_CODE: "ຜົນການທຳການ",
            RES_MSG: "ໝາຍເຫດ"
        },
        METHOD_NAME: {
            ONEPAY_DOM: "ຈ່າຍຜ່ານ Onepay ໃນປະເທດ",
            ONEPAY_INTER: "ຈ່າຍຜ່ານ Onepay ລະດັບສາກົນ",
            VNPAY: "ຈ່າຍຜ່ານ Vnpay",
            TRANSFER: "ໂອນເງິນ",
            CASH: "ຈ່າຍເງິນສົດ",
            VNPAY_QR: "ຈ່າຍຜ່ານ Vnpay QR",
            VIETTELPAY_QR: "ຈ່າຍຜ່ານ Viettelpay QR",
            VIETTELPAY: "ຈ່າຍຜ່ານ Viettelpay"
        },
        PAYMENT_CARD_DETAIL: "ລາຍລະອຽດບັດຈ່າຍເງິນ",
        SUB_TOTAL: "ຍອດລວມຍ່ອຍ",
        TOTAL: "ຍອດລວມທັງໝົດ",
        PAID: "ຈ່າຍແລ້ວ:",
        UNPAID: "ຍັງຄ້າງຈ່າຍ:",
        EXPORT: "ພິມໃບຈອງ",
        CANCEL: "ຍົກເລີກການຈອງ",
        NOTE: "ໝາຍເຫດ",
        CONFIRM_CANCEL: "ຢືນຢັນການຍົກເລີກການຈອງ?",
        CONFIRM_REASON: "ເຫດຜົນ (ຈໍາເປັນ)",
        CONFIRM: "ຢືນຢັນ",
        COMMISSION: "ຄ່ານາຍໜ້າ",
        BEFORE_COMMISSION: "ຈໍານວນສຸດທິທີ່ໄດ້ຮັບ",
        AFTER_COMMISSION: "ລາຄາລວມຄ່ານາຍໜ້າ",
        PAYMENT_COLLECT: "ເງິນທີ່ເກັບ",
        PROPERTY_COLLECT: "ເກັບໂດຍໂຮງແຮມ",
        OTA_CONTACT: "ຕິດຕໍ່ OTA",
        CHANNEL_COLLECT: "ເກັບໂດຍຊ່ອງທາງ"
    },
    _REQUEST_DETAIL: {
        TITLE: "ລາຍລະອຽດຄຳຂໍ",
        BUGET: "ງົບປະມານທີ່ຈ່າຍ",
        CONTACT: {
            TITLE: "ຂໍ້ມູນຜູ້ຕິດຕໍ່ການຈອງ",
            NAME: "ຊື່ແຂກ",
            PHONE: "ເບີໂທລະສັບ",
            EMAIL: "ອີເມວ",
            AGENT_NAME: "ຕົວແທນ",
            REQUESTER_NAME: "ຊື່ຜູ້ຮ້ອງຂໍ"
        },
        BOOKING_DETAIL: {
            TITLE: "ລາຍລະອຽດຄຳຂໍ",
            CODE: "ລະຫັດຄຳຂໍ",
            STATUS: "ສະຖານະຄຳຂໍ",
            CREATED: "ວັນທີຮ້ອງຂໍ",
            CHECK_IN: "ວັນເຂົ້າພັກ",
            CHECK_OUT: "ວັນອອກ",
            UPDATED: "ວັນປັບປຸງ"
        },
        ROOM: {
            TITLE: "ລາຍລະອຽດຫ້ອງ",
            APPLY_DATE: "ວັນທີ",
            NAME: "ແພັກແກັດລາຄາ",
            UNIT_PRICE: "ລາຄາ / ຄືນ (VND)",
            QUANTITY: "ຈໍານວນຫ້ອງ",
            ADULTS: "ຜູ້ໃຫຍ່",
            CHILDREN: "ເດັກນ້ອຍ",
            TOTAL: "ລວມເງິນ (VND)"
        },
        NOTE: "ໝາຍເຫດ",
        SEND_REQUEST: "ສົ່ງຂໍ້ຄວາມກັບ"
    },

    _BOOKING_TRANSACTION: {
        TITLE: "ທຸລະກຳລາຍຮັບ-ຈ່າຍ",
        ALL: "ທັງໝົດ",
        BOOKING: "ຈອງຫ້ອງ",
        BOOKING_DATE: "ວັນທີຈອງ",
        BOOKING_CODE: "ລະຫັດການຈອງ",
        AGENT_NAME: "ຕົວແທນ",
        TIME_STAY: "ວັນທີພັກ",
        AMOUNT: "ຍອດເງິນທັງໝົດ",
        PAYMENT_DATE: "ວັນທີຈ່າຍເງິນ",
        BOOKING_STATUS: "ສະຖານະການຈອງ",
        ACTION: "ການດຳເນີນການ",
        EXPORT: "ສົ່ງອອກ Excel",
        SEARCH: "ຄົ້ນຫາ",
        CONFIRM: "ຢືນຢັນ",
        TIME_STAY_TEXT: "{day} ມື້ {night} ຄືນ",
        SEARCH_CONDITION: "ຄົ້ນຫາຕາມ",
        SEARCH_BOOKING_CODE: "ໃສ່ລະຫັດ",
        SEARCH_DATE: "ຊ່ວງວັນທີ",
        SEARCH_BY: {
            BOOKING_CODE: "ລະຫັດການຈອງ",
            BOOKING_DATE: "ວັນທີຈອງ",
            CHECKIN_DATE: "ວັນເຂົ້າພັກ",
            CHECKOUT_DATE: "ວັນອອກ"
        },
        STATUS: {
            CANCEL: "ລູກຄ້າຍົກເລີກ",
            AWAIT_PAYMENT: "ລໍຖ້າການຈ່າຍເງິນ",
            CLOSE: "ປິດແລ້ວ",
            IN_SERVICE: "ກຳລັງໃຫ້ບໍລິການ",
            PAYMENT_FAILED: "ຈ່າຍເງິນບໍ່ສຳເລັດ",
            CONFIRM: "ຢືນຢັນແລ້ວ",
            AWAIT_FULLY_PAYMENT: "ຈ່າຍບາງສ່ວນ",
            VOID: "ໂຮງແຮມຍົກເລີກ"
        }
    },

    _BOOKING_TRANSACTION_DETAIL: {
        TITLE: "ລາຍລະອຽດທຸລະກຳ",
        DETAIL: "ລາຍລະອຽດທຸລະກຳ",
        BOOKING_CODE: "ລະຫັດການຈອງ:",
        PAYMENT_METHOD: "ວິທີຈ່າຍເງິນ",
        TRANSACTION_CODE: "ລະຫັດທຳການ",
        TRANSACTION_DATE: "ວັນທຳການ",
        AMOUNT: "ຈໍານວນເງິນ",
        NOTE: "ໝາຍເຫດ",
        BANK_TRANSFER: "ໂອນເງິນຜ່ານທະນາຄານ",
        CASH: "ເງິນສົດ",
        DEBT: "ຍັງຄ້າງຈ່າຍ"
    },

    // END

    // Sale room plan
    _ROOM_PLAN: {
        TITLE: "ຫ້ອງແລະແພັກແກັດລາຄາ",
        BATCH_UPDATE: "ອັບເດດພ້ອມກັນຫຼາຍລາຍການ",
        ALL_ROOM: "ທຸກຫ້ອງ",
        STOP_SELL: "ຢຸດຂາຍ",
        MIN_STAY: "ຂັ້ນຕ່ຳຄືນພັກ",
        MAX_STAY: "ຂັ້ນສູງຄືນພັກ",
        CTA: "ບໍ່ອະນຸຍາດໃຫ້ເຂົ້າພັກ",
        CTD: "ບໍ່ອະນຸຍາດໃຫ້ອອກ",
        CURRENT_MONTH: "{month}/{year}",
        CONFIRM_CHANGE_PAGE: "ຂໍ້ມູນທີ່ບໍ່ບັນທຶກຈະຖືກລຶບ\nທ່ານຕ້ອງການສືບຕໍ່ບໍ?",
        MIN_SMALLER_THAN_ONE: "ຈຳນວນຄືນພັກຂັ້ນຕ່ຳຕ້ອງຫຼາຍກວ່າ 1",
        MAX_SMALLER_THAN_ONE: "ຈຳນວນຄືນພັກຂັ້ນສູງຕ້ອງຫຼາຍກວ່າ 1",
        MIN_BIGGER_THAN_MAX: "ຄືນພັກຂັ້ນຕ່ຳຫຼາຍກວ່າຂັ້ນສູງ",
        MIN_SMALLER_THAN_CONFIG: "ຄືນພັກຂັ້ນຕ່ຳນ້ອຍກວ່າຄ່າກຳນົດ",
        MAX_BIGGER_THAN_CONFIG: "ຄືນພັກຂັ້ນສູງເກີນກ່ອນຄ່າກຳນົດ"
    },

    SALE_PACKAGE: "ແພັກແກັດລາຄາ",

    _HOTEL_CHAIN: {
        CHAIN_LIST_HOTEL: "ໂຮງແຮມ",
        TITLE: "ໂຮງແຮມໃນເຄືອຂ່າຍ",
        CHAIN_NAME: "ຊື່ເຄືອຂ່າຍ",
        CHAIN_LIST: "ລາຍການໂຮງແຮມ ({total})",
        HOTEL_ID: "ລະຫັດໂຮງແຮມ: ",
        ADD_HOTEL: "ເພີ່ມໂຮງແຮມ",
        LOGIN_TEXT: "ການປ່ຽນໂຮງແຮມ ກະລຸນາໃຊ້ບັນຊີເຈົ້າຂອງໂຮງແຮມ",
        LOGIN_EXISTED_TEXT: "ເຂົ້າລະບົບດ້ວຍບັນຊີ {hotelName}:",
        USERNAME: "ຊື່ຜູ້ໃຊ້",
        PASSWORD: "ລະຫັດຜ່ານ",
        CONFIRM: "ຢືນຢັນ",
        REMOVE_HOTEL: "ຢືນຢັນລຶບໂຮງແຮມນີ້ອອກຈາກເຄືອຂ່າຍບໍ?",
        LOGIN: "ເຂົ້າລະບົບ",
        DELETE_HOTEL: "ລຶບອອກຈາກເຄືອຂ່າຍ",
        LABEL_SEARCH_CODE_NAME: "ລະຫັດ/ຊື່ໂຮງແຮມ",
        ENTER_HOTEL_NAME_OR_CODE: "ໃສ່ຊື່ໂຮງແຮມ ຫຼື ລະຫັດໂຮງແຮມ",
        CHAIN_LIST_BOOKING: "ການຈອງ",
        STATUS: "ສະຖານະ",
        SEARCH: "ຄົ້ນຫາ"
    },

    _ACCOUNT_SETTING: {
        TITLE: "ການຕັ້ງຄ່າບັນຊີສ່ວນຕົວ",
        AVATAR: "ຮູບໂປຣໄຟລ໌",
        USER_INFO: "ຂໍ້ມູນສ່ວນຕົວ",
        CHANGE_PASSWORD: "ປ່ຽນລະຫັດຜ່ານ",
        USERNAME: "ຊື່ຜູ້ໃຊ້",
        FULLNAME: "ຊື່ເຕັມ",
        PASSWORD: "ລະຫັດຜ່ານ",
        PASSWORD_REPEAT: "ຢືນຢັນລະຫັດຜ່ານ",
        GENDER: "ເພດ",
        GENDER_MALE: "ຊາຍ",
        GENDER_FEMALE: "ຍິງ",
        EMAIL: "ອີເມວ",
        PHONE_NUMBER: "ເບີໂທລະສັບ",
        ADDRESS: "ທີ່ຢູ່",
        POSITION: "ຕຳແໜ່ງ",
        GROUP: "ກຸ່ມຜູ້ໃຊ້",
        CURRENT_PASS: "ລະຫັດຜ່ານປະຈຸບັນ",
        NEW_PASS: "ລະຫັດຜ່ານໃໝ່",
        NEW_PASS_REPEAT: "ຢືນຢັນລະຫັດໃໝ່",

        ERROR_PHONE_NUMBER_MIN: "ເບີໂທຕ້ອງຢ່າງໜ້ອຍ 8 ຕົວອັກສອນ",
        ERROR_PASSWORD_MIN: "ລະຫັດຜ່ານຕ້ອງຢ່າງໜ້ອຍ 8 ຕົວອັກສອນ",
        ERROR_RETYPE_PASSWORD_MIN: "ຢືນຢັນລະຫັດຕ້ອງ 8 ຕົວອັກສອນຂື້ນໄປ",
        ERROR_PASSWORD_INVALID: "ລະຫັດປະຈຸບັນບໍ່ຖືກຕ້ອງ",
        ERROR_PASSWORD_NOT_MATCH: "ລະຫັດຜ່ານບໍ່ກົງກັນ",
        MESSAGE_PASSWORD_MATCHED: "ລະຫັດກົງກັນ",
        MESSAGE_PASSWORD_NOT_MATCHED: "ລະຫັດບໍ່ກົງກັນ"
    },

    _LIST_USER: {
        TITLE: "ການຈັດການຜູ້ໃຊ້",
        LIST_USER: "ລາຍການຜູ້ໃຊ້",
        USER: "ຜູ້ໃຊ້",
        SEARCH_PLACEHOLDER: "ຄົ້ນຫາດ້ວຍຊື່ຜູ້ໃຊ້, ຊື່ເຕັມ ຫຼື ອີເມວ",
        GROUP_NAME: "ຊື່ກຸ່ມ",
        USERNAME: "ຊື່ຜູ້ໃຊ້",
        NAME: "ຊື່ເຕັມ",
        EMAIL: "ອີເມວ",
        CREATE_USER: "ສ້າງໂດຍ",
        CREATE_DATE: "ວັນທີສ້າງ",
        STATUS: "ສະຖານະ",
        ACTION: "ຈັດການ",
        STATUS_ACTIVATE: "ໃຊ້ງານ",
        STATUS_DEACTIVATE: "ປິດການໃຊ້ງານ",
        REMOVE: "ຢືນຢັນການລຶບຜູ້ໃຊ້ນີ້ບໍ?",
        CANNOT_DELETE_CURRENT_USER: "ບໍ່ສາມາດລຶບບັນຊີທີ່ກຳລັງໃຊ້ຢູ່ໄດ້"
    },
    // Quản lý nhóm người dùng - danh sách
    _LIST_GROUP: {
        TITLE: "ການຈັດການກຸ່ມຜູ້ໃຊ້",
        LIST_GROUP: "ກຸ່ມຜູ້ໃຊ້",
        GROUP: "ກຸ່ມຜູ້ໃຊ້",
        SEARCH_PLACEHOLDER: "ຄົ້ນຫາດ້ວຍຊື່ກຸ່ມຜູ້ໃຊ້",
        GROUP_NAME: "ຊື່ກຸ່ມ",
        CREATE_USER: "ສ້າງໂດຍ",
        CREATE_DATE: "ວັນທີສ້າງ",
        STATUS: "ສະຖານະ",
        ACTION: "ຈັດການ",
        STATUS_ACTIVATE: "ໃຊ້ງານ",
        STATUS_DEACTIVATE: "ປິດການໃຊ້ງານ",
        DESCRIPTION: "ຂໍ້ມູນຄຳອະທິບາຍ",
        REMOVE: "ຢືນຢັນການລຶບກຸ່ມນີ້ບໍ?"
    },

    _EDIT_USER: {
        TITLE: "ຂໍ້ມູນຜູ້ໃຊ້",
        INFO: "ຂໍ້ມູນຜູ້ໃຊ້",
        USER: "ຜູ້ໃຊ້",
        ROLE: "ສິດໃນການເຂົ້າເຖິງ",
        USERNAME: "ຊື່ຜູ້ໃຊ້",
        FULLNAME: "ຊື່ເຕັມ",
        PASSWORD: "ລະຫັດຜ່ານ",
        PASSWORD_REPEAT: "ຢືນຢັນລະຫັດຜ່ານ",
        GENDER: "ເພດ",
        GENDER_MALE: "ຊາຍ",
        GENDER_FEMALE: "ຍິງ",
        EMAIL: "ອີເມວ",
        PHONE_NUMBER: "ເບີໂທລະສັບ",
        ADDRESS: "ທີ່ຢູ່",
        POSITION: "ຕຳແໜ່ງ",
        GROUP: "ກຸ່ມຜູ້ໃຊ້",
        GROUP_PLACEHOLDER: "ຄົ້ນຫາ",
        HOTEL_OWNER: "ເຈົ້າຂອງໂຮງແຮມ",
        STATUS: "ສະຖານະ ເປີດ/ປິດ",
        N_O: "ລຳດັບ",
        FUNCTION_CODE: "ລະຫັດຟັງຊັນ",
        FUNCTION_NAME: "ຊື່ຟັງຊັນ",
        ACTION: "ຈັດການ",
        ERROR_PHONE_NUMBER_MIN: "ເບີໂທຕ້ອງຢ່າງໜ້ອຍ 8 ຕົວອັກສອນ",
        ERROR_PASSWORD_MIN: "ລະຫັດຜ່ານຕ້ອງຢ່າງໜ້ອຍ 8 ຕົວອັກສອນ",
        ERROR_RETYPE_PASSWORD_MIN: "ຢືນຢັນລະຫັດຕ້ອງ 8 ຕົວອັກສອນຂື້ນໄປ",
        ERROR_PASSWORD_NOT_MATCH: "ລະຫັດຜ່ານບໍ່ກົງກັນ",
        CHAIN: "ເຄືອຂ່າຍ",
        HOTEL: "ໂຮງແຮມ"
    },

    _EDIT_GROUP: {
        TITLE: "ຂໍ້ມູນກຸ່ມຜູ້ໃຊ້",
        INFO: "ຂໍ້ມູນກຸ່ມຜູ້ໃຊ້",
        GROUP: "ກຸ່ມຜູ້ໃຊ້",
        ROLE: "ສິດໃນການເຂົ້າເຖິງ",
        GROUP_NAME: "ຊື່ກຸ່ມ",
        GROUP_CODE: "ລະຫັດກຸ່ມ",
        GROUP_ROLE: "ບົດບາດຂອງກຸ່ມ",
        PARENT_GROUP: "ກຸ່ມແມ່",
        TYPE: "ປະເພດກຸ່ມ",
        DESCRIPTION: "ຂໍ້ມູນຄຳອະທິບາຍ",
        STATUS: "ສະຖານະ ເປີດ/ປິດ",
        NO: "ລຳດັບ",
        FUNCTION_CODE: "ລະຫັດຟັງຊັນ",
        FUNCTION_NAME: "ຊື່ຟັງຊັນ",
        ACTION: "ຈັດການ",
        ERROR_MIN_ROLE_SELECTED: "ກະລຸນາເລືອກຢ່າງໜ້ອຍ 1 ຟັງຊັນ"
    },

    _CONTRACT: {
        TITLE: "ສັນຍາອິເລັກໂທຣນິກ",
        CONTRACT_INFO: "ຂໍ້ມູນຕາມກົດໝາຍ",
        BUSINESS_NAME: "ຊື່ບໍລິສັດ",
        BUSINESS_NAME_NOTE: " (ໃສ່ຕາມໃບທະບຽນທຸລະກິດ, ພິມຕົວໃຫຍ່)",
        TAX_CODE: "ເລກລະຫັດພາສີ",
        TAX_CODE_NOTE: " (ໃສ່ໃຫ້ຖືກຕ້ອງ ແລະ ໃຫ້ຄົບຖ້ວນ)",
        ADDRESS: "ທີ່ຢູ່ທະບຽນທຸລະກິດ",
        ADDRESS_NOTE: " (ໃສ່ຕາມໃບ GPKD)",
        BANK_ACCOUNT: "ເລກບັນຊີທະນາຄານ",
        BANK_ACCOUNT_OWNER: "ຊື່ເຈົ້າຂອງບັນຊີ",
        BANK: "ຊື່ທະນາຄານ",
        BANK_BRANCH: "ສາຂາທະນາຄານ",
        LEGAL_REPRESENTATIVE: "ຜູ້ແທນຕາມກົດໝາຍ",
        LEGAL_REPRESENTATIVE_NOTE: " (ໃສ່ຕາມໃບ GPKD)",
        PIC: "ຜູ້ເຊັນສັນຍາ",
        PIC_POSITION: "ຕຳແໜ່ງຂອງຜູ້ເຊັນ",
        COMMISSION: "ຄ່ານາຍໜ້າ (%)",
        STATUS: "ສະຖານະສັນຍາ",
        VIEW: "ເບິ່ງ",
        _STATUS: {
            CREATE: "ສ້າງ",
            AM_SENT: "AM ສົ່ງ",
            SM_ACCEPT: "SM ອະນຸມັດ",
            SM_REJECT: "SM ປະຕິເສດ",
            CM_ACCEPT: "CM ອະນຸມັດ",
            CM_REJECT: "CM ປະຕິເສດ",
            PUBLISH: "ເຜີຍແຜ່",
            WAIT_SIGN: "ລໍຖ້າເຊັນ",
            COMPLETE: "ສຳເລັດ",
            SIGNED: "ເຊັນແລ້ວ",
            DISPUTED: "ຂັດແຍ້ງ",
            LIQUIDFY: "ຊຳລະບັນຊີ",
            CLOSE: "ປິດ",
            EXTEND: "ຂະຫຍາຍ"
        }
    },
    // END
    // Danh sách đại lý hợp tác
    _TRAVEL_AGENT: {
        TITLE: "ລາຍຊື່ບໍລິສັດທ່ອງທ່ຽວ",
        TITLE_DEACTIVE: "ລາຍຊື່ບໍລິສັດທີ່ຢຸດການຮ່ວມມື",
        AGENT: "ຕົວແທນ",
        SEARCH_PLACEHOLDER: "ຄົ້ນຫາຕາມຊື່ບໍລິສັດ",
        NAME: "ຊື່ບໍລິສັດ",
        BUSINESS_TYPE: "ປະເພດທຸລະກິດ",
        TAX_CODE: "ລະຫັດພາສີ",
        LEVEL: "ລະດັບຕົວແທນ",
        STATUS: "ສະຖານະ",
        DEACTIVE: "ຢຸດຮ່ວມມື",
        ACTIVE: "ກັບມາຮ່ວມມື",
        LEVEL_1: "ລະດັບ 1",
        LEVEL_2: "ລະດັບ 2",
        LEVEL_3: "ລະດັບ 3",
        LEVEL_4: "ລະດັບ 4",
        LEVEL_5: "ລະດັບ 5",
        CONFIRM_CHANGE_LEVEL: "ຢືນຢັນການປ່ຽນລະດັບຫຼືບໍ?",
        CONFIRM_ACTIVE: "ຢືນຢັນການຮ່ວມມືກັບຕົວແທນ?",
        CONFIRM_DEACTIVE: "ຢືນຢັນການຢຸດຮ່ວມມືກັບຕົວແທນ?",
        CONFIRM_REASON: "ເຫດຜົນ (ຈຳເປັນ)",
        CONFIRM: "ຢືນຢັນ"
    },
    // END
    _VALIDATE: {
        REQUIRED: "ກະລຸນາປ້ອນຂໍ້ມູນທັງໝົດ",
        EMAIL_FORMAT: "ກະລຸນາກວດຮູບແບບອີເມວຂອງທ່ານ",
        MIN_LENGTH: "ຄ່າທີ່ປ້ອນຕ້ອງມີຫຼາຍກວ່າ {minLength} ຕົວອັກສອນ",
        MAX_LENGTH: "ຄ່າທີ່ປ້ອນຕ້ອງນ້ອຍກວ່າ {maxLength} ຕົວອັກສອນ",
        REQUIRED_AT_LEAST_ONE_HOTEL_OR_CHAIN: "ກະລຸນາເລືອກຢ່າງໜ້ອຍ 1 ໂຮງແຮມ ຫຼື ເຊົ່າໂຮງແຮມ"
    },
    /* beautify preserve:start */
    _ROLES: {
        CHAIN: "ເມນູໂຮງແຮມເຊົ່າ",
        BOOKING_CHAIN: "ການຈອງໂຮງແຮມໃນເຊົ່າແລະໂຮງແຮມດຽວ",
        CHAIN_LIST: "ລາຍຊື່ໂຮງແຮມໃນເຊົ່າ",
        USER_MANAGEMENT: "ການຈັດການຜູ້ໃຊ້",
        // USER_GROUP: "USER_GROUP",
        DASHBOARD: "ແຜງຄວບຄຸມ",
        MANAGE: "ການຄວບຄຸມ",
        BOOKING_HOTEL: "ການຈອງໂຮງແຮມດຽວ",
        ROOM_SALE: "ຂາຍຫ້ອງພັກ",
        ROOM_SALE_MANAGEMENT: "ຈັດການການຂາຍຫ້ອງພັກ",
        SALE_PACKAGE_MANAGEMENT: "ຈັດການແພັກແກັດລາຄາ",
        OTA_MANAGEMENT: "ezCms Vela",
        SETTING: "ການຕັ້ງຄ່າ",
        ACCOUNT_INFOMATION: "ການຕັ້ງຄ່າບັນຊີ",
        PERSONAL_ACCOUNT: "ຂໍ້ມູນບັນຊີສ່ວນຕົວ",
        GENERAL_INFORMATION: "ຂໍ້ມູນທົ່ວໄປ",
        HOTEL_AMENITY: "ສິ່ງອໍານວຍຄວາມສະດວກໂຮງແຮມ",
        HOTEL_IMAGE: "ຮູບພາບໂຮງແຮມ",
        NEARBY_PLACE: "ສະຖານທີ່ໃກ້ຄຽງ",
        ROOM_TYPE: "ປະເພດຫ້ອງ",
        ROOM_INFORMATION: "ຂໍ້ມູນຫ້ອງ",
        ROOM_AMENITY: "ສິ່ງອໍານວຍຄວາມສະດວກໃນຫ້ອງ",
        ROOM_IMAGE: "ຮູບພາບຫ້ອງ",
        HOTEL_CONFIGURATION: "ການຕັ້ງຄ່າໂຮງແຮມ",
        GENERAL_CONFIGURATION: "ການຕັ້ງຄ່າທົ່ວໄປ",
        PAYMENT_POLICY: "ນະໂຍບາຍການຊໍາລະເງິນ",
        CANCELLATION_POLICY: "ນະໂຍບາຍຍົກເລີກ",
        IMAGE_LIBRARY: "ຄັງຮູບພາບ",
        HISTORY_LOG: "ປະຫວັດການທໍາວຽກ",
        PAYMENT_METHOD: "ວິທີຈ່າຍເງິນ",
        BOOKING_ENGINE: "ເຄື່ອງຈອງຫ້ອງ",
        BOOKING_ENGINE_CONFIG: "ການຕັ້ງຄ່າ",
        HOTEL_EMAIL: "ອີເມວໂຮງແຮມ",
        HOTEL_BOOKING_CONFIRM: "ການຈອງທີ່ຍືນຢັນ",
        HOTEL_SERVICE: "ບໍລິການ",
        HOTEL_PROMOTION: "ໂປຣໂມຊັ່ນ",
        HOTEL_INFORMATION: "ຂໍ້ມູນໂຮງແຮມ",
        BOOKING_MANAGEMENT: "ການຈັດການການຈອງ",
        SYNC_MANAGEMENT: "ການຊິງຊ໌ຊ່ອງທາງຂາຍ",
        HEADER_FOOTER: "ແບບແມ່ແບບ",
        SU_MANAGEMENT: "ezCms Leo",
        SU_CONNECTION: "ຊ່ອງທາງຂາຍ",
        SU_MAPPING: "ການແມບຂໍ້ມູນ",
        HOTEL_BOOKING_REPOST: "ໂພສຕື່ນການຈອງ",
        CHAIN_SERVICE: "ບໍລິການເຊົ່າ",
        CHAIN_ROOM_TYPE: "ຂໍ້ມູນປະເພດຫ້ອງເຊົ່າ",
        CHAIN_RATE_PLAN: "ແພັກແກັດຂາຍຫ້ອງເຊົ່າ",
        CHAIN_TRAVEL_AGENT: "ຂໍ້ມູນບໍລິສັດແລະຕົວແທນ",
        HOTEL_TRAVEL_AGENT: "ຂໍ້ມູນບໍລິສັດແລະຕົວແທນ",
        SITEMINDER_MANAGEMENT: "ezCms SiteMinder",
        GDS_MANAGEMENT: "ezCms GDS",
        RMS_MANAGEMENT: "ການຈັດການລາຍໄດ້",
        DYNAMIC_PRICING: "ລາຄາແບບໄດ້ປ່ຽນແປງ",
        MASTER_RATE: "ລາຄາຫຼັກ",
        PACKAGE_MANAGEMENT: "ຈັດການແພັກແກັດ",
        PACKAGE_ITEM: "ລາຍການແພັກແກັດ",
        PACKAGE_DEAL: "ໂປຣໂມຊັ່ນແພັກແກັດ",
        BE_MANAGEMENT: "ezBe",
        HOTEL_BOOKING_GROUP: "ການຈອງແບບກຸ່ມ",
        BOOKING_UNMAP_HOTEL: "ການຈອງທີ່ບໍ່ແມບໂຮງແຮມ",
        HOTEL_DASHBOARD_IGNORE_TASK: "ຂ້າມວຽກ",
        HOTEL_DASHBOARD_REUPDATE_TASK: "ປັບປຸງວຽກໃໝ່",
        HOTEL_BOOKING_UNMAP_REPOST: "ໂພສການຈອງທີ່ບໍ່ແມບ",
        CHAIN_ROOM_UPDATE_QUANTITY: "ປັບປຸງຈໍານວນຫ້ອງ",
        HOTEL_DASHBOARD: "ແຜງຄວບຄຸມໂຮງແຮມ",
        ROOM_UPDATE_QUANTITY: "ປັບປຸງຈໍານວນຫ້ອງ",
        DYNAMIC_RESTRICTION: "ຂໍ້ຈໍາກັດແບບໄດ້ປ່ຽນແປງ",
        DYNAMIC_ROOM_SALE: "ການຂາຍຫ້ອງແບບໄດ້ປ່ຽນແປງ",
        DYNAMIC_CONFIGURATION: "ການຕັ້ງຄ່າແບບໄດ້ປ່ຽນແປງ",
        CHAIN_BOOKING_REPOST: "ໂພສການຈອງໃນເຊົ່າ",
        INVENTORY: "ຄັງສິນຄ້າ",
        RATE: "ລາຄາ",
        RESTRICTION: "ຂໍ້ຈໍາກັດ",
        STOP_SELL_LIMIT: "ຈໍາກັດການຂາຍ",
        CHANNEX_MANAGEMENT: "ezCms Vela+",
        CHANNEX_CONNECTION: "ຊ່ອງທາງຂາຍ",
        CHANNEX_MAPPING: "ການແມບຂໍ້ມູນ",
        WARNING_METHOD: "ວິທີແຈ້ງເຕືອນ",
        STAAH_MANAGEMENT : "ezCms StaahMax",
        STAAH_MAPPING: "ການຈັບຄູ່",
        STAAH_CONNECTION: "ຊ່ອງທາງການຂາຍ",
    },
    /* beautify preserve:stop */
    _LEFT_MENU: {
        COPY_RIGHT: "Copyright © 2021 ezCloud ສິດທິທັງໝົດຖືກຮັກສາ"
    },
    _ACTIVITY: {
        ACTION_DATE: "ວັນທີປະຕິບັດ",
        ACTION_BY: "ຜູ້ປະຕິບັດ",
        APPLY_DATE: "ວັນທີນໍາໃຊ້",
        CREATED_DATE: "ວັນທີສ້າງ",
        ROOM_NAME: "ຊື່ຫ້ອງ",
        RATE: "ລາຄາ",
        CREATE_DATE: "ວັນທີສ້າງ",
        SEARCH_DATE: "ວັນທີນໍາໃຊ້",
        USER_NAME: "ບັນຊີ",
        ROOM: "ຫ້ອງ",
        ROOM_PLAN: "ແພັກແກັດລາຄາ",
        YES: "ແມ່ນ",
        NO: "ບໍ່",
        STOPSELL: "ຢຸດຂາຍ",
        MINSTAY: "ພັກຂັ້ນຕ່ໍາ",
        CLOSEDTOARRIVE: "ປິດຮັບການເຂົ້າພັກ",
        MAXSTAY: "ພັກຂັ້ນສູງ",
        CLOSEDTODEPATURE: "ປິດການອອກຈາກ",
        IPADDRESS: "ທີ່ຢູ່ IP",
        CREATEDBY: "ສ້າງໂດຍ",
        PAGING: "ໜ້າ",
        DOCUMENT: "ບັນທຶກ",
        ROOMAVAIL: "ຄັງຫ້ອງ",
        ALLSELECT: "ທັງໝົດ",
        HOTELID: "ID ໂຮງແຮມ",
        HOTELNAME: "ຊື່ໂຮງແຮມ",
        DATABEFORE: "ຂໍ້ມູນກ່ອນໜ້າ",
        DATAAFTER: "ຂໍ້ມູນຫຼັງຈາກນັ້ນ",
        ACTION: "ການປະຕິບັດ",
        HOTEL_LOGIN: "ເຂົ້າລະບົບ",
        HOTEL_CANCEL_BOOKING: "ຍົກເລີກການຈອງ",
        HOTEL_UPDATE_PAYMENT_BOOKING: "ຢືນຢັນການຈອງ",
        HOTEL_REQUEST_BOOKING: "ການຂໍຈອງທີ່ຖືກຢືນຢັນ",
        HOTEL_ROOM_PLAN_CREATE: "ສ້າງແພັກແກັດລາຄາໃໝ່",
        HOTEL_ROOM_PLAN_UPDATE: "ຂໍ້ມູນແພັກແກັດລາຄາ",
        HOTEL_ROOM_PLAN_COPY: "ຄັດລອກແພັກແກັດ",
        HOTEL_ROOM_PLAN_DELETE: "ລຶບແພັກແກັດ",
        HOTEL_PROMOTION_CREATE: "ສ້າງໂປຣໂມຊັ່ນໃໝ່",
        HOTEL_PROMOTION_UPDATE: "ຂໍ້ມູນໂປຣໂມຊັ່ນ",
        HOTEL_PROMOTION_COPY: "ຄັດລອກໂປຣໂມຊັ່ນ",
        HOTEL_PROMOTION_DELETE: "ລຶບໂປຣໂມຊັ່ນ",
        HOTEL_PROFILE_UPDATE: "ອັບເດດໂປຣໄຟລ໌",
        HOTEL_AVATAR_ADD: "ເພີ່ມຮູບປະຈໍາຕົວ",
        HOTEL_AVATAR_REMOVE: "ລຶບຮູບປະຈໍາຕົວ",
        HOTEL_CHANGE_PASSWORD_PROFILE: "ປ່ຽນລະຫັດຜ່ານ",
        HOTEL_USER_CREATE: "ສ້າງຜູ້ໃຊ້",
        HOTEL_USER_UPDATE: "ອັບເດດຜູ້ໃຊ້",
        HOTEL_USER_UPDATE_ROLE: "ອັບເດດສິດທິຜູ້ໃຊ້",
        HOTEL_USER_DELETE: "ລຶບຜູ້ໃຊ້",
        HOTEL_GROUP_CREATE: "ສ້າງກຸ່ມຜູ້ໃຊ້",
        HOTEL_GROUP_UPDATE: "ອັບເດດກຸ່ມຜູ້ໃຊ້",
        HOTEL_GROUP_UPDATE_ROLE: "ອັບເດດສິດທິຂອງກຸ່ມ",
        HOTEL_GROUP_DELETE: "ລຶບກຸ່ມຜູ້ໃຊ້",
        HOTEL_CONTRACT_UPDATE: "ອັບເດດສັນຍາ",
        HOTEL_INFO_UPDATE: "ອັບເດດຂໍ້ມູນໂຮງແຮມ",
        HOTEL_UPDATE_AMENITIES: "ອັບເດດສິ່ງອໍານວຍຄວາມສະດວກ",
        HOTEL_UPDATE_IMAGES: "ເພີ່ມຮູບໃໝ່",
        HOTEL_DELETE_IMAGES: "ລຶບຮູບ",
        HOTEL_AREA_CREATED: "ສ້າງພື້ນທີ່ໃກ້ຄຽງ",
        HOTEL_AREA_UPDATED: "ອັບເດດພື້ນທີ່ໃກ້ຄຽງ",
        HOTEL_AREA_DELETED: "ລຶບພື້ນທີ່ໃກ້ຄຽງ",
        HOTEL_CHAIN_CREATED: "ສ້າງເຊົ່າໂຮງແຮມ",
        HOTEL_CHAIN_UPDATED: "ອັບເດດເຊົ່າໂຮງແຮມ",
        HOTEL_ROOM_CREATED: "ສ້າງຫ້ອງ",
        HOTEL_ROOM_UPDATED: "ອັບເດດຫ້ອງ",
        HOTEL_ROOM_COPY: "ຄັດລອກຫ້ອງ",
        HOTEL_ROOM_DELETED: "ລຶບຫ້ອງ",
        HOTEL_ROOM_AMENITY: "ອັບເດດສິ່ງອໍານວຍຄວາມສະດວກຂອງຫ້ອງ",
        HOTEL_ROOM_ADD_IMAGES: "ເພີ່ມຮູບພາບຂອງຫ້ອງ",
        HOTEL_ROOM_DELETE_IMAGES: "ລຶບຮູບຂອງຫ້ອງ",
        HOTEL_UPDATE_HOTEL_SETTING_INFO: "ອັບເດດການຕັ້ງຄ່າໂຮງແຮມ",
        HOTEL_PAYMENT_POLICY_CREATED: "ສ້າງນະໂຍບາຍການຈ່າຍເງິນ",
        HOTEL_PAYMENT_POLICY_UPDATED: "ອັບເດດນະໂຍບາຍການຈ່າຍເງິນ",
        HOTEL_PAYMENT_POLICY_DELETED: "ລຶບນະໂຍບາຍການຈ່າຍເງິນ",
        HOTEL_CANCEL_POLICY_CREATED: "ສ້າງນະໂຍບາຍການຍົກເລີກ",
        HOTEL_CANCEL_POLICY_UPDATED: "ອັບເດດນະໂຍບາຍການຍົກເລີກ",
        HOTEL_CANCEL_POLICY_DELETED: "ລຶບນະໂຍບາຍການຍົກເລີກ",
        HOTEL_SETTING_PAYMENT_GATE: "ຕັ້ງຄ່າປະຕູຈ່າຍເງິນ",
        HOTEL_ADD_IMAGES_SLIDE: "ເພີ່ມຮູບໃນສະໄລດ໌",
        HOTEL_DELETE_IMAGES_SLIDE: "ລຶບຮູບສະໄລດ໌",
        HOTEL_REMOVE_CONNECT_AGENT: "ຍົກເລີກເຊື່ອມຕໍ່ກັບຕົວແທນ",
        HOTEL_UPDATE_LEVEL_AGENT: "ປັບລະດັບການເຊື່ອມຕໍ່ຕົວແທນ",
        HOTEL_RETURN_CONNECT_AGENT: "ກັບຄືນການເຊື່ອມຕໍ່ກັບຕົວແທນ",
        PMS_CONFIRM: "ຢືນຢັນຈາກ PMS",
        RATE_CATEGORY_CREATE: "ສ້າງໝວດລາຄາໃໝ່",
        RATE_CATEGORY_UPDATE: "ລາຍລະອຽດໝວດລາຄາ",
        ROOM_CATEGORY_CREATE: "ສ້າງໝວດຫ້ອງໃໝ່",
        ROOM_CATEGORY_UPDATE: "ລາຍລະອຽດໝວດຫ້ອງ"
    },
    STATUS_CREATE_NEW: "ສ້າງໃໝ່",
    STATUS_DELIVERED: "ຈັດສົ່ງແລ້ວ",
    STATUS_SALE_SEND_HOTEL: "ສົ່ງໄປໂຮງແຮມ",
    STATUS_SALE_ADMIN_SEND_BACK: "ຜູ້ຈັດການຂາຍສົ່ງກັບ",
    STATUS_SALE_ADMIN_PASSED: "ຜູ້ຈັດການຂາຍອະນຸມັດ",
    STATUS_QC_SENT_BACK_HOTEL: "QC ສົ່ງກັບ",
    STATUS_QC_PASSED_HOTEL: "QC ອະນຸມັດ",
    STATUS_SALE_ADDITIONAL: "ສົ່ງຂໍ້ມູນເພີ່ມ",
    STATUS_QC_SENT_BACK_INFOR: "QC ສົ່ງຂໍ້ມູນກັບ",
    STATUS_QC_PASSED_INFOR: "QC ອະນຸມັດຂໍ້ມູນ",
    STATUS_ONSITE: "ໃນສະຖານທີ່",
    STATUS_OFFSITE: "ນອກສະຖານທີ່",

    STATUS_SIGNED: "ເຊັນແລ້ວ",
    STATUS_WAITING_SIGN: "ລໍຖ້າເຊັນ",
    STATUS_CLOSED: "ປິດແລ້ວ",
    STATUS_IN_DISPUTE: "ກໍ່ໃຄ່",
    STATUS_LIQUIDATED: "ປິດສັນຍາ",
    STATUS_COMPLETED: "ສຳເລັດແລ້ວ",
    STATUS_CM_PASSED: "CM ອະນຸມັດ",
    STATUS_CM_SEND_BACK: "CM ສົ່ງກັບ",
    STATUS_RELEASED: "ປ່ອຍອອກ",
    STATUS_RENEWAL: "ຕໍ່ສັນຍາ",
    STATUS_CHANGED: "ສະຖານະຖືກປ່ຽນເປັນ",
    STATUS_NEW_CREATE: "ສ້າງໃໝ່",

    STATUS_AWAIT_PAYMENT: "ລໍຖ້າການຈ່າຍເງິນ",
    STATUS_AWAIT_FULLY_PAYMENT: "ລໍຖ້າການຈ່າຍເຕັມ",
    STATUS_PAYMENT_FAILED: "ຈ່າຍເງິນບໍ່ສຳເລັດ",
    STATUS_CONFIRM: "ຢືນຢັນ",

    ALL: "ທັງໝົດ",
    CANCEL: "ລູກຄ້າຍົກເລີກ",
    AWAIT_PAYMENT: "ລໍຖ້າຈ່າຍເງິນ",
    IN_SERVICE: "ກຳລັງໃຫ້ບໍລິການ",
    PAYMENT_FAILED: "ຈ່າຍເງິນລົ້ມເຫຼວ",
    CONFIRM: "ຢືນຢັນແລ້ວ",
    AWAIT_FULLY_PAYMENT: "ຈ່າຍບາງສ່ວນ",
    VOID: "ໂຮງແຮມຍົກເລີກ",
    STATUS_WAIT_FEEDBACK: "ລໍຖ້າຄຳຕິຊົມ",
    STATUS_FEEDBACK: "ຄຳຕິຊົມ",
    STATUS_COMPLETE: "ສຳເລັດ",
    STATUS_CANCEL: "ຖືກຍົກເລີກ",
    BOOKING: "ການຈອງ",
    BOOKING_STATUS: "ສະຖານະຂອງການຈອງ",
    BOOKING_REQUEST_STATUS: "ສະຖານະຂອງຄຳຮ້ອງຂໍການຈອງ",
    CONTRACT_STATUS: "ສະຖານະສັນຍາ",
    TA_STATUS: "ສະຖານະຕົວແທນທ່ອງທ່ຽວ",
    HOTEL_STATUS: "ສະຖານະໂຮງແຮມ",
    SHOW_MORE: "ເບິ່ງເພີ່ມ",
    NOTIFICATION: "ແຈ້ງເຕືອນ",
    HAS_JUST_JOINED_ONEI: "ເພິ່ງເຂົ້າຮ່ວມ One Inventory",
    HAS_JUST_CREATED_ONEI: "ເພິ່ງສ້າງໃນ OneInventory.com",
    ANNEX_OF_CONTRACT: "ພະລະບົດເສີມຂອງສັນຍາເລກທີ",
    YOUR_AGENT: "ຕົວແທນຂອງທ່ານ",
    NOTIFICATIONS: "ຂ່າວສານແຈ້ງເຕືອນ",
    MARK_AS_READ: "ໝາຍເປັນອ່ານແລ້ວ",
    CONTACT_NUMBER: "ເລກທີສັນຍາ",
    HOTELS_CONTRACT: "ສັນຍາໂຮງແຮມ",
    AGENTS_CONTRACT: "ສັນຍາຕົວແທນ",
    ADDENDUM_OF_CONTRACT: "ເລກທີພະລະບົດເສີມ",
    EXTEND_CONTRACT: "ຂະຫຍາຍສັນຍາ",
    BELONG_HOTEL: "ຂອງໂຮງແຮມ",
    BELONG_AGENT: "ຂອງຕົວແທນ",
    AGENT: "ຕົວແທນ",
    NEW_TA: "ຕົວແທນໃໝ່",
    RE_RELEASE: "ປ່ອຍອອກຄືນ",
    AGO: "ທີ່ຜ່ານມາ",
    MONTHS: "ເດືອນ",
    YEARS: "ປີ",
    SECONDS: "ວິນາທີ",
    MINUTES: "ນາທີ",
    HOURS: "ຊົ່ວໂມງ",
    NOW: "ປັດຈຸບັນນີ້",
    DAYS: "ວັນ",
    REQUEST_EMPTY: "ຄຳຮ້ອງຂໍວ່າງເປົ່າ",
    STATUS_INCORRECT: "ສະຖານະບໍ່ຖືກຕ້ອງ",
    STATUS_CONTRACT_INCORRECT: "ສະຖານະສັນຍາບໍ່ຖືກຕ້ອງ",
    NO_NOTIFICATION: "ບໍ່ມີແຈ້ງເຕືອນໃໝ່",
    ADDENDUM_STATUS: "ສະຖານະພະລະບົດເສີມ",
    OVER_CHARACTER: "ທ່ານໃສ່ຕົວອັກສອນເກີນຈຳນວນທີ່ກຳນົດ",

    HOTEL_LOG_bookingCode: "ລະຫັດການຈອງ",
    HOTEL_LOG_agentName: "ຊື່ຕົວແທນ",
    HOTEL_LOG_customer: "ຊື່ລູກຄ້າ",
    HOTEL_LOG_createdDate: "ວັນທີສ້າງ",
    HOTEL_LOG_checkinDate: "ວັນເຂົ້າພັກ",
    HOTEL_LOG_checkoutDate: "ວັນອອກຈາກທີ່ພັກ",
    HOTEL_LOG_totalCost: "ຄ່າໃຊ້ຈ່າຍທັງໝົດ",
    HOTEL_LOG_payableAmount: "ຈຳນວນເງິນທີ່ຕ້ອງຈ່າຍ",
    HOTEL_LOG_bookingStatus: "ສະຖານະການຈອງ",
    HOTEL_LOG_active: "ໃຊ້ງານ",
    HOTEL_LOG_amount: "ຈຳນວນ/ເປີເຊັນ",
    HOTEL_LOG_cancellationDay: "ວັນຍົກເລີກ",
    HOTEL_LOG_cancellationType: "ປະເພດການຍົກເລີກ",
    HOTEL_LOG_startDate: "ວັນເລີ່ມຕົ້ນ",
    HOTEL_LOG_endDate: "ວັນສິ້ນສຸດ",
    HOTEL_LOG_hotelId: "ລະຫັດໂຮງແຮມ",
    HOTEL_LOG_type: "ເວລານຳໃຊ້",
    HOTEL_LOG_notifyToEmail: "ອີເມວ",
    HOTEL_LOG_notifyCCEmail: "ອີເມວ CC",
    HOTEL_LOG_notifyBCCEmail: "ອີເມວ BCC",
    HOTEL_LOG_includeTaxesInPrice: "ລວມພາສີໃນລາຄາ",
    HOTEL_LOG_language: "ພາສາ",
    HOTEL_LOG_weekend: "ສຸດສັບດາ",
    HOTEL_LOG_email: "ອີເມວ",
    HOTEL_LOG_checkinAfterHour: "ເຂົ້າພັກຫຼັງເວລາ",
    HOTEL_LOG_checkoutBeforeHour: "ອອກຈາກທີ່ພັກກ່ອນເວລາ",
    HOTEL_LOG_roomServices: "ບໍລິການຫ້ອງ",
    HOTEL_LOG_hotelPolicyVi: "ນໂຍບາຍໂຮງແຮມ (VI)",
    HOTEL_LOG_hotelPolicyEn: "ນໂຍບາຍໂຮງແຮມ (EN)",
    HOTEL_LOG_yearOfBuild: "ປີກໍ່ສ້າງ",
    HOTEL_LOG_numberOfFloors: "ຈຳນວນຊັ້ນ",
    HOTEL_LOG_numberOfRooms: "ຈຳນວນຫ້ອງ",
    HOTEL_LOG_minutesToAirport: "ນາທີ່ໄປສະໜາມບິນ",
    HOTEL_LOG_babyAgeDetermine: "ກຳນົດອາຍຸເດັກນ້ອຍ",
    HOTEL_LOG_childAgeDetermine: "ກຳນົດອາຍຸເດັກ",
    HOTEL_LOG_electronicVoltage: "ແຮງໄຟຟ້າ",
    HOTEL_LOG_distanceToAirport: "ລະຍະທາງໄປສະໜາມບິນ",
    HOTEL_LOG_serviceTaxPercent: "ອັດຕາພາສີບໍລິການ",
    HOTEL_LOG_valueAddedTaxPercent: "ພາສີມູນຄ່າເພີ່ມ",
    HOTEL_LOG_distanceToCenter: "ລະຍະທາງໄປກາງເມືອງ",
    HOTEL_LOG_lat: "ລະດັບລະຈີດ",
    HOTEL_LOG_lng: "ລະດັບລົງຈີດ",
    HOTEL_LOG_phoneNum: "ເບີໂທ",
    HOTEL_LOG_hotLine: "ເບີດ່ວນ",
    HOTEL_LOG_starRanking: "ດາວຈັດອັນດັບ",
    HOTEL_LOG_website: "ເວັບໄຊ",
    HOTEL_LOG_addressVi: "ທີ່ຢູ່ (VI)",
    HOTEL_LOG_addressEn: "ທີ່ຢູ່ (EN)",
    HOTEL_LOG_hotelNameVi: "ຊື່ໂຮງແຮມ (VI)",
    HOTEL_LOG_hotelNameEn: "ຊື່ໂຮງແຮມ (EN)",
    HOTEL_LOG_hotelTypeVi: "ປະເພດໂຮງແຮມ (VI)",
    HOTEL_LOG_hotelTypeEn: "ປະເພດໂຮງແຮມ (EN)",
    HOTEL_LOG_cityVi: "ເມືອງ (VI)",
    HOTEL_LOG_countryVi: "ປະເທດ (VI)",
    HOTEL_LOG_locationVi: "ແຂວງ (VI)",
    HOTEL_LOG_cityEn: "ເມືອງ (EN)",
    HOTEL_LOG_areaVi: "ເຂດ (VI)",
    HOTEL_LOG_countryEn: "ປະເທດ (ພາສາອັງກິດ)",
    HOTEL_LOG_locationEn: "ແຂວງ (ພາສາອັງກິດ)",
    HOTEL_LOG_areaEn: "ເຂດພື້ນທີ່ (ພາສາອັງກິດ)",
    HOTEL_LOG_descriptionVi: "ລາຍລະອຽດ (ພາສາຫວຽດ)",
    HOTEL_LOG_descriptionEn: "ລາຍລະອຽດ (ພາສາອັງກິດ)",
    HOTEL_LOG_depositType: "ປະເພດການມັດຈຳ",
    HOTEL_LOG_cutOfDate: "ຈ່າຍມັດຈຳກ່ອນຈຳນວນວັນ",
    HOTEL_LOG_paymentDay: "ຈ່າຍເງິນກ່ອນຈຳນວນວັນ",
    HOTEL_LOG_proNameVi: "ຊື່ໂປຣໂມຊັນ (ພາສາຫວຽດ)",
    HOTEL_LOG_proNameEn: "ຊື່ໂປຣໂມຊັນ (ພາສາອັງກິດ)",
    HOTEL_LOG_promoType: "ປະເພດໂປຣໂມຊັນ",
    HOTEL_LOG_sessionType: "ປະເພດເວລາ",
    HOTEL_LOG_discountOrSurcharge: "ອັດຕາສ່ວນຫຼຸດ / ເພີ່ມລາຄາ",
    HOTEL_LOG_coupon: "ຄູປອງ",
    HOTEL_LOG_orderType: "ປະເພດການນຳໃຊ້",
    HOTEL_LOG_notApplyDates: "ວັນທີບໍ່ນຳໃຊ້",
    HOTEL_LOG_applyPlans: "ແຜນທີ່ນຳໃຊ້",
    HOTEL_LOG_applyAgents: "ເອເຢັນທີ່ນຳໃຊ້",
    HOTEL_LOG_applyLevels: "ຂັ້ນຕອນເອເຢັນທີ່ນຳໃຊ້",
    HOTEL_LOG_applyDays: "ວັນທີ່ນຳໃຊ້",
    HOTEL_LOG_bookType: "ປະເພດການຈອງ",
    HOTEL_LOG_fromDays: "ຈາກ",
    HOTEL_LOG_toDays: "ເຖິງ",
    HOTEL_LOG_minOrder: "ຂັ້ນຕ່ຳການສັ່ງ",
    HOTEL_LOG_freeForMinOrder: "ຟຣີສຳລັບຂັ້ນຕ່ຳ",
    HOTEL_LOG_percentOrFixed: "ເປີເຊັນ ຫຼື ຕົ້ນທຶນຄົງທີ່",
    HOTEL_LOG_startBook: "ແຕ່ວັນຈອງ",
    HOTEL_LOG_endBook: "ເຖິງວັນຈອງ",
    HOTEL_LOG_objectType: "ປະເພດວັດຖຸ",
    HOTEL_LOG_delete: "ລຶບ",
    HOTEL_LOG_promotionNameVi: "ຊື່ໂປຣໂມຊັນ (ພາສາຫວຽດ)",
    HOTEL_LOG_promotionNameEn: "ຊື່ໂປຣໂມຊັນ (ພາສາອັງກິດ)",
    HOTEL_LOG_promotionDesVi: "ລາຍລະອຽດ (ພາສາຫວຽດ)",
    HOTEL_LOG_promotionDesEn: "ລາຍລະອຽດ (ພາສາອັງກິດ)",
    HOTEL_LOG_code: "ລະຫັດຄຳຂໍ",
    HOTEL_LOG_note: "ໝາຍເຫດ",
    HOTEL_LOG_requestStatus: "ສະຖານະຂອງຄຳຂໍ",
    HOTEL_LOG_fullName: "ຊື່ເຕັມ",
    HOTEL_LOG_gender: "ເພດ",
    HOTEL_LOG_phoneNumber: "ເບີໂທ",
    HOTEL_LOG_position: "ຕຳແໜ່ງ",
    HOTEL_LOG_address: "ທີ່ຢູ່",
    HOTEL_LOG_maxChildren: "ເດັກສູງສຸດ",
    HOTEL_LOG_maxAdults: "ຜູ້ໃຫຍ່ສູງສຸດ",
    HOTEL_LOG_totalRoom: "ຈຳນວນຫ້ອງທັງໝົດ",
    HOTEL_LOG_defaultPrice: "ລາຄາເລີ່ມຕົ້ນ",
    HOTEL_LOG_weekendPrice: "ລາຄາສຸດສັບດາ",
    HOTEL_LOG_roomSize: "ຂະໜາດຫ້ອງ",
    HOTEL_LOG_numberOfExtraBeds: "ຈຳນວນຕຽງເພີ່ມ",
    HOTEL_LOG_bedTypeTitleVi: "ຊື່ຫ້ອງ (ພາສາຫວຽດ)",
    HOTEL_LOG_bedTypeTitleEn: "ຊື່ຫ້ອງ (ພາສາອັງກິດ)",
    HOTEL_LOG_viewVi: "ທິວທັດຫ້ອງ (ພາສາຫວຽດ)",
    HOTEL_LOG_viewEn: "ທິວທັດຫ້ອງ (ພາສາອັງກິດ)",
    HOTEL_LOG_bedTypeVi: "ປະເພດຕຽງ (ພາສາຫວຽດ)",
    HOTEL_LOG_bedTypeEn: "ປະເພດຕຽງ (ພາສາອັງກິດ)",
    HOTEL_LOG_sellAllotment: "ຈຳນວນຂາຍ",
    HOTEL_LOG_roomName: "ປະເພດຫ້ອງ",
    HOTEL_LOG_amenityName: "ສິ່ງອຳນວຍຄວາມສະດວກຂອງຫ້ອງ",
    HOTEL_LOG_id: "ລະຫັດ",
    HOTEL_LOG_nameVi: "ຊື່ (ພາສາຫວຽດ)",
    HOTEL_LOG_nameEn: "ຊື່ (ພາສາອັງກິດ)",
    HOTEL_LOG_adultsIncluded: "ລວມຜູ້ໃຫຍ່ແລ້ວ",
    HOTEL_LOG_exAdult: "ລາຄາຜູ້ໃຫຍ່ເພີ່ມ",
    HOTEL_LOG_aexType: "ປະເພດຜູ້ໃຫຍ່",
    HOTEL_LOG_childrenInclued: "ລວມເດັກແລ້ວ",
    HOTEL_LOG_exChild: "ລາຄາເດັກເພີ່ມ",
    HOTEL_LOG_cexType: "ປະເພດເດັກ",
    HOTEL_LOG_start: "ວັນເລີ່ມຕົ້ນ",
    HOTEL_LOG_end: "ເຖິງວັນທີ",
    HOTEL_LOG_sesType: "ໄລຍະເວລາໃນການພັກ",
    HOTEL_LOG_minStay: "ຈຳນວນຄືນຂັ້ນຕ່ຳ",
    HOTEL_LOG_maxStay: "ຈຳນວນຄືນສູງສຸດ",
    HOTEL_LOG_extraBedPrice: "ລາຄາຕຽງເພີ່ມ",
    HOTEL_LOG_rooms: "ປະເພດຫ້ອງ",
    HOTEL_LOG_meals: "ລາຄາອາຫານລວມ",
    HOTEL_LOG_plans: "ຊື່ແຜນ",
    HOTEL_LOG_promotions: "ຊື່ໂປຣໂມຊັນ",
    HOTEL_LOG_avatar: "ຮູບໂປຣໄຟລ໌",
    HOTEL_LOG_userName: "ຊື່ຜູ້ໃຊ້",
    HOTEL_LOG_userGroup: "ກຸ່ມຜູ້ໃຊ້",
    HOTEL_LOG_owner: "ຕຳແໜ່ງ",
    HOTEL_LOG_name: "ຊື່",
    HOTEL_LOG_functions: "ລະຫັດຟັງຊັນ",
    HOTEL_LOG_users: "ບັນຊີຜູ້ໃຊ້",
    HOTEL_LOG_description: "ລາຍລະອຽດ",
    HOTEL_LOG_enterpriseName: "ຊື່ບໍລິສັດ",
    HOTEL_LOG_registeredAddress: "ທີ່ຢູ່ບໍລິສັດ",
    HOTEL_LOG_taxCode: "ລະຫັດພາສີ",
    HOTEL_LOG_bankAccountNumber: "ເລກບັນຊີທະນາຄານ",
    HOTEL_LOG_bankAccountName: "ຊື່ບັນຊີທະນາຄານ",
    HOTEL_LOG_bankName: "ຊື່ທະນາຄານ",
    HOTEL_LOG_bankBranch: "ສາຂາທະນາຄານ",
    HOTEL_LOG_representative: "ຕົວແທນ",
    HOTEL_LOG_signer: "ຜູ້ເຊັນ",
    HOTEL_LOG_area: "ພື້ນທີ່",
    HOTEL_LOG_location: "ສະຖານທີ່",
    HOTEL_LOG_city: "ເມືອງ",
    HOTEL_LOG_country: "ປະເທດ",
    HOTEL_LOG_hotline: "ເບີສາຍດ່ວນ",
    HOTEL_LOG_images: "ຊື່ຮູບພາບ",
    HOTEL_LOG_amenities: "ຊື່ສິ່ງອຳນວຍຄວາມສະດວກ",
    HOTEL_LOG_landmark: "ສະຖານທີ່ໃກ້ຄຽງ",
    HOTEL_LOG_distance: "ໄລຍະທາງ",
    HOTEL_LOG_unit: "ໜ່ວຍ",
    HOTEL_LOG_hotelChains: "ໂຮງແຮມໃນເຄືອຂ່າຍ",
    HOTEL_LOG_roomId: "ລະຫັດຫ້ອງ",
    HOTEL_LOG_views: "ທິວທັດ",
    HOTEL_LOG_agentId: "ລະຫັດເອເຈັນ",
    HOTEL_LOG_areas: "ຊື່ພື້ນທີ່",
    HOTEL_LOG_level: "ລະດັບເອເຈັນ",
    HOTEL_LOG_userGroups: "ຊື່ກຸ່ມຜູ້ໃຊ້",
    HOTEL_LOG_hotelType: "ປະເພດໂຮງແຮມ",
    HOTEL_LOG_logo: "ໂລໂກ້ໂຮງແຮມ",
    HOTEL_LOG_currency: "ສະກຸນເງິນ",
    HOTEL_LOG_pmsConfirm: "PMS",
    HOTEL_LOG_restriction: "ຂໍ້ຈຳກັດ",
    OTHER_POLICY: "ນະໂຍບາຍອື່ນໆ",
    IF_CANCELED: "ຖ້າທ່ານຍົກເລີກການຈອງພາຍໃນ",
    DAYS_PRIOR_TO_ARRIVAL_DATE: "ມື້ກ່ອນວັນເຂົ້າພັກ",
    OF_THE_BOOKING_VALUE_WILL_CHARGED: "ຈະຖືກຮຽກເກັບຈາກລາຄາການຈອງ",
    WILL_BE_CHARGED: "ຈະຖືກຮຽກເກັບ",
    WILL_BE_CHARGED_POCUP: "ທ່ານຈະຖືກຮຽກເກັບ",
    RESERVATIONS: "ການຈອງ",
    REQUIES_A_DEPOSIT: "ຈຳເປັນຕ້ອງມີການວາງມັດຈຳ",
    OF_THE_BOOKING_VALUE: "ຈາກລາຄາການຈອງ",
    THE_REMAINING_AMOUNT: "ຈຳນວນເງິນທີ່ເຫຼືອຕ້ອງຊຳລະກ່ອນ",
    THE_REMAINING_DAYS: "ຈຳນວນເງິນທີ່ເຫຼືອຕ້ອງຊຳລະກ່ອນເຂົ້າພັກ",
    PAYMENT_WHEN_CHECKIN: "ຈ່າຍເງິນກ່ອນເຂົ້າພັກ",
    PAYMENT_WHEN_CHECKOUT: "ຈ່າຍເງິນກ່ອນອອກ",
    VIEWDETAIL_PHOTO: "ເບິ່ງຮູບພາບເພີ່ມເຕີມ",
    PAYMENT_100: "ຈ່າຍເງິນ 100% ຂອງລາຄາຈອງ",
    CANCEL_100: "ການຍົກເລີກຈະຖືກຮຽກເກັບ 100%",
    FREE_DEPOSIT: "ບໍ່ມີຄ່າວາງມັດຈຳ",
    ARRIVAL_DATE: "ວັນເຂົ້າພັກ",
    LEAVING_DATE: "ວັນອອກ",
    CHIlDRENTS: "ເດັກນ້ອຍ",
    CHIlDRENT: "ເດັກ",
    ADULTS: "ຜູ້ໃຫຍ່",
    FREE_CANCEL: "ຍົກເລີກໄດ້ຟຣີ",
    CHARGE: "ຄ່າບໍລິການເພີ່ມ",
    CHARGE_AS_ADULTS: "ຮຽກເກັບເຫມືອນຜູ້ໃຫຍ່",
    CHILDREN_BELOW: "ເດັກອາຍຸຕ່ຳກວ່າ",
    CHILDREN_OVER: "ເດັກອາຍຸເກີນ",
    CHILDREN_FROM: "ເດັກຈາກ",
    AGES: "ປີ",
    DISCOUNT: "ສ່ວນຫຼຸດ",
    READ_MORE: "ອ່ານເພີ່ມ",
    READ_LESS: "ຍໍ່ລົງ",
    PICTURE_FACILITIES: "ຮູບພາບ ແລະ ສິ່ງອຳນວຍຄວາມສະດວກ",
    CAPACITY: "ຄວາມຈຸ",
    OPTIONS: "ແຜນຫ້ອງ",
    ALL_CAPACITY: "ເບິ່ງສິ່ງອຳນວຍທັງໝົດ",
    UN_ALL_CAPACITY: "ເບິ່ງນ້ອຍລົງ",
    PAYMENT_BEFORE: "ຈ່າຍເງິນກ່ອນ",
    NO_PAYMENT_BEFORE: "ບໍ່ຈຳເປັນຈ່າຍລ່ວງໜ້າ",
    BOOK_WITHIN: "ຈອງພາຍໃນ",
    PAYMENT_100_NOW: "ຈ່າຍ 100% ຂອງລາຄາຈອງ",
    CANCEL_FREE_FROM: "ຍົກເລີກໄດ້ຟຣີຈາກ",
    TO_H: "ກ່ອນເຂົ້າພັກ",
    CANCEL_FREE_BEFORE: "ຍົກເລີກໄດ້ໂດຍບໍ່ມີຄ່າທ່ານເຖິງ",
    FROM: "ຈາກ",
    UNTIL: "ຫາ",
    EARLY_CONFIRM: "ການຢືນຢັນລ່ວງໜ້າ!",
    SEND_REQUEST_BOOKING: "ສົ່ງຄຳຂໍຈອງ",
    SEND_REQUEST_CART: "ເພີ່ມຄຳຂໍ",
    SEND_REQUEST_NOW: "ສົ່ງຄຳຂໍຕອນນີ້",
    AREA_INFO: "ຂໍ້ມູນພື້ນທີ່",
    CANCELLATION_POLICY: "ນະໂຍບາຍການຍົກເລີກ",
    CHILD_AND_BED: "ນະໂຍບາຍເດັກນ້ອຍ",
    IF_CANCELED_BEFORE: "ຖ້າຍົກເລີກກ່ອນ",
    THERE_ARE: "ມີ",
    ROOM_TYPES_WITH: "ປະເພດຫ້ອງທີ່ມີ",
    OPTIONS_DETAIL: "ແຜນຫ້ອງ",
    SPECIAL_OFFER: "ຂໍ້ເສນພິເສດ",
    HOTEL_POLICY: "ນະໂຍບາຍໂຮງແຮມ",
    CHECK_AVAILABILITY: "ຄົ້ນຫາຫ້ອງ",
    PRICE_FOR: "ລາຄາສໍາລັບ",
    ONLY: "ເທົ່ານັ້ນ",
    NIGHT: "ຄືນ",
    ROOM_LEFT: "ຫ້ອງທີ່ເຫຼືອ",
    THE_PRICE_DOES_NOT_INCLUDE_VAT: "ລາຄາບໍ່ລວມພາສີ",
    SERVICE_CHARGE: "ຄ່າບໍລິການ",
    THE_PRICE_DOES_INCLUDE_VAT: "ລາຄາລວມພາສີ",
    THE_PRICE_DOES_NOT_INCLUDE_VAT_NOT_TOOL: "ບໍ່ລວມພາສີ",
    SERVICE_CHARGE_NOT_TOOL: "ຄ່າບໍລິການ",
    THE_PRICE_DOES_INCLUDE_VAT_NOT_TOOL: "ລວມພາສີ",
    ADD_ROOM: "ເພີ່ມຫ້ອງ",
    BOOK_NOW: "ຈອງຕອນນີ້",
    AND_SERVICE_CHARGE: "ແລະຄ່າບໍລິການ",
    AND_SERVICE_CHARGE_NOT_TOOL: "ແລະຄ່າທ່ານ",
    NO_CHARGE: "ບໍ່ມີຄ່າໃຊ້ຈ່າຍ",
    ADULTS_BTN_RESULTSEARCH: "ຜູ້ໃຫຍ່",
    ABOVE_12_YEARS: "ອາຍຸເກີນ 12 ປີ",
    CHILDRENS_BTN_RESULTSEARCH: "ເດັກນ້ອຍ",
    BELLOW_12_YEARS: "ຕ່ຳກວ່າ 12 ປີ",
    ROOM: "ຫ້ອງ",
    HOW_OLD_ARE_THE_CHILDRENT: "ເດັກນ້ອຍທີ່ທ່ານເດີນທາງມີອາຍຸເທົ່າໃດ",
    CHECKIN: "ເຂົ້າພັກ",
    CHECKOUT: "ອອກຈາກຫ້ອງ",
    T2: "ຈ",
    T3: "ອັງ",
    T4: "ພ",
    T5: "ພະ",
    T6: "ສຸ",
    T7: "ເສົາ",
    T8: "ອາ",
    TH1: "ມັງກອນ",
    TH2: "ກຸມພາ",
    TH3: "ມີນາ",
    TH4: "ເມສາ",
    TH5: "ພຶດສະພາ",
    TH6: "ມິຖຸນາ",
    TH7: "ກໍລະກົດ",
    TH8: "ສິງຫາ",
    TH9: "ກັນຍາ",
    TH10: "ຕຸລາ",
    TH11: "ພະຈິກ",
    TH12: "ທັນວາ",
    MOST_POPULAR: "ສິ່ງອໍານວຍຄວາມສະດວກຍອດນິຍົມ",
    EVERY_OPTION: "ສິ່ງອໍານວຍຄວາມສະດວກອື່ນໆ",
    GIFT_CODE: "ລະຫັດສ່ວນຫຼຸດ",
    COPY_THIS_CODE: "ຄັດລອກລະຫັດນີ້ແລ້ວນໍາໄປວາງໃນໜ້າຊຳລະເງິນ",
    ENDOW: "ສ່ວນຫຼຸດ",
    APPLY_FOR_MIN_ORDER_FROM: "ສໍາລັບຄໍາສັ່ງຊື້ຂັ້ນຕ່ໍາຈາກ",
    APPLY_ON_TOTAL_ROOM_RATE: "ນໍາໃຊ້ກັບລາຄາຫ້ອງທັງໝົດ",
    APPLY_ON_TOTAL_BOOKING: "ນໍາໃຊ້ກັບຄ່າຈອງທັງໝົດ",
    APPLY_ON_TOTAL_SERVICE: "ນໍາໃຊ້ກັບຄ່າບໍລິການທັງໝົດ",
    APPLY_ALL_ORDER: "ສໍາລັບທຸກການສັ່ງຊື້",
    NO_ROOM_LEFT: "ບໍ່ມີຫ້ອງຫຼືອ",
    QUIT_FAVORITE: "ໄດ້ເພີ່ມໃສ່ລາຍການທີ່ມັກແລ້ວ",
    SUM_PROMOTION: "ໂປຣໂມຊັ່ນລວມ",
    PRIORITY_PROMOTION: "ໂປຣໂມຊັ່ນທີ່ມີລຳດັບກ່ອນ",
    BEST_PROMOTION: "ໂປຣໂມຊັ່ນທີ່ດີທີ່ສຸດ",
    TYPE_PROMOTION: "ການຕັ້ງຄ່າໂປຣໂມຊັ່ນ",
    INDEX: "ດັດສະນີ",
    PMS_SUCCESS: "ຂອບໃຈ! ໂຮງແຮມໄດ້ສຳເລັດການຂາຍຫ້ອງຜ່ານ ezCrs ແລ້ວ",
    COMPLETE_INFOMATION: "ກະລຸນາກອກຂໍ້ມູນໃຫ້ຄົບຖ້ວນ",
    SERVICE: {
        CONFIRM_DELETE_SERVICE: "ທ່ານແນ່ໃຈບໍ່ວ່າຈະລຶບ?",
        CONFIRM_DEACTIVE_SERVICE: "ທ່ານແນ່ໃຈບໍ່ວ່າຈະປິດການໃຊ້ງານ?",
        SPECIAL_PRICE: "ລາຄາລາຍວັນ",
        SPECIAL_PRICE_TITLE: "ວັນທີ",
        SPECIAL_PRICE_VALUE: "ລາຄາ",
        ADD_SPECIAL_PRICE: "ເພີ່ມລາຄາພິເສດຕາມວັນ",
        HAS_EXITS: "ມີຢູ່ແລ້ວ",
        LINK: "ລາຍການລິ້ງ",
        STATUS_SYNC: "ສະຖານະການຊິງ",
        ORDER: "ການສັ່ງຊື້",
        THUMBNAIL: "ຮູບພາບ",
        STATUS: "ສະຖານະ",
        DEACTIVE: "ບໍ່ໃຊ້ງານ",
        ACTIVE: "ໃຊ້ງານ",
        SYNC_PMS: "ຊິງຈາກ PMS",
        LIST: "ລາຍການບໍລິການ",
        INFO: "ຂໍ້ມູນບໍລິການ",
        NAME: "ຊື່",
        DESCRIPTION_INFO: "ລາຍລະອຽດ",
        DESCRIPTION_INFO_DEFAULT: "ລາຍລະອຽດ",
        CODE: "ລະຫັດບໍລິການ",
        TIME_APPLY: "ໄລຍະເວລານຳໃຊ້",
        DAY_APPLY: "ວັນໃນອາທິດທີ່ນຳໃຊ້",
        DAYS_NOT_APPLY: "ວັນທີ່ບໍ່ນຳໃຊ້",
        ADD_DAYS_NOT_APPLY: "ເພີ່ມວັນທີ່ບໍ່ນຳໃຊ້",
        TIME_BOOK: "ວັນທີຈອງ",
        TIME_USE: "ວັນທີເຂົ້າພັກ",
        FREE: "ບໍລິການຟຣີ",
        PREMIUM: "ບໍລິການຈ່າຍເງິນ",
        PRICE: "ລາຄາ",
        PRICE_STATUS: "ຄ່າບໍລິການ",
        INCLUDE_TAX: "ລວມພາສີແລ້ວ",
        CURRENCY: "ສະກຸນເງິນ",
        COPPY: "ຄັດລອກ",
        UNIT: "ໜ່ວຍ",
        PER_BOOKING: "ຕໍ່ການຈອງ",
        PER_PERSON_PER_NIGHT: "ຕໍ່ຄົນຕໍ່ຄືນ",
        PER_ROOM: "ຕໍ່ຫ້ອງ",
        PER_ROOM_PER_NIGHT: "ຕໍ່ຫ້ອງຕໍ່ຄືນ",
        PER_PERSON: "ຕໍ່ຄົນ",
        TAX_LABEL: "ພາສີ",
        MAXBOOK: "ການຈອງສູງສຸດ",
        PACKAGE_SELL: "ແພັກແກັດຂາຍ",
        PACKAGE_ALL: "ທັງໝົດ",
        PACKAGE_SPEC: "ແພັກແກັດບາງຢ່າງ",
        SELL_CHANEL: "ຊ່ອງທາງຂາຍທີ່ນໍາໃຊ້",
        CHANEL_ALL: "ນໍາໃຊ້ກັບທຸກຊ່ອງທາງຂາຍ",
        CHANEL_SPEC: "ນໍາໃຊ້ກັບຊ່ອງທາງບາງສ່ວນ",
        CODE_MAX_LENGTH: "ຕ້ອງມີຫຼາຍກວ່າ 2 ຕົວອັກສອນ",
        SPECIAL_DESC: "ລາຄາສໍາລັບວັນທີ່ສະເພາະ",
        NOT_EMPTY: "ຕ້ອງບໍ່ປ່ອນເປົ່າ",
        ERROR_DUPLICATE_DAY: "ມີວັນທີ່ຊໍ້າກັນ, ກະລຸນາກວດຄືນ",
        TAX_DEFAULT: "ແບບເລີ່ມຕົ້ນ",
        UPDATE_IMAGE_SUCCESS: "ອັບໂຫລດຮູບສໍາເລັດ",
        UPDATE_IMAGE_FAIL: "ອັບໂຫລດຮູບລົ້ມເຫຼວ",
        CANCEL: "ຍົກເລີກ",
        NOTHUMB: "ຕ້ອງໃສ່ຮູບພາບ",
        IMAGE_TOO_LARGE: "ຮູບພາບຕ້ອງບໍ່ເກີນ 8MB",
        BINDING_PRICE: "ລາຄານີ້ລວມຢູ່ໃນຄ່າຫ້ອງແລ້ວ",
        MAXQUATITY: "ຈຳນວນສູງສຸດຂອງບໍລິການ",
        UNLIMIT: "ບໍ່ຈຳກັດ",
        LIMIT: "ຈຳກັດ",
        ONE_TIME: "ໃຊ້ໄດ້ຄັ້ງດຽວ",
        CONFIRM_ACTIVE_SERVICE: "ທ່ານແນ່ໃຈບໍ່?",
        BENEFIT: "ຜົນປະໂຫຍດ & ສິ່ງອໍານວຍຄວາມສະດວກ",
        MANDATORY_ADD_ON: "ບໍລິການເສີມທີ່ຈໍາເປັນ",
        MANDATORY_ADD_ON_INFO: "ຖ້າເລືອກ, ບໍລິການນີ້ຈະເພີ່ມໃນການຈອງໂດຍອັດຕະໂນມັດ",
    },
    IMAGE_NOT_EXIST: "ຍັງບໍ່ມີຮູບພາບ",
    IMAGE_SERVICE: "ຮູບພາບ",
    _ROOM_SALE: {
        ROOM_TYPE: {
            ROOM_TYPE: "ປະເພດຫ້ອງ",
            ROOM_CODE: "ລະຫັດຫ້ອງ",
            MAX_PERSON: "ຜູ້ເຂົ້າພັກສູງສຸດ",
            MAX_ADULT: "ຜູ້ໃຫຍ່ສູງສຸດ",
            MAX_CHILD: "ເດັກນ້ອຍສູງສຸດ",
            MAX_KID: "ເດັກອ່ອນສູງສຸດ",
            ROOM_PARENT_TYPE: "ປະເພດຫ້ອງຕົ້ນແບບ",
            ERROR_ROOM_CODE: "ລະຫັດຫ້ອງຕ້ອງບໍ່ຊໍ້າ ຫຼື ປ່ອນເປົ່າ",
            ERROR_ROOM_PARENT: "ຫ້ອງທີ່ເລືອກໄດ້ຖືກຕັ້ງຄ່າເປັນຫ້ອງຕົ້ນແບບຂອງຫ້ອງນີ້ແລ້ວ"
        },
        EXPAND: "ເບິ່ງເພີ່ມ",
        UNEXPAND: "ເບິ່ງນ້ອຍລົງ",
        SELL_CHANNEL: "ຊ່ອງທາງຂາຍ",
        SELL_MARKET: "ຕະຫຼາດ",
        SELL_CHANNEL_ALL: "ທຸກຊ່ອງທາງ",
        SELL_CHANNEL_SPEC: "ບາງຊ່ອງທາງ",
        SELL_MARKET_ALL: "ທຸກຕະຫຼາດ",
        SELL_MARKET_SPEC: "ບາງຕະຫຼາດ",
        LABEL_SEARCH_CODE_NAME: "ລະຫັດ/ປະເພດຫ້ອງ",
        ENTER_HOTEL_NAME_OR_CODE: "ໃສ່ລະຫັດ/ປະເພດຫ້ອງ"
    },
    _SALE_PACKAGE: {
        SALE_PACKAGE: "ແຜນລາຄາ",
        ADD_NEW: "ເພີ່ມແຜນລາຄາໃໝ່",
        ENTER_SALE_PACKAGE_NAME_OR_CODE: "ໃສ່ລະຫັດ/ແຜນລາຄາ",
        RATE_CATEGORY: "ໝວດລາຄາ",
        RATE_CATEGORY_ADD_NEW: "ເພີ່ມໝວດລາຄາໃໝ່",
        ROOM_CATEGORY: "ໝວດຫ້ອງ",
        ROOM_CATEGORY_ADD_NEW: "ເພີ່ມໝວດຫ້ອງໃໝ່"
    },
    ADD_NEW_ROOM: "ເພີ່ມຫ້ອງໃໝ່",
    ROOMS_PER_PAGE: "ຫ້ອງຕໍ່ໜ້າ",
    NOT_EMPTY: "ກະລຸນາໃສ່ຄ່າ",
    _SERVICE_PACKAGE: {
        AGE_MAX_CHILD: "ອາຍຸເດັກນ້ອຍສູງສຸດ",
        AGE_MAX_BABY: "ອາຍຸເດັກອ່ອນສູງສຸດ",
        DAY_APPLY_IN_WEEK: "ວັນໃນອາທິດທີ່ນໍາໃຊ້",
        PAYMENT_POLICY: "ນະໂຍບາຍການຈ່າຍເງິນ",
        CANCEL_POLICY: "ນະໂຍບາຍການຍົກເລີກ",
        APPLY_OBJECT: "ຜູ້ທີ່ນໍາໃຊ້",
        APPLY_CARD: "ປະເພດບັດ",
        PACKAGE_CODE: "ລະຫັດແຜນລາຄາ",
        ADD_PAYMENT_POLICY: "ເພີ່ມນະໂຍບາຍການຈ່າຍເງິນ",
        ADD_CANCEL_POLICY: "ເພີ່ມນະໂຍບາຍການຍົກເລີກ",
        SALE_PACKAGE_CODE: "ລະຫັດແຜນລາຄາ",
        ERROR_SALE_PACKAGE_CODE: "ລະຫັດແຜນລາຄາຕ້ອງບໍ່ຊໍ້າ ຫຼື ປ່ອນເປົ່າ"
    },
    PACKAGE_PER_PAGE: "ແຜນລາຄາຕໍ່ໜ້າ",
    ADD_RANGE_DAYS_NOT_APPLY: "ເພີ່ມວັນທີ່ບໍ່ໄດ້ນໍາໃຊ້",
    NOT_APPLY_RANGE_DATE: "ວັນທີ່ບໍ່ໄດ້ນໍາໃຊ້",
    ROOM_AVAILABLE: "ຈໍານວນຫ້ອງ",
    NO_ROOM_PARENT: "ບໍ່ມີ",
    ROOM_RATE: "ລາຄາຫ້ອງ",
    ADD_SALE_PACKAGE: "ເພີ່ມແຜນລາຄາ",
    ADD_DATE_RANGE: "ເພີ່ມຊ່ວງວັນທີ",
    CONFIRM_DELETE_SALE_PACKAGE_DATE_RANGE: "ຢືນຢັນການລຶບຊ່ວງວັນທີ?",
    SELECT_SALE_PACKAGE: "ເລືອກແຜນລາຄາ",
    LIST_SALE_PACKAGE_EMPTY: "ບໍ່ມີຂໍ້ມູນແຜນລາຄາ",
    VIEW_TABLE: "ເບິ່ງແບບຕາຕະລາງ",
    VIEW_CALENDAR: "ເບິ່ງແບບປະຕິທິນ",
    SELECT_ROOM_TO_VIEW: "ກະລຸນາເລືອກຫ້ອງເພື່ອເບິ່ງ",
    SHOW_ROOM_AVAIL: "ສະແດງຈໍານວນຫ້ອງທີ່ຫຼືອ",
    ROOM_CONNECTED_OTA: "ຫ້ອງໄດ້ເຊື່ອມຕໍ່ກັບ OTA",
    RESTRICTION_PACKAGE: "ແພັກເກັດຈໍາກັດ",
    RESTRICTION: "ຈໍາກັດ",
    ENTER_RESTRICTION_NAME_OR_CODE: "ໃສ່ຊື່ ຫຼື ລະຫັດການຈໍາກັດ",
    CONFIRM_DELETE_RESTRICTION: "ຢືນຢັນການລຶບແພັກເກັດຈໍາກັດ",
    RESTRICTION_INFOMATION: "ຂໍ້ມູນການຈໍາກັດ",
    CONFIG_RESTRICTION: "ຕັ້ງຄ່າການຈໍາກັດ",
    DEFAULT: "ເລີ່ມຕົ້ນ",
    ROOMTYPE: "ປະເພດຫ້ອງ",
    ROOMPLAN: "ແຜນລາຄາ",
    RESTRICTION_NAME: "ຊື່ການຈໍາກັດ",
    ADD_NEW_RESTRICTION: "ເພີ່ມການຈໍາກັດໃໝ່",
    METADATA: "ເລືອກອັບເດດ",
    RESTRICTION_BULK_UPDATE: "ອັບເດດຫຼາຍລາຍການ",
    RESTRICTION_BULK_DELETE: "ລຶບຫຼາຍລາຍການ",
    ROOM_AVAIL: "ຈໍານວນຫ້ອງ",
    SELL_LIMIT: "ຈໍາກັດການຂາຍ",
    STOP_SELL_LIMIT: "ຢຸດຂາຍ",
    PRICE: "ລາຄາ",
    MANAGE_SYNC_OTA: "ຈັດການຊ່ອງທາງຂາຍ",
    MANAGE_ALIAS_OTA: "ezCms Vela",
    ALL_ROOM: "ທຸກຫ້ອງ",
    NOT_SELECT_SALE_PACKGE: "ກະລຸນາເລືອກແຜນລາຄາ",
    DATA_INPUT_INVALID: "ຂໍ້ມູນບໍ່ຖືກຕ້ອງ",
    UPDATE: "ອັບເດດ",
    SELECT_ROOM_APPLY: "ປະເພດຫ້ອງ",
    SELECT_SALE_PACKAGE_APPLY: "ເລືອກແຜນລາຄາ",
    SPECIAL_PRICE: "ລາຄາລາຍວັນ",
    ENTER_PRICE_AND_CHOSE_SALE_PACAKGE: "ບໍ່ມີລາຄາ ຫຼື ແຜນລາຄາ",
    minStay: "ພັກຢູ່ຢ່າງນ້ອຍ",
    maxStay: "ພັກຢູ່ສູງສຸດ",
    minStayArrival: "ພັກຢ່າງນ້ອຍວັນເຂົ້າ",
    maxStayArrival: "ພັກຢ່າງຫຼາຍວັນເຂົ້າ",
    minBookingWindow: "ຂໍ້ຈໍາກັດການຈອງລ່ວງໜ້າຕໍ່ໍໍໍໍໍໍມື້",
    maxBookingWindow: "ຈໍານວນມື້ຈອງລ່ວງໜ້າສູງສຸດ",
    minBookingWindowByHour: "ຈໍານວນຊົ່ວໂມງຈອງລ່ວງໜ້າຕໍ່ໍໍໍໍໍໍໍໍໍໍຊົ່ວໂມງຕໍ່ຕໍ່",
    maxBookingWindowByHour: "ຈໍານວນຊົ່ວໂມງຈອງລ່ວງໜ້າສູງສຸດ",
    exactStay: "ພັກຢູ່ຕາມຈໍານວນວັນທີກໍານົດ",
    exactStayArrival: "ພັກຢູ່ຕາມຈໍານວນວັນທີເຂົ້າ",
    fromCheckout: "ແຕ່ວັນອອກ",
    cutOfTime: "ເວລາສຸດທ້າຍການຈອງ",
    closedOnArrival: "ປິດຈອງວັນເຂົ້າ",
    closedOnDeparture: "ປິດຈອງວັນອອກ",
    closed: "ຢຸດຂາຍ",
    belongTo: "ເປັນຂອງ",
    appliedFor: "ນໍາໃຊ້ສໍາລັບ",
    CHANNEL_APPLY: "ຊ່ອງທາງຂາຍ",
    CHANNEL_EMPTY: "ບໍ່ມີຊ່ອງທາງ",
    APPLY_FOR: "ນໍາໃຊ້ສໍາລັບ",
    priceExtraAdult: "ລາຄາຜູໃຫຍ່ເພີ່ມ",
    priceExtraChild: "ລາຄາເດັກເພີ່ມ",
    priceExtraBaby: "ລາຄາທາຣກເພີ່ມ",
    DAY_SPECIAL: "ລາຄາລາຍວັນ",
    SUN_SHORT: "ອາທິດ",
    MON_SHORT: "ຈັນ",
    TUE_SHORT: "ອັງຄານ",
    WED_SHORT: "ພຸດ",
    THU_SHORT: "ພະຫັດ",
    FRI_SHORT: "ສຸກ",
    SAT_SHORT: "ເສົາ",
    JAN_SHORT: "ມ.ກ.",
    FEB_SHORT: "ກ.ພ.",
    MAR_SHORT: "ມ.ນ.",
    APR_SHORT: "ເມ.ສ.",
    MAY_SHORT: "ພ.ພ.",
    JUN_SHORT: "ມິ.ຖ.",
    JUL_SHORT: "ກ.ລ.",
    AUG_SHORT: "ສ.ຫ.",
    SEP_SHORT: "ກ.ຍ.",
    OCT_SHORT: "ຕ.ລ.",
    NOV_SHORT: "ພ.ຈ.",
    DEC_SHORT: "ທ.ວ.",
    NO_SELECT: "ບໍ່ມີການປ່ຽນແປງ",
    OPEN: "ເປີດ",
    CONFIRM_DELETE_SPECIAL_PRICE: "ຢືນຢັນການລຶບລາຄາລາຍວັນ",
    CONFIRM_DELETE_SPECIAL_PRICE_EXTRA_ADULT: "ຢືນຢັນການລຶບລາຄາຜູ້ໃຫຍ່ເພີ່ມລາຍວັນ",
    CONFIRM_DELETE_SPECIAL_PRICE_EXTRA_CHILD: "ຢືນຢັນການລຶບລາຄາເດັກເພີ່ມລາຍວັນ",
    CONFIRM_DELETE_SPECIAL_PRICE_EXTRA_BABY: "ຢືນຢັນການລຶບລາຄາທາຣກເພີ່ມລາຍວັນ",
    REMOVE_SPECIAL_PRICE: "ລຶບລາຄາລາຍວັນ",
    NO_DATA: "ບໍ່ມີຂໍ້ມູນ",
    CURRENCY_OTA: "ສະກຸນເງິນບນຊ່ອງຂາຍ",
    ROOM_TYPE_ON_OTA: "ປະເພດຫ້ອງບນ OTA",
    SALE_PACKAGE_ON_OTA: "ແຜນລາຄາບນ OTA",
    NUMBER_OF_PERSON: "ຈໍານວນຄົນ",
    PACKAGE_TYPE: "ປະເພດແພັກເກັດ",
    RATES: "ລາຄາ",
    RATES_OSCILLATE: "ເພີ່ມເຕີມ",
    REGULAR_PRICE: "ລາຄາປົກກະຕິ",
    SYNCED: "ຊິງຄ໌ແລ້ວ",
    ROOM_CLOSED: "ປິດຂາຍ",
    NO_SALEPACKAGE_AVAIL: "ບໍ່ມີແຜນລາຄາ",
    YES: "ແມ່ນ",
    NO: "ບໍ່ແມ່ນ",
    BOOKING_CUSTOMER_NAME: "ຊື່ລູກຄ້າ",
    BOOKING_EMPTY: "ບໍ່ພົບການຈອງໃດໆ.",
    BOOKING_CHANNEL: "ຊ່ອງທາງຈອງ",
    BOOKING_HOTEL: "ໂຮງແຮມ",
    STT: "ລຳດັບ",
    BOOKING_IS_NOT_EXIST: "ບໍ່ພົບການຈອງ",
    ADD_NEW_SALE_CHANNEL: "ເພີ່ມຊ່ອງຂາຍໃໝ່",
    CONNECT: "ເຊື່ອມຕໍ່",
    SELECT_SALE_CHANNEL: "ເລືອກຊ່ອງຂາຍ",
    PHONE_INVALID: "ເບີໂທລະສັບບໍ່ຖືກຕ້ອງ",
    EMAIL_INVALID: "ອີເມວບໍ່ຖືກຕ້ອງ",
    LOGIN_NOW: "ເຂົ້າລະບົບຕອນນີ້!",
    POLICY_NAME: "ຊື່ນະໂຍບາຍ",
    POLICY_DESCRIPTION: "ລາຍລະອຽດນະໂຍບາຍ",
    DESCRIPTION: "ລາຍລະອຽດ",
    APPLY_DAY: "ນໍາໃຊ້",
    DEPOSIT_UNIT: "ຫນ່ວຍ",
    APPLY_FOR_STAYING: "ຕາມວັນພັກ",
    APPLY_FOR_BOOKING: "ຕາມວັນຈອງ",
    CHECKOUT_DATE: "ວັນອອກ",
    CHECKIN_DATE: "ວັນເຂົ້າ",
    BEFORE_CHECKIN_DATE: "ກ່ອນວັນເຂົ້າພັກ",
    BEFORE_CHECKOUT_DATE: "ກ່ອນວັນອອກ",
    CANCEL_ROOM_IN_ROUND_X_DAY_BEFORE: "ຍົກເລີກການຈອງພາຍໃນ X ວັນ",
    NIGHT_CAP: "0 ຄືນ | 1 ຄືນ | {count} ຄືນ",
    CHANGE_PASSWORD_REQUEST_NO_LONGER_WORK: "ຄຳຂໍຂອງທ່ານໃນການປ່ຽນລະຫັດຜ່ານໝົດອາຍຸແລ້ວ!",
    MAXROOM_1000: "ຈຳນວນຫ້ອງສູງສຸດແມ່ນ 1000",
    DATA_INPUT_MAX_100_PERCENT: "ຄ່າສູງສຸດແມ່ນ 100",
    DATA_INPUT_MAX_10_NIGHT: "ຄ່າສູງສຸດແມ່ນ 10 ຄືນ",
    DUPLICATE_CODE: "ລະຫັດຊ້ຳກັນ",
    CREATE: "ສ້າງໃໝ່",
    BULK_UPDATE: "ອັບເດດຫຼາຍລາຍການ",
    SETUP_OTA: "ຕັ້ງຄ່າ OTA",
    AUTH: "ເຂົ້າເຖິງໂຮງແຮມ",
    RECEIVE_BOOKING_FROM_OTA: "ຮັບການຈອງຈາກ OTA",
    UPDATE_INVENTORY: "ອັບເດດຈຳນວນຫ້ອງຈາກ PMS",
    RECEIVE_INVENTORY_UPDATE_FROM_PMS: "ຮັບຂໍ້ມູນຈຳນວນຫ້ອງໄປຫາ OTA",
    PUSH_BOOKING_NOTIFICATION_TO_PMS: "ສົ່ງແຈ້ງເຕືອນການຈອງໄປຫາ PMS",
    HOTEL_INFO: "ຂໍ້ມູນໂຮງແຮມ",
    HOTEL_IMAGE: "ຮູບໂຮງແຮມ",
    HOTEL_AREA: "ພື້ນທີ່ໂຮງແຮມ",
    HOTEL_AMENITY: "ສິ່ງອຳນວຍຄວາມສະດວກໂຮງແຮມ",
    HOTEL_CANCELLATION_POLICY: "ນະໂຍບາຍຍົກເລີກຂອງໂຮງແຮມ",
    HOTEL_SETTING: "ການຕັ້ງຄ່າໂຮງແຮມ",
    HOTEL_PAYMENT_POLICY: "ນະໂຍບາຍການຈ່າຍເງິນໂຮງແຮມ",
    SETUP_AND_MAPPING_TO_OTA: "ຕັ້ງຄ່າແລະແມບເຂົ້າກັບ OTA",
    HOTEL_RATE_PLAN: "ແຜນລາຄາໂຮງແຮມ",
    HOTEL_RESTRICTION: "ຂໍ້ຈຳກັດໂຮງແຮມ",
    HOTEL_ROOM_TYPE: "ປະເພດຫ້ອງ",
    HOTEL_ROOM_TYPE_AMENITY: "ສິ່ງອຳນວຍຄວາມສະດວກຂອງຫ້ອງ",
    HOTEL_ROOM_TYPE_AVAILABILITY: "ຈຳນວນຫ້ອງທີ່ມີ",
    HOTEL_ROOM_RATE: "ລາຄາຫ້ອງ",
    HOTEL_ROOM_TYPE_STOP_SELL: "ຫ້ອງປິດການຂາຍ",
    HOTEL_ROOM_RATE_ADULT: "ລາຄາຜູ້ໃຫຍ່",
    HOTEL_ROOM_RATE_CHILD: "ລາຄາເດັກນ້ອຍ",
    HOTEL_ROOM_RATE_BABY: "ລາຄາເດັກອ່ອນ",
    HOTEL_ROOM_RATE_SPECIAL: "ລາຄາພິເສດ",
    STAFF_INFO: "ຂໍ້ມູນພະນັກງານ",
    STAFF_PASSWORD: "ລະຫັດຜ່ານພະນັກງານ",
    STAFF_AVATAR: "ຮູບພະນັກງານ",
    STAFF_LOGIN: "ເຂົ້າລະບົບພະນັກງານ",
    HOTEL_REGISTER: "ລົງທະບຽນໂຮງແຮມ",
    CHANGE_STATUS: "ປ່ຽນສະຖານະ",
    LOG_ACTION: "ການດຳເນີນງານ",
    LOG_FUNCTION: "ຟັງຊັນ",
    LOG_CONTENT: "ປະຫວັດການທຳງານ",
    LOG_DATE_CREATE: "ວັນທີສ້າງ",
    LOG_USERNAME: "ຊື່ຜູ້ໃຊ້",
    PRICE_ON_OTA: "ລາຄາໃນ OTA",
    PRICE_ON_DEFINED: "ລາຄາທີ່ກຳນົດໄວ້",
    STOP_SELL_TRIGGER: "ເງື່ອນໄຂການປິດຂາຍ",
    DOWNLOAD: "ດາວໂຫຼດ",
    CONFIRM_CHANGE_STATUS_SALE_PACKAGE: "ແຜນລາຄານີ້ໄດ້ເຊື່ອມຕໍ່ກັບ OTA ແລ້ວ, ທ່ານແນ່ໃຈວ່າຈະປ່ຽນສະຖານະບໍ?",
    CONFIRM_CHANGE_STATUS_ROOMTYPE: "ປະເພດຫ້ອງນີ້ໄດ້ເຊື່ອມຕໍ່ກັບ OTA ແລ້ວ, ທ່ານແນ່ໃຈວ່າຈະປ່ຽນສະຖານະບໍ?",
    hotel_id: "ລະຫັດໂຮງແຮມ",
    property_id: "ລະຫັດສັງຫາລິມຊັບ",
    HOTEL_ROOM_TYPE_IMAGES: "ຮູບພາບຫ້ອງ",
    IMAGE_MANAGAMENT: "ຄລັງຮູບພາບ",
    UNIT: "ຫົວໜ່ວຍ",
    NEARBY_TYPE: "ປະເພດໃກ້ໂຮງແຮມ",
    DIALOG_CONFIRM_DESC: "ຈຳກັດການອັບເດດຕາມການຕັ້ງຄ່າແຜນລາຄາ ຫຼື ບໍ?",
    CANNOT_GET_INFO_FROM_OTA_1: "ການສື່ສານກັບ OTA ຂັດຂ້ອງ.",
    CANNOT_GET_INFO_FROM_OTA_2: "ກະລຸນາຕິດຕໍ່ພວກເຮົາໂດຍໂທ 1900 9013 ຫຼືອີເມວ hotro@ezcloud.vn",
    ROOMTYPE_HAS_NO_RATEPLAN: "ກະລຸນາໃສ່ຂໍ້ມູນທີ່ກຳນົດໄວ້ກ່ອນລ່ວງໜ້າ ສຳລັບປະເພດຫ້ອງ, ແຜນລາຄາ, ແລະຊ່ອງທາງ.",
    MAX_LENGTH_10: "ຂໍ້ມູນຈຳກັດ 10 ຕົວອັກສອນ",
    UPDATE_BY: "ອັບເດດໂດຍ",
    OTA_HAS_NO_RATEPLAN: "ຍັງບໍ່ມີແຜນລາຄາສຳລັບ OTA ນີ້",
    PRICE_IS_REQUIRED: "ລາຄາຕ້ອງລະບຸ",
    HOTEL_ROOM_IS_OVER_LIMIT: "ຫ້ອງໂຮງແຮມເກີນຂີດຈຳກັດ",
    CONFIRM_DELETE_PROMOTION: "ທ່ານແນ່ໃຈວ່າຈະລຶບໂປຣໂມຊັນບໍ?",
    ADD_NEW_PROMOTION: "ເພີ່ມໂປຣໂມຊັນໃໝ່",
    ADD_NEW_SERVICE: "ເພີ່ມບໍລິການໃໝ່",
    PRICE_EXTRA: "ລາຄາເພີ່ມເຕີມ",
    PERSON_NUMBER: "ຈຳນວນຄົນ",
    DETAIL: "ລາຍລະອຽດ",
    PRICE_AND_PERSON_IS_REQUIRED: "ລາຄາ ແລະ ຈຳນວນຄົນຕ້ອງລະບຸ",
    CHOOSE_LANG_PAYMENT: "ເລືອກພາສາສຳລັບວິທີຈ່າຍເງິນ",
    ENTER_CONTENT_SHOW: "ໃສ່ເນື້ອໃນທີ່ຈະສະແດງ",
    CONFIG_BE: "ລະບົບຈອງ",
    SAVE_SUCCESS: "ບັນທຶກສຳເລັດ",
    CONFIGURE_OUGING_EMAIL: "ຕັ້ງຄ່າອີເມວທີ່ສົ່ງອອກ",
    EMAIL_SEND: "ທີ່ຢູ່ອີເມວ",
    EMAIL_NAME_SEND: "ຊື່ສະແດງ",
    SERVER_MAIL_ADDRESS: "ເຊີບເວີ SMTP",
    CONNECTOR: "ພອດ SMTP",
    ENCRYPTION_TYPE: "ການເຊື່ອມຕໍ່ປອດໄພ",
    AUTHENTICATON_CONNECTION: "ການຢືນຢັນການເຊື່ອມຕໍ່",
    EMAIL_TYPE: "ປະເພດອີເມວ",
    TEST_EMAIL_SENT: "ທົດລອງສົ່ງອີເມວ",
    SENT_EMAIL_TEST: "ສົ່ງອີເມວທົດລອງ",
    EMAIL_SETTING_EXISTED: "ການຕັ້ງຄ່າອີເມວມີແລ້ວ",
    ERROR_MAIL: "ຜິດພາດ",
    SUCCESS_MAIL: "ສົ່ງອີເມວສຳເລັດ",
    UNIT_ROOM_PRICE: "ລາຄາຫ້ອງ",
    FROM_CHECKOUT: "ຈາກການເຊັກເອົາ",
    NON_REFUNDABLE: "ສາມາດຂໍເງິນຄືນ",
    GUEST_NAME: "ຊື່ແຂກ",
    FROM_TIME: "ເວລາເລີ່ມ",
    TO_TIME: "ເຖິງເວລາ",
    PROMOTION_CODE: "ລະຫັດໂປຣໂມຊັນ",
    SORT: "ຈັດລຽງ",
    HAS_CONNECTED: "ເຊື່ອມຕໍ່ແລ້ວ",
    GUEST: "ແຂກ",
    COUPON_CODE: "ລະຫັດສ່ວນຫຼຸດ",
    PAYMENT_REQUIRED_UPON_BOOKING: "ຈ່າຍເງິນທັນທີໃນການຈອງ",
    CONDITIONS: "ເງື່ອນໄຂ",
    HOW_MUCH_PAYMENT_IS_MADE_BY_THE_GUEST_ON_THE_DAY_OF_BOOKING: "ແຂກໄດ້ຈ່າຍເງິນເທົ່າໃດໃນມື້ຈອງ",
    PERCENT_OF_TOTAL_ROOM_RATE: "% ຂອງຄ່າຫ້ອງທັງໝົດ",
    WHEN_DOES_THE_CUSTOMER_MAKE_THE_PAYMENT_FOR_THE_REMAINING_AMOUNT: "ແຂກຈະຈ່າຍເງິນທີ່ເຫຼືອໃນເມື່ອໃດ?",
    WHAT_THE_PAYMENT_POLICY_FOR_THE_BOOKING_PERIOD: "ນະໂຍບາຍການຈ່າຍເງິນນີ້ໃຊ້ໃນໄລຍະເວລາໃດ?",
    WHAT_DOES_PAYMENT_POLICY_APPLY: "ນະໂຍບາຍການຈ່າຍເງິນນີ້ໃຊ້ກັບໄລຍະພັກໃດ?",
    POLICY_SUMMARY: "ສະຫຼຸບນະໂຍບາຍ",
    PERCENT_BOOKING: "% ຈາກການຈອງ",
    WHEN_DOES_THE_CUSTOMER_MAKE_THE_PAYMENT: "ແຂກຈະຈ່າຍເງິນໃນເມື່ອໃດ?",
    DATA_INPUT_MAX_24_HOUR: "ຂໍ້ມູນບໍ່ຄວນເກົ່າກວ່າ 24 ຊົ່ວໂມງ",
    DAY: "ມື້",
    HOUR: "ຊົ່ວໂມງ",
    HOW_MUCH_DOES_THE_CUSTOMER_MAKE_PAYMENT: "ແຂກຈ່າຍເງິນເທົ່າໃດ?",
    ON_THE_DAY_OF_CHECK_IN: "ໃນວັນເຂົ້າພັກ",
    ON_THE_DAY_OF_CHECK_OUT: "ໃນວັນອອກຈາກພັກ",
    PRICE_PER_NIGHT: "ລາຄາຕໍ່ຄືນ",
    ON_THE_DATE_OF_BOOKING: "ໃນວັນທີ່ຈອງ",
    UPDATE_PRICE_NOTE: "ການປັບລາຄາແລະຈໍານວນຈະຖືກຂຽນທັບ. ການປັບຂຶ້ນລາຄາຂອງຫ້ອງແມ່ຈະສົ່ງຜົນຕໍ່ຫ້ອງລູກດ້ວຍ",
    PROMOTION_TITLE: "ຫົວຂໍ້ໂປຣໂມຊັນ",
    FREE_CANCELLATION_ALLOWED: "ອະນຸຍາດໃຫ້ຍົກເລີກໄດ້ຟຣີ",
    HOW_LONG_BEFORE_CHECK_IN_CAN_GUESTS_CANCEL_FOR_FREE: "ຜູ້ເຂົ້າພັກສາມາດຍົກເລີກໄດ້ຟຣີກ່ອນວັນເຂົ້າພັກກີ່ມື້?",
    DAY_BEFORE_CHECK_IN: "{day} ມື້ກ່ອນວັນເຂົ້າພັກ",
    ACCORDING_TO_CUSTOM: "ກໍານົດເອງ",
    HOW_MUCH_DO_GUESTS_HAVE_TO_PAY_WHEN_THEY_CANCEL_A_RERVATION_DAYS_PRIOR_TO_ARRIVAL: "ແຂກຈະຕ້ອງຈ່າຍເງິນເທົ່າໃດຖ້າຍົກເລີກການຈອງໃນ {day} ມື້ກ່ອນມາຮອດ?",
    HOW_MUCH_DO_GUESTS_HAVE_TO_PAY_WHEN_CANCELING_A_RESERVATION: "ແຂກຈະຕ້ອງຈ່າຍເທົ່າໃດໃນການຍົກເລີກການຈອງ?",
    WHAT_THE_CANCEL_POLICY_FOR_THE_BOOKING_PERIOD: "ນະໂຍບາຍຍົກເລີກນີ້ໃຊ້ໃນໄລຍະເວລາໃດຂອງການຈອງ?",
    WHAT_DOES_CANCEL_POLICY_APPLY: "ນະໂຍບາຍຍົກເລີກນີ້ໃຊ້ໃນໄລຍະພັກໃດ?",
    HOW_MUCH_WILL_THE_CUSTOMER_HAVE_TOT_PAY_IF_THE_GUEST_CANCELS_ON_THE_CHECKIN: "ແຂກຈະຈ່າຍເງິນເທົ່າໃດຖ້າຍົກເລີກໃນມື້ເຂົ້າພັກ?",
    UTC: "ເວລາ UTC",
    ROOM_ARE_AVAILABLE_FROM_LESS_TO_MORE: "ຫ້ອງມີຈໍານວນຈາກນ້ອຍໄປຫາຫຼາຍ",
    TIME_ZONE_HOTEL: "ເວລາໂຊນຂອງໂຮງແຮມ",
    BED_TYPE_SETTING: "ຕັ້ງຄ່າປະເພດເຕຽງ",
    ROOM_TYPE_SETTING: "ຕັ້ງຄ່າປະເພດຫ້ອງ",
    OVER_MAX_GUEST: "ຈໍານວນແຂກເກີນກໍານົດຂອງປະເພດຫ້ອງ",
    OVER_MAX_ADULTS: "ຈໍານວນຜູ້ໃຫຍ່ເກີນຂອງຫ້ອງນີ້",
    OVER_MAX_CHILDREN: "ຈໍານວນເດັກເກີນຂອງຫ້ອງນີ້",
    OVER_MAX_BABY: "ຈໍານວນເດັກອ່ອນເກີນຂອງຫ້ອງນີ້",
    UNDER_MAX_ADULTS: "ຈໍານວນຜູ້ໃຫຍ່ບໍ່ຄົບຕາມແພັກແກຈຂາຍ",
    UNDER_MAX_CHILDREN: "ຈໍານວນເດັກບໍ່ຄົບຕາມແພັກແກຈຂາຍ",
    UNDER_MAX_BABY: "ຈໍານວນເດັກອ່ອນບໍ່ຄົບຕາມແພັກແກຈຂາຍ",
    UNDER_MAX_QUANTITY: "ຈໍານວນຫ້ອງທັງໝົດບໍ່ຄວນເກີນການປະກາດຈໍານວນທີ່ມີ",
    BOOKING_ENGINE: "ເຄື່ອງມືຈອງຫ້ອງ",
    TEXT_NOTIFY_EXPIRED: "ບັນຊີຂອງທ່ານໃນການເຊື່ອມຕໍ່ກັບຊ່ອງທາງຈັດຈໍາໜ່າຍກັບຊ່ອງ {channel} ໄດ້ໝົດອາຍຸໃນວັນທີ {date}. ຂໍ້ມູນຈະບໍ່ຖືກຊິງຄ໌ໄປທີ່ຊ່ອງ OTA, ກະລຸນາຕໍ່ອາຍຸ",
    TEXT_NOTIFY_WILL_EXPIRE: "ບັນຊີຂອງທ່ານໃນການເຊື່ອມຕໍ່ກັບຊ່ອງທາງຈັດຈໍາໜ່າຍກັບຊ່ອງ {channel} ຈະໝົດອາຍຸໃນວັນທີ {date}. ຂໍ້ມູນຈະບໍ່ຖືກຊິງຄ໌ໄປທີ່ຊ່ອງ OTA, ກະລຸນາຕໍ່ອາຍຸ",
    ROOM_AND_PACKAGES_FOR_SALE_ON_GOOOGLE: "ຫ້ອງແລະແພັກແກຈຂາຍຢູ່ຊ່ອງ Google Hotel",
    HOTEL_LOG_roomTypeI18n: "ປະເພດຫ້ອງ",
    HOTEL_LOG_lang: "ພາສາ",
    HOTEL_LOG_ratePlanI18n: "ແພັກແກຈຫ້ອງ",
    HOTEL_LOG_otaI18n: "OTA",
    BE_CONNECT_REQUIRED: "ຍັງບໍ່ມີການເຊື່ອມຕໍ່ລະບົບຈອງ",
    ACCESS_DENIED: "ບໍ່ມີສິດເຂົ້າເຖິງ",
    OTA_NOT_FOUND: "ບໍ່ພົບ OTA",
    HOTEL_SYNC: "ໂຮງແຮມໄດ້ຖືກຊິງຄ໌ແລ້ວ",
    PASSWORD_SENT_SUCCESS: "ສົ່ງລະຫັດຜ່ານສໍາເລັດແລ້ວ",
    CAN_NOT_DELETE: "ປະເພດຫ້ອງ/ແພັກແກຈຂາຍໄດ້ເຊື່ອມກັບ OTA ແລ້ວ",
    BOOKING_NOT_CANCEL: "ບໍ່ສາມາດຍົກເລີກການຈອງໄດ້",

    HEADER_FOOTER_CONFIG: "ແມ່ແບບ",
    MENU_EDIT: "ປະເພດເມນູ",
    MENU_NAME: "ຊື່ເມນູ",
    MENU_CONFIG: "ການສະແດງເມນູ",
    WIDGETS_EDIT: "ປະເພດ Widget",
    ADD_NEW_WIDGETS: "ເພີ່ມ widget ໃໝ່",
    WIDGETS_NOT_YET_DISPLAYED: "ຍັງບໍ່ມີ widget ສະແດງ",
    PARAMETERS: "ຕັ້ງຄ່າອື່ນໆ",
    LOGO_DISPLAYS: "URL ລະບຸໂລໂກ້",
    TOP_HEADER_BACKGROUND: "ຫົວຂໍ້ສູງ – ສີພື້ນ",
    HEADER_BACKGROUND: "ຫົວຂໍ້ – ສີພື້ນ",
    TEXT_HEADER_COLOR: "ຫົວຂໍ້ – ສີຂອງຂຽນ",
    TEXT_HEADER_COLOR_ACTIVE: "ສີຫຼັກ",
    FOOTER_BACKGROUND: "ລາຍລົງ – ສີພື້ນ",
    TEXT_FOOTER_COLOR: "ລາຍລົງ – ສີຂອງຂຽນ",
    BACKGROUND_COPYRIGHT: "ລາຍລົງທາງລຸກ – ສີພື້ນ",
    ADD_NEW_MENU: "ເພີ່ມເມນູໃໝ່",
    CONTENT_WIDGETS: "ເນື້ອຫາ",
    TITLE: "ຫົວຂໍ້",
    REFERENCE_SAMPLE: "ຕົວຢ່າງອ້າງອິງ",
    VI: "ພາສາຫວຽດ",
    EN: "ພາສາອັງກິດ",
    BIGGER_THAN_EQUAL: "ໃຫຍ່ກວ່າ ຫຼື ເທົ່າກັນ",
    AND_MORE: "ແລະ {count} ຕົວເລືອກອື່ນໆ",
    ALL_AGENT: "ທຸກຕົວແທນ",
    GROUP_AGENT: "ກຸ່ມຕົວແທນ",
    SPECIFIC_AGENT: "ຕົວແທນສະເພາະ",
    CHOOSE_NOT_APPLY_AGENT: "ເລືອກຕົວແທນທີ່ບໍ່ນໍາໃຊ້ໂປໂມຊັ່ນ",
    CHOOSE_APPLY_AGENT: "ເລືອກຕົວແທນທີ່ໃຊ້ໂປໂມຊັ່ນ",
    LIST_NOT_APPLY_AGENT: "ລາຍຊື່ຕົວແທນທີ່ບໍ່ໄດ້ໃຊ້ໂປໂມຊັ່ນ",
    LIST_APPLY_AGENT: "ລາຍຊື່ຕົວແທນທີ່ໄດ້ໃຊ້ໂປໂມຊັ່ນ",
    SEARCH_NAME_AGENT: "ໃສ່ຊື່ ຫຼື ລະຫັດຕົວແທນ",
    AGENT_TYPE: "ປະເພດ",
    ENTERPRISE_AGENT: "ບໍລິສັດທ່ອງທ່ຽວ",
    ENTERPRISE_TRADING: "ບໍລິສັດການຄ້າ",
    ENTERPRISE_API: "API ບໍລິສັດ",
    LIST_AGENT: "ລາຍຊື່ຕົວແທນທ່ອງທ່ຽວ",
    SUCCESS: "ສໍາເລັດ",
    CONFIG_CONNECT: "ຕັ້ງຄ່າການເຊື່ອມຕໍ່",
    NO_RECORDS: "ບໍ່ມີຂໍ້ມູນສະແດງ",
    QUANTITY: "ຈໍານວນ",
    ROOM_PRICE: "ລາຄາຫ້ອງ",
    EXTRA_ADULT: "ຜູໃຫຍ່ເພີ່ມ",
    EXTRA_CHILD: "ເດັກເພີ່ມ",
    HOTEL_PROMOTION: "ໂປໂມຊັ່ນໂຮງແຮມ",
    GUEST_INFO: "ຂໍ້ມູນແຂກ",
    MAX_GUEST: "ຈໍານວນແຂກ",
    MAX: "ສູງສຸດ",
    BOOKING_INFO: "ຂໍ້ມູນການຈອງ",
    WRONG_DOMAIN: "ຊື່ໂດເມນບໍ່ຖືກຕ້ອງ",
    FILE_NULL: "ອັບໂຫລດໄຟລ໌ຜິດພາດ",
    PLEASE_COMPLETE_THE_FIELDS_MARKED: "ກະລຸນາກອກຂໍ້ມູນໃຫ້ຄົບຖ້ວນ",
    ADD_NEW_SOCIAL_NETWORK: "ເພີ່ມເຄືອຂ່າຍສັງຄົມໃໝ່",
    PRIMARY_TEXT_COLOR: "ສີຕົວອັກສອນຫຼັກ",
    PRIMARY_BACKGROUND_COLOR: "ສີພື້ນຫຼັກ",
    TOP_HEADER_TEXT_COLOR: "ສີຂອງຂຽນຫົວຂໍ້ສູງ",
    TOP_HEADER_BACKGROUND_COLOR: "ສີພື້ນຫົວຂໍ້ສູງ",
    HEADER_TEXT_COLOR: "ສີຂອງຂຽນຫົວຂໍ້",
    HEADER_BACKGROUND_COLOR: "ສີພື້ນຫົວຂໍ້",
    FOOTER_TEXT_COLOR: "ສີຂອງຂຽນຫົວຂໍ້ລາຍລົງ",
    FOOTER_BACKGROUND_COLOR: "ສີພື້ນຫົວຂໍ້ລາຍລົງ",
    BOTTOM_FOOTER_TEXT_COLOR: "ສີຂອງຂຽນຫົວຂໍ້ລາຍລົງທາງລຸກ",
    BOTTOM_FOOTER_BACKGROUND_COLOR: "ສີພື້ນຫົວຂໍ້ລາຍລົງທາງລຸກ",
    BUTTON_TEXT_COLOR: "ສີຂໍ້ຄວາມປຸ່ມ",
    BUTTON_BACKGROUND_COLOR: "ສີພື້ນປຸ່ມ",
    BUTTON_TEXT_COLOR_2: "ສີຂໍ້ຄວາມປຸ່ມ 2",
    BUTTON_BACKGROUND_COLOR_2: "ສີພື້ນປຸ່ມ 2",
    CUSTOM: "ກຳນົດເອງ",
    URL: "ລິ້ງ",
    OTA_IS_OUT_OF_TIME: "ຊ່ອງທາງ OTA ຍັງບໍ່ໄດ້ເປີດໃຊ້ງານ",
    DATA_INPUT_MUST_BE_GREATER_THAN_0: "ຂໍ້ມູນປ້ອນເຂົ້າຕ້ອງຫຼາຍກວ່າ 0",
    HOTEL_EXTRA_RATE_UPDATE: "ອັບເດດອັດຕາຄ່າບໍລິການເພີ່ມ",
    HOTEL_EXTRA_RATE_DELETE: "ລຶບຄ່າບໍລິການເພີ່ມ",
    DATE_OF_STAY_DOES_NOT_APPLY: "ວັນທີເຂົ້າພັກບໍ່ນໍາໃຊ້",
    DATE_OF_BOOKING_DOES_NOT_APPLY: "ວັນທີຈອງບໍ່ນໍາໃຊ້",
    BOOKING_CODE_OTA: "ລະຫັດການຈອງ OTA",
    HOTEL_WAS_CONNECTED_WITH_OTA: "ໂຮງແຮມໄດ້ເຊື່ອມຕໍ່ກັບຊ່ອງທາງ OTA ແລ້ວ",
    ROOM_TYPE_OTA: "ezCms Leo",
    CONNECTED: "ເຊື່ອມຕໍ່ແລ້ວ",
    NOT_CONNECTED: "ບໍ່ໄດ້ເຊື່ອມຕໍ່",
    MISSING_ROOM_AND_PRICE: "ຂາດຫ້ອງ, ລາຄາ ແລະ ຂໍ້ຈຳກັດ",
    CONNECTED_OTA: "ການກຳນົດຄ່າ OTA",
    SYNC_IN_PROGRESS: "ກຳລັງປັບປຸງຂໍ້ມູນ",
    CONNECTING: "ກຳລັງເຊື່ອມຕໍ່",
    ROOM_AND_PRICE_PACKAGES_HAVE_NOT_BEEN_DECLARED: "ບໍ່ໄດ້ກຳນົດແພັກເກັດຫ້ອງ ແລະ ລາຄາ",
    CONNECTION_FAILED: "ເຊື່ອມຕໍ່ລົ້ມເຫຼວ",
    SU_CONNECTION: "ຊ່ອງທາງຂາຍ",
    SU_MAPPING: "ການກຳນົດຄ່າ",
    CHANNEL_MANAGER_SYSTEM: "ລະບົບຈັດການຊ່ອງທາງຈອງ",
    ENTER_NAME_OR_CODE: "ໃສ່ຊື່ ຫຼື ລະຫັດ",
    OTA_LOG: "ບັນທຶກປັບປຸງ OTA",
    INVENTORY_LOG: "ບັນທຶກສິນຄ້າ",
    ERROR_LOG: "ບັນທຶກຄວາມຜິດພາດ",
    SOURCE: "ແຫຼ່ງຂໍ້ມູນ",
    UPDATE_TIME: "ເວລາອັບເດດ",
    RATE: "ອັດຕາ",
    STOP_SELL: "ຢຸດຂາຍ",
    MIN_STAY: "ຈຳນວນຄືນຂັ້ນຕ່ຳ",
    MAX_STAY: "ຈຳນວນຄືນຂັ້ນສູງ",
    EXTRA_ADULT_RATE: "ຄ່າເພີ່ມຜູໃຫຍ່",
    EXTRA_CHILD_RATE: "ຄ່າເພີ່ມເດັກນ້ອຍ",
    FULL_UPDATE: "ລາຍລະອຽດ",
    UN_STOP_SELL: "ຍົກເລີກການຢຸດຂາຍ",
    OPEN_RESERVATION: "ເປີດຈອງ",
    OPEN_CHECKOUT: "ເປີດເຊັກອອກ",
    ERROR_PHONE_NUMBER_LENGTH: "ເບີໂທຕ້ອງມີ 6-10 ຕົວອັກສອນ",
    ERROR_PHONE_NUMBER_STRING: "ເບີໂທບໍ່ຄວນມີຕົວອັກສອນ ແລະ ຕົວເລກ 0 ນຳໜ້າ",
    FAILURE: "ລົ້ມເຫຼວ",
    ACTIVE_LOG: "ບັນທຶກການໃຊ້ງານ",
    WAITING: "ກຳລັງດຳເນີນການ",
    ROOM_SALE_UPDATE: "ອັບເດດການຂາຍຫ້ອງ",
    PRICE_EXTRA_SPECIAL: "ຄ່າບໍລິການເພີ່ມລາຍວັນ",
    BASE_PRICE_IS_MISSING: "ບໍ່ໄດ້ກຳນົດລາຄາພື້ນຖານ",
    TOOLTIP_MASTER: "ເລືອກຜະລິດຕະພັນ Master 1 ລາຍການ ເພື່ອໃຊ້ເປັນຄ່າອ້າງອີງໃນການຄຳນວນລາຄາລາຍການທີ່ເຫຼືອ",
    RULE_CODE: "ລະຫັດລະຫວ່າງ 2-20 ຕົວ ໃຊ້ພຽງຕົວເລກ ແລະ ຕົວອັກສອນ",
    ROOM_DERIVE: "ຫ້ອງທີ່ຖືກອ້າງອີງ - ອີງຈາກຫ້ອງຫຼັກ",
    DERIVE_OF_ROOM: "ອີງຈາກ",
    COPY_BY_FOMULAR: "ຄັດລອກຕາມສູດ",
    PASTE: "ວາງ",
    DATE_RANGE: "ຊ່ວງວັນ",
    CODE_IS_EXISTED: "ລະຫັດບໍລິການມີແລ້ວ",
    HOTEL_CHANGE_SUCCESS: "ປ່ຽນໂຮງແຮມສຳເລັດ",
    ROOM_CLASS: "ປະເພດຫ້ອງ",
    UPDATE_FOR: "ອັບເດດສຳລັບ {date}",
    UPDATE_RATE_BY_RANGE: "ອັບເດດລາຄາທີ່ຫຼາຍໃນຄັ້ງດຽວ",
    BOOKER: "ຊື່ຜູ້ຈອງ",
    SEARCH_BY_BOOKER: "ຊື່ແຂກ",
    CONTACT_US: "ຕິດຕໍ່ພວກເຮົາ",
    UPDATE_TO_STOP_SELLING_OPENING: "ອັບເດດປິດ/ເປີດຂາຍ",
    UPDATE_ROOM_AVAILABILITY_IN_STAGES: "ອັບເດດຄວາມພ້ອມໃຊ້",
    UPDATE_SELLING_PRICES_IN_STAGES: "ອັບເດດລາຄາຂາຍ",
    UPDATE_STOP_SELL: "ອັບເດດການຢຸດຂາຍ",
    UPDATE_SELL_LIMIT_BY_OTA: "ອັບເດດຈຳນວນຂາຍ",
    UPDATE_SELL_LIMIT_FOR_NEW_OTA: "ອັບເດດຈຳນວນຂາຍ OTA ໃໝ່",
    UPDATE_RESTRICTION_STOPSELL: "ອັບເດດຂໍ້ຈຳກັດການຂາຍ",
    UPDATE_STOP_SELL_BY_OTA: "ອັບເດດການຢຸດຂາຍ",
    DELETE_SELL_LIMIT_BY_OTA: "ລຶບຈຳນວນຂາຍ",
    DELETE_STOP_SELL_BY_OTA: "ລຶບການຢຸດຂາຍ",
    OTHER_FUNCTION: "ຟັງຊັນອື່ນໆ",
    VIEW_MOBILE_VERSION: "ເບິ່ງແບບມືຖື",
    VIEW_DESKTOP_VERSION: "ເບິ່ງແບບຄອມ",
    FILTER_RESULTS: "ກັ່ນຕອງ",
    STOPSELL_UPDATE_SUCCESS: "ອັບເດດການຢຸດຂາຍສຳເລັດ",
    REMOVE_STOPSELL_SUCCESS: "ຍົກເລີກການຢຸດຂາຍສຳເລັດ",
    HOTEL: "0 ໂຮງແຮມ | 1 ໂຮງແຮມ | {count} ໂຮງແຮມ",
    NIGHT_NUMBER: "ຈຳນວນຄືນ",
    CONFIRM_STOP_SELL: "ຢືນຢັນການຢຸດຂາຍ",
    CONFIRM_REMOVE_STOP_SELL: "ຢືນຢັນການຍົກເລີກການຢຸດຂາຍ",
    APP: "ແອັບ",
    ENTER_THE_NAME_OF_THE_APP_WANT_TO_SEARCH_FOR: "ໃສ່ຊື່ແອັບທີ່ທ່ານຕ້ອງການຄົ້ນຫາ",
    LABEL_NIGHT_BACKGROUND_COLOR: "ສີພື້ນຫຼັງຍ່ອຍ 1",
    LABEL_NIGHT_TEXT_COLOR: "ສີຕົວອັກສອນຍ່ອຍ 1",
    PACKAGE_TEXT_COLOR: "ສີຕົວອັກສອນແພັກເກດທີ່ຂາຍໄປແລ້ວ",
    PROMOTION_BACKGROUND_COLOR: "ສີພື້ນຫຼັງຮອບສອງ",
    PROMOTION_TEXT_COLOR: "ສີຕົວອັກສອນຮອບສອງ",
    PRICE_TEXT_COLOR: "ສີລາຄາ 1",
    RANK_STAR_COLOR: "ສີດາວ",
    TEXT_PRICE_2_COLOR: "ສີຄ່າໃຊ້ຈ່າຍ 2",
    SUB_TEXT_3_COLOR: "ສີຕົວອັກສອນເພີ່ມເຕີມ 3",
    SUB_BACKGROUND_3_COLOR: "ສີພື້ນຫຼັງຍ່ອຍ 3",
    RE_SYNC: "ໂພສຈອງໃໝ່",
    CONFIRM_RE_SYNC: "ຢືນຢັນການໂພສໃໝ່",
    HOTEL_REPORT_BOOKING: "ໂພສຈອງໃໝ່",
    UPDATE_INTERVAL_IS_NOT_MORE_THAN_ONE_YEAR: "ໄລຍະການອັບເດດບໍ່ຄວນເກີນ 1 ປີ",
    ACCOUNT_IS_NOT_CONNECTED_TO_GDS: "ບັນຊີບໍ່ໄດ້ເຊື່ອມຕໍ່ກັບ ezCms GDS",
    DISCONNECT: "ຕັດການເຊື່ອມຕໍ່",
    CONFIRM_DISCONNECT_OTA: "ທ່ານແນ່ໃຈບໍ່ວ່າຈະຕັດການເຊື່ອມຕໍ່",
    CONFIRM_CONNECT_OTA: "ທ່ານແນ່ໃຈບໍ່ວ່າຈະເຊື່ອມຕໍ່ຄືນອີກ",
    GDS_OTA: "ezCms GDS",
    ROOM_DUPLICATE: "ລະຫັດຫ້ອງບໍ່ສາມາດຊ້ຳກັນໄດ້",
    ROOM_PLAN_DUPLICATE: "ລະຫັດອັດຕາບໍ່ສາມາດຊ້ຳກັນໄດ້",
    YOU_DONT_HAVE_ANY_HOTELS_YET: "ບໍ່ພົບໂຮງແຮມ",
    TEXT_GDS_INFOMATION: "GDS ແມ່ນເຄືອຂ່າຍການຈອງທີ່ໃຊ້ຄອມພິວເຕີ ທົ່ວໂລກ ທີ່ມີ TA ຫຼາຍກວ່າ 450,000 ໃຊ້ໃນການຈອງຫ້ອງໂຮງແຮມ",
    ROOM_TYPE_ON_CMS: "ປະເພດຫ້ອງໃນ ezCrs",
    ROOM_TYPE_ON_SABRE: "ປະເພດຫ້ອງໃນຊ່ອງທາງຂາຍ",
    ROOM_PLAN_ON_CMS: "ແຜນອັດຕາໃນ ezCrs",
    ROOM_PLAN_ON_SABRE: "ແຜນອັດຕາໃນຊ່ອງທາງຂາຍ",
    CHAIN_CODE: "ລະຫັດໂຮງແຮມໃນເຊັນ",
    CHAIN_TYPE: "ປະເພດເຊັນໂຮງແຮມ",
    ITEMS_SHOWING: "ລາຍການທີ່ສະແດງ",
    TA_NAME: "ຊື່ຕົວແທນ",
    TA_CODE: "ລະຫັດຕົວແທນ",
    CHAIN_TRAVEL_AGENT_INFOMATION: "ຂໍ້ມູນຕົວແທນ",
    ASSIGN_TA_TO_HOTEL: "ມອບໝາຍຕົວແທນທ່ອງທ່ຽວໃຫ້ໂຮງແຮມ",
    ALLOW_OVERWRITING_INFOMATION_DOWN_TO_THE_HOTEL: "ອະນຸຍາດໃຫ້ໂຮງແຮມແກ້ໄຂຂໍ້ມູນ",
    FIRST_NAME: "ຊື່",
    LAST_NAME: "ນາມສະກຸນ",
    CHAIN_AGENT_LIST: "ບໍລິສັດແລະຕົວແທນ",
    ASSIGN_ROOM_TO_HOTEL: "ມອບໝາຍຫ້ອງໃຫ້ໂຮງແຮມ",
    ASSIGN_RATE_PLAN_TO_HOTEL: "ມອບໝາຍແຜນອັດຕາໃຫ້ໂຮງແຮມ",
    CHAIN: "ເຊັນ",
    UNASSIGN: "ຍົກເລີກການມອບໝາຍ",
    ASSIGN: "ມອບໝາຍ",
    CONFIRM_CHANGE_ACTIVE: "ຢືນຢັນການປ່ຽນສະຖານະຕົວແທນ",
    ENTERPRISE_CODE: "ລະຫັດບໍລິສັດ",
    FIRST_NAME_REPRESENT: "ນາມສະກຸນຜູ້ແທນ",
    LAST_NAME_REPRESENT: "ຊື່ຜູ້ແທນ",
    ACCOUNT_HOLDER: "ເຈົ້າຂອງບັນຊີ",
    POSITION: "ຕຳແໜ່ງ",
    HOTEL_LIST: "ລາຍຊື່ໂຮງແຮມ",
    CHAIN_CONFIG: "ການຕັ້ງຄ່າເຊັນ",
    ASSIGN_SERVICE_TO_HOTEL: "ມອບໝາຍບໍລິການໃຫ້ໂຮງແຮມ",
    ROOM_TYPE_CODE_HAS_SYNCED_TO_OTA: "ປະເພດຫ້ອງໄດ້ຖືກເຊື່ອມຕໍ່ແລ້ວ. ກະລຸນາກວດສອບອີກຄັ້ງ",
    ROOM_CODE_DUPLICATION_ROOM_CODE_IN_CHAIN: "ລະຫັດປະເພດຫ້ອງກົງກັບຫ້ອງໃນເຊັນ. ກະລຸນາກວດສອບ",
    ROOM_CODE_DUPLICATION: "ລະຫັດປະເພດຫ້ອງມີແລ້ວ",
    CHAIN_ROOM_TYPE_IS_OVER_LIMIT: "ຈຳນວນຫ້ອງເກີນຂີດຈຳນວນຫ້ອງຂອງໂຮງແຮມ",
    RATE_PLAN_CODE_DUPLICATION: "ແພັກເກດຂາຍມີແລ້ວ. ກະລຸນາກວດສອບ",
    SERVICE_NOT_EXIST: "ບໍລິການບໍ່ມີຢູ່",
    SERVICE_CODE_DUPLICATION: "ລະຫັດບໍລິການມີແລ້ວໃນເຊັນໂຮງແຮມ. ກະລຸນາກວດສອບ",
    TRAVEL_AGENT_ALREADY_EXIST: "ຂໍ້ມູນບໍລິສັດ ແລະຕົວແທນມີຢູ່ແລ້ວ. ກະລຸນາກວດສອບ",
    HOTEL_NOT_USE_EQUAL_CURRENCY: "ໂຮງແຮມທີ່ຖືກມອບໝາຍໃຊ້ສະກຸນເງິນທີ່ແຕກຕ່າງ. ກະລຸນາກວດສອບ",
    AUTO_CANCEL: "ອະນຸຍາດຍົກເລີກອັດຕະໂນມັດຖ້າບໍ່ຢືນຢັນການຈອງ",
    ACCOUNT_IS_NOT_CONNECTED_TO_SITEMINDER: "ບັນຊີບໍ່ໄດ້ເຊື່ອມຕໍ່ກັບ ezCms SiteMinder",
    ROOM_TYPE_MAP_UNMAP: "ປະເພດຫ້ອງທີ່ກຳລັງເຊື່ອມຕໍ່ຈະຖືກຕັດຂາດຖ້າຖອນເລືອກແລະບັນທຶກ. ການດຳເນີນການນີ້ອາດເຮັດໃຫ້ຂາດການເຊື່ອມຕໍ່ ຫຼື ຈອງເກີນ",
    OTA_HOTEL_CODE_ALREADY_EXITS: "ລະຫັດໂຮງແຮມທີ່ໃສ່ໄດ້ເຊື່ອມຕໍ່ແລ້ວ. ກະລຸນາກວດສອບ",
    ADD_SERVICE_TO_ROOM_RATE: "ເພີ່ມບໍລິການໃສ່ແຜນຂາຍ",
    CONFIRM_DELETE_SERVICE_PACKAGE: "ຢືນຢັນການລຶບບໍລິການອອກຈາກແຜນຂາຍ",
    PACKAGE_DEAL: "ແພັກເກດພິເສດ",
    PACKAGE_ITEM: "ລາຍການໃນແພັກເກດ",
    PRICE_ALLOCATION: "ການແບ່ງລາຄາ",
    WEEKLY_PRICE: "ລາຄາລາຍອາທິດ",
    DAILY_PRICE: "ລາຄາລາຍວັນ",
    RD_DAY: "ວັນທີ {day}",
    TOTAL_PACKAGE_VALUE: "ມູນຄ່າລວມຂອງແພັກເກດ",
    LIST_EDIT_SUCCESS: "ອັບເດດສຳເລັດ",
    INFOMATION_OF_BANK_ACCOUNT: "ຂໍ້ມູນບັນຊີທະນາຄານ",
    CHILD_HAS_MORE_OTA_THAN_MASTER: "ບໍ່ສາມາດສ້າງຄວາມສຳພັນໄດ້",
    ENTIRE_HOTEL: "ລະດັບໂຮງແຮມ",
    ACCORDING_TO_EACH_ROOM_CLASS: "ລະດັບປະເພດຫ້ອງ",
    NUMBER_OF_ROOMS_AVAILABLE: "ຈຳນວນຫ້ອງທີ່ພ້ອມໃຫ້ໃຊ້",
    ROOM_OCCUPANCY: "ອັດຕາການໃຊ້ງານຫ້ອງ",
    EDIT_DYNAMIC_PRICING: "ລາຍລະອຽດແບບລາຄາຢືດຫຍຸ່ນ",
    ADD_NEW_DYNAMIC_PRICING: "ເພີ່ມແບບລາຄາຢືດຫຍຸ່ນໃໝ່",
    DYNAMIC_PRICING: "ລາຄາປ່ຽນແປງໄດ້",
    CONFIRM_DELETE_DYNAMIC_PRICING: "ຢືນຢັນລຶບແບບລາຄາຢືດຫຍຸ່ນ",
    DYNAMIC_NAME: "ຊື່ແບບລາຄາຢືດຫຍຸ່ນ",
    DYNAMIC_DESCRIPTION: "ລາຍລະອຽດຂອງແບບລາຄາຢືດຫຍຸ່ນ",
    CRITERIA: "ເງື່ອນໄຂ",
    PRICE_CALCULATION_FORMULA: "ສູດຄຳນວນລາຄາ",
    TOTAL_NUMBER_OF_ROOMS_BY_ROOM_CLASS: "ຈຳນວນຫ້ອງທີ່ຂາຍໄດ້ທັງໝົດຂອງແຕ່ລະປະເພດ (ລວມການຈອງໃນມື້ນັ້ນໆ)",
    TOTAL_NUMBER_OF_ROOMS_BY_HOTEL: "ຈຳນວນຫ້ອງທີ່ໂຮງແຮມຂາຍໄດ້ທັງໝົດ (ລວມການຈອງໃນມື້ນັ້ນໆ)",
    TOTAL_NUMBER_OF_AVAILABLE_ROOMS_BY_ROOM_CLASS: "ຈຳນວນຫ້ອງທີ່ພ້ອມໃຊ້ຂອງແຕ່ລະປະເພດ",
    TOTAL_NUMBER_OF_AVAILABLE_ROOMS_BY_HOTEL: "ຈຳນວນຫ້ອງທີ່ໂຮງແຮມມີໃຫ້ໃຊ້ທັງໝົດ",
    ROOM_CAPACCITY_FORMULA: "ສູດຈຳນວນຜູ້ພັກໃນຫ້ອງ",
    FROM_TO_LESS: "ຈາກ {val} ຫາຕ່ຳກວ່າ",
    NO_PRIOTITY: "ບໍ່ມີຄວາມສຳຄັນ",
    PRIOTITY: "ຄວາມສຳຄັນ",
    UN_SELECT_ALL: "ລຶບ",
    SET_THE_PRICE_CYCLE: "ຂາຍແບບປ່ຽນແປງໄດ້",
    EVENT: "ຕາມເຫດການ",
    CALENDAR: "ຕາຕະລາງ (ຈະມາໃນໄວໆນີ້)",
    DYNAMIC_RATE_METHOD: "ວິທີການລາຄາປ່ຽນແປງໄດ້",
    CONFIRM_DEACTIVE_DYNAMIC_RATE: "ຢືນຢັນປິດການໃຊ້ລາຄາປ່ຽນແປງໄດ້",
    RMS_MANAGEMENT: "ການຈັດການລາຍໄດ້",
    DERIVED_ROOMTYPE: "ປະເພດຫ້ອງທີ່ສືບທອດ",
    BASE: "ປະເພດຫ້ອງພື້ນຖານ",
    UPDATE_FORMULAR: "ອັບເດດສູດ",
    FORMULAR: "ສູດ",
    SET_UP_FORMULAR_BY_DATE_RANGE: "ກຳນົດສູດຕາມຊ່ວງວັນທີ",
    MASTER_RATE: "ລາຄາຫຼັກ",
    SET_UP_FORMULAR: "ຕັ້ງຄ່າສູດ",
    CONFIRM_DELETE_FORMULA: "ຢືນຢັນການລຶບສູດ",
    EDIT_PRICE: "ແກ້ໄຂລາຄາ",
    FOR_EXAMPLE_SERVICE: "ການຈອງຕັ້ງແຕ່ 1 ຫາ 10 ເດືອນຕຸລາ (9 ຄືນ)<br>ດ້ວຍການຕັ້ງຄ່າແບບກຳນົດເອງ:<br><ul><li>ເລີ່ມຈາກຄືນທຳອິດ: 1</li><li>ສິ້ນສຸດທີ່ຄືນສຸດທ້າຍ</li><li>ໃຊ້ຮອບ: 2 (ຄືນ/ຄັ້ງ)</li><li>ຈຳນວນຄັ້ງທີ່ໃຊ້: 3 (ຄັ້ງ)</li></ul>ບໍລິການສາມາດໃຊ້ໄດ້ຈາກ 1 ຫາ 10 ຕຸລາ.<br>ເນື່ອງຈາກໃຊ້ຮອບ 2 ຄືນ/ຄັ້ງ, ບໍລິການຈະໃຊ້ໃນວັນທີ 1/10, 3/10, 5/10, 7/10, 9/10.<br>ແຕ່ເນື່ອງຈາກຈຳນວນຄັ້ງທີ່ໃຊ້ແມ່ນ 3, ບໍລິການຈະໃຊ້ສຳລັບ 3 ຄືນ: 1/10, 3/10, 5/10.<br>ດ້ວຍການຕັ້ງຄ່າຂ້າງເທິງ, ບໍລິການຈະຖືກນຳໃຊ້ໃນ <strong>1/10, 3/10, 5/10</strong>",
    SCHEDULINGTYPE_1: "ໃຊ້ໃນຄືນທຳອິດຂອງການພັກ",
    SCHEDULINGTYPE_2: "ໃຊ້ໃນຄືນສຸດທ້າຍຂອງການພັກ",
    SCHEDULINGTYPE_3: "X ຄືນ ໃຊ້ 1 ຄັ້ງ, ເລີ່ມຈາກຄືນທີ Y",
    SCHEDULINGTYPE_4: "ໃຊ້ໃນຄືນທັງໝົດຍົກເວັ້ນຄືນທຳອິດ",
    SCHEDULINGTYPE_5: "ໃຊ້ໃນຄືນທັງໝົດຍົກເວັ້ນຄືນສຸດທ້າຍ",
    SCHEDULINGTYPE_6: "ບໍ່ໃຊ້ໃນຄືນທຳອິດ ແລະ ຄືນສຸດທ້າຍ",
    SCHEDULINGTYPE_7: "ໃຊ້ໃນທຸກຄືນ (14 ຄືນ)",
    SCHEDULINGTYPE_8: "ໃຊ້ໃນ X ຄືນແບບກຳນົດເອງ",
    SCHEDULINGTYPE_9: "ກຳນົດເອງ",
    SCHEDULINGTYPE_0: "ທຸກຄືນ",
    EXAMPLE: "ຕົວຢ່າງ",
    STARTING_FROMM_NIGHT: "ເລີ່ມຈາກຄືນທີ",
    ENDS_ON_NIGHT: "ສິ້ນສຸດທີ່ຄືນທີ",
    USE_CYCLE: "ຮອບການໃຊ້",
    NUMBER_OF_REPETITION: "ຈຳນວນຄັ້ງທີ່ໃຊ້",
    NUMBER_OF_REPETITION_DETAIL: "ໃຊ້ຮອບ (X ຄືນ ໃຊ້ 1 ຄັ້ງ)",
    NIGHT_14_DESCRIPTION: "ຖ້າຈອງເກີນ 14 ຄືນ, ຫຼັງຈາກຄືນທີ 14 ຈະນຳໃຊ້ບໍລິການຕາມຮອບທີ່ເລືອກໃຫ້",
    CODE_NOT_EMPTY: "ລະຫັດຕ້ອງບໍ່ຊ້ຳ ຫຼື ເປົ່າ",
    BEFORE_THE_LAST_NIGHT: "ກ່ອນຄືນສຸດທ້າຍ",
    LAST_NIGHT: "ຄືນສຸດທ້າຍ",
    CONFIRM_UPDATE_PRICE_SERVICE_GREATER_THAN_TOTAL_PACKAGE: "ລາຄາທີ່ແບ່ງໃຫ້ສູງກວ່າລາຄາລວມຂອງແພັກເກດ. ຢືນຢັນການອັບເດດຫຼືບໍ?",
    EDIT_ATTRIBUTION: "ແກ້ໄຂການຈັດສັນ",
    MIN_ROOM_RATE: "ລາຄາຫ້ອງຕ່ຳສຸດ",
    SETUP_FORMULA: "ອັບເດດສູດ",
    SETUP_FORMULA_BY_DATE_RANGE: "ອັບເດດສູດຕາມຊ່ວງວັນທີ",
    DELETE_FORMULA: "ລຶບສູດ",
    CAN_NOT_CREATE: "ບໍ່ສາມາດສ້າງການຂາຍຫ້ອງໄດ້ ເນື່ອງຈາກຂຶ້ນກັບການຂາຍຫ້ອງແມ່",
    HAVE_BEEN_CONNECTED_TO_OTA: "ປະເພດຫ້ອງ/ແພັກເກດໄດ້ເຊື່ອມຕໍ່ກັບ OTA ແລ້ວ",
    CAN_NOT_INACTIVE_OR_DELETE: "ບໍ່ສາມາດອັບເດດໄດ້",
    ROOM_RATE_IS_CHILDREN: "ຜະລິດຕະພັນທີ່ກຳລັງແກ້ໄຂແມ່ນລາຄາທີ່ສືບທອດ",
    TO_LESS: "ຫາຕ່ຳກວ່າ",
    COMBO: "ແພັກເກດ",
    TITLE_DESCRIPTION_DYNAMIC_CHANGE: "ວິທີປ່ຽນແປງໂດຍຕາມເຫດການ ໃຫ້ໂຮງແຮມສາມາດຕັ້ງຄ່າເພື່ອປ່ຽນແປງລາຄາ/ຂໍ້ຈຳກັດໄດ້ໂດຍຕິດຕາມເຫດການທີ່ກ່ຽວຂ້ອງກັບສິນຄ້າ ລວມທັງ:",
    CHANGE_TYPE_1: "ສິນຄ້າຖືກອັບເດດຈາກ PMS",
    CHANGE_TYPE_2: "ການຈອງຖືກສົ່ງ/ດຶງຈາກຊ່ອງທາງອອນໄລນ໌",
    CHANGE_TYPE_3: "ເປີດ/ປິດປະເພດຫ້ອງ",
    CHANGE_TYPE_4: "ສ້າງ / ແກ້ໄຂສູກກຳລັງອັດຕາຄ່າດຽວ",
    CHANGE_TYPE_5: "ປ່ຽນແປງລາຄາຫ້ອງ",
    CHANGE_TYPE_6: "ປິດ/ເປີດຫ້ອງ",
    SCHEDULE_DYNAMIC_PRICING: "ການກຳນົດການຂາຍຫ້ອງປະເພດດາຍນາມ",
    HAVE_BEEN_CONNECTED_TO_DYNAMICPRICING: "ບໍ່ສາມາດລຶບໄດ້ເພາະສິນຄ້າກຳລັງຕັ້ງຄ່າອັດຕາຄ່າດຽວ",
    SERVICE_INCLUDES: "ບໍລິການປະກອບດ້ວຍ",
    CHAIN_INFO: "ຂໍ້ມູນທົ່ວໄປ - ສາຍໂຮງແຮມ",
    CHAIN_ROOM_TYPE: "ປະເພດຫ້ອງ - ສາຍໂຮງແຮມ",
    CHAIN_RATE_PLAN: "ແພັກເກດຫ້ອງ - ສາຍໂຮງແຮມ",
    CHAIN_ROOM_TYPE_AMENITY: "ສິ່ງອຳນວຍຄວາມສະດວກຫ້ອງ - ສາຍໂຮງແຮມ",
    CHAIN_SERVICE: "ບໍລິການ - ສາຍໂຮງແຮມ",
    CODE_NOT_VALIDATE: "ລະຫັດບໍ່ຖືກຕ້ອງ",
    PAYMENT_CODE: "ລະຫັດການຊຳລະເງິນ",
    PAYMENT_TYPE: "ປະເພດການເຮັດທຸລະກຳ",
    PAYMENT_STATUS: "ສະຖານະທຸລະກຳ",
    PAYMENT: "ການຊຳລະເງິນ",
    REFUND: "ຄືນເງິນ",
    CANCELLATION_REFUND: "ຄືນເງິນຈາກການຍົກເລີກ",
    CANCELLATION_FEE: "ຄ່າທຳນຽມຍົກເລີກ",
    WAITING_PAYMENT: "ລໍຖ້າຊຳລະເງິນ",
    SUCCESS_PAYMENT: "ຊຳລະເງິນສຳເລັດ",
    FAILED: "ບໍ່ສຳເລັດ",
    CHAIN_NOT_EXIST: "ບໍ່ພົບສາຍໂຮງແຮມ",
    CHAIN_TRAVEL_AGENT: "ຂໍ້ມູນບໍລິສັດແລະເອເຢັນ - ສາຍໂຮງແຮມ",
    HOTEL_TRAVEL_AGENT: "ຂໍ້ມູນບໍລິສັດແລະເອເຢັນ",
    BE_MANAGEMENT: "ezBe",
    THE_SYSTEM_IS_LOADING: "ລະບົບກຳລັງໂຫຼດ, ກະລຸນາລໍຖ້າ",
    OTA_HOTEL_NOT_FOUND: "ບໍ່ພົບໂຮງແຮມໃນ OTA",
    ROOM_CLASS_MAPING: "ເຊື່ອມຕໍ່ປະເພດຫ້ອງ",
    CONFIRM_SAVE: "ທ່ານໄດ້ປ່ຽນຂໍ້ມູນການເຊື່ອມຕໍ່ແລ້ວ. ການກະທຳນີ້ອາດເຮັດໃຫ້ການເຊື່ອມຕໍ່ຂາດຫາຍ, ຍົກເລີກການແມບ ແລະເກີນຈຳນວນຈອງ",
    UNDO: "ກັບຄືນ",
    CONFIRM_UNDO: "ການປ່ຽນແປງທີ່ທ່ານໄດ້ເຮັດຈະບໍ່ຖືກບັນທຶກ, ທ່ານແນ່ໃຈວ່າຈະຍົກເລີກບໍ?",
    DEFAULT_LANGUAGE: "ພາສາຫຼັກທີ່ໃຊ້",
    RE_SYNC_CONNECT: "ຊິງໃໝ່",
    ez_FOLIO: "ezFolio",
    ez_CLOUDHOTEL: "ezCloudHotel",
    ADVANCE_SEARCH: "ຄົ້ນຫາຂັ້ນສູງ",
    PRICE_OR_OTA_IS_REQUIRED: "ລາຄາຂາຍ ຫຼື ຊ່ອງທາງຂາຍບໍ່ສາມາດເປົ່າໄດ້",
    UPDATE_BY_ROOM_TYPE: "ອັບເດດຕາມປະເພດຫ້ອງ",
    UPDATE_BY_SALE_PACKAGE: "ອັບເດດຕາມແພັກເກດຫ້ອງ",
    UPDATE_BY_SALE_CHANNEL: "ອັບເດດຕາມຊ່ອງທາງຂາຍ",
    BULK_DELETE: "ລຶບຫຼາຍລາຍການ",
    CONFIRM_UPDATE_OVERWRITE: "ຢືນຢັນການອັບເດດແບບທັບທົ່ມລາຄາ ແລະ ຈຳນວນຄົນທີ່ລວມໃນລາຄາ ສຳລັບຊ່ອງທາງຂາຍທີ່ເລືອກທັງໝົດ",
    ONLY_UPDATE_PRICE: "ອັບເດດລາຄາຢ່າງດຽວ",
    DAILY_MASTER_RATE: "ລາຄາຕໍ່ວັນທີ່ລິ່ງມາ",
    NUMBER_NIGHT: "ຄືນ",
    NUMBER_ROOM: "ຫ້ອງ",
    ROOM_CAP: "0 ຫ້ອງ | 1 ຫ້ອງ | {count} ຫ້ອງ",
    BOOKING_CAP: "0 ການຈອງ | 1 ການຈອງ | {count} ການຈອງ",
    CHECKIN_STATUS_RESERVED: "ຈອງແລ້ວ",
    CHECKIN_STATUS_CHECKIN: "ເຂົ້າພັກ",
    CHECKIN_STATUS_CHECKOUT: "ອອກຈາກພັກ",
    CHECKIN_STATUS_NO_SHOW: "ບໍ່ມາຕາມນັດ",
    CHECKIN_STATUS_ARRIVAL: "ມາຮອດແລ້ວ",
    CHECKIN_STATUS_DUE_OUT: "ຄາດວ່າຈະອອກ",
    CHECKIN_STATUS_CANCELLED: "ຍົກເລີກແລ້ວ",
    NAME_OF_GUEST_STAYING: "ຜູ້ພັກອາໄສ",
    PRICE_EXTRA_DAILY: "ລາຄາພິເສດຕໍ່ວັນ",
    CHANNEL: "0 ຊ່ອງທາງ | 1 ຊ່ອງທາງ | {count} ຊ່ອງທາງ",
    ASSIGN_RATE_TO_CATEGORY: "ກຳນົດແຜນລາຄາໃຫ້ກັບໝວດໝູ່",
    _CATEGORY: {
        CODE: "ລະຫັດໝວດໝູ່",
        NAME: "ຊື່ໝວດໝູ່",
        DESCRIPTION: "ລາຍລະອຽດ"
    },
    ASSIGN_HOTEL_TO_CATEGORY: "ກຳນົດໝວດໝູ່ໃຫ້ໂຮງແຮມ",
    CHAIN_REGIS_INFO: "ຂໍ້ມູນການລົງທະບຽນແຊນ",
    CONFIRM_DELETE_RATE_CATEGORY: "ຢືນຢັນການລຶບໝວດໝູ່ລາຄາ",
    RATE_CATEGORY_ALREADY_EXIST: "ໝວດໝູ່ລາຄາມີຢູ່ແລ້ວ",
    RATE_PLAN_DOES_NOT_EXIST: "ແຜນລາຄາບໍ່ມີຢູ່",
    CANCEL_REASON: "ເຫດຜົນການຍົກເລີກ",
    RATE_PMS: "ລາຄາຂາຍ PMS",
    ALL_PLAN: "ແຜນລາຄາທັງໝົດ",
    ALL_RATE_CATEGORY: "ໝວດໝູ່ລາຄາທັງໝົດ",
    TO_PAGE: "ລາຍການຈາກ 1 ຫາ {count}",
    ASSIGN_ROOM_TYPE: "ກຳນົດປະເພດຫ້ອງ",
    CONFIG_RATE_OTA: "ການຕັ້ງຄ່າລາຄາ OTA",
    CONFIG_RATE_PMS: "ການຕັ້ງຄ່າລາຄາ PMS",
    UPDATE_RATE_PMS: "ອັບເດດລາຄາ",
    VIEW: "ເບິ່ງ",
    CONFIRM_DELETE_SALE_PACKAGE_DATE_RANGE_PMS: "ລາຄາໃນຊ່ວງເວລາທີ່ເລືອກຈະຖືກລຶບໃນປະເພດຫ້ອງ ແລະ ແພັກເກດຂາຍອື່ນໆ.<br> ທ່ານແນ່ໃຈຫຼືບໍ່ວ່າຈະລຶບລາຄາຕາມລຳດັບ?",
    WAITING_UPDATE: "ຂໍ້ມູນໄດ້ຖືກບັນທຶກ ແລະ ກຳລັງດຳເນີນການ",
    STATUS_ROOM_TYPE_ON_OTA: "ສະຖານະການເຊື່ອມຕໍ່ບໍລິການ OTA",
    BOOKING_LIST_GROUP: "ການຈອງເປັນກຸ່ມ",
    _GROUP_STATUS: {
        HOLD: "ຈອງໄວ້",
        TENTATIVE: "ລໍຖ້າຢືນຢັນ",
        CONFIRMED: "ຢືນຢັນແລ້ວ",
        CANCELED: "ຍົກເລີກ",
        CHECKED_IN: "ເຂົ້າພັກແລ້ວ",
        CHECKED_OUT: "ອອກຈາກພັກ",
        CLOSE: "ປິດແລ້ວ",
        NO_SHOW: "ບໍ່ມາຕາມນັດ"
    },
    _BOOKING_GROUP: {
        BOOKING_GROUP_NAME: "ຊື່ການຈອງເປັນກຸ່ມ",
        BOOKING_GROUP_CODE: "ລະຫັດການຈອງເປັນກຸ່ມ",
        GROUP_PROFILE_NAME: "ຊື່ໂປຣໄຟລ໌ກຸ່ມ",
        GROUP_PROFILE_CODE: "ລະຫັດໂປຣໄຟລ໌ກຸ່ມ",
        BOOKING_GROUP_START_DATE: "ວັນເລີ່ມຕົ້ນ",
        BOOKING_GROUP_END_DATE: "ວັນສິ້ນສຸດ",
        BOOKING_GROUP_CREATE_DATE: "ເວລາສ້າງ",
        STATUS: "ສະຖານະກຸ່ມ"
    },
    ENTER_TEXT: "ປ້ອນ {text}",
    LIST_PROFILE_GROUP: "ລາຍການໂປຣໄຟລ໌ກຸ່ມ",
    PROFILE_GROUP: "ໂປຣໄຟລ໌ກຸ່ມ",
    SEARCH_BY_PROFILE_NAME_AND_CODE: "ຊອກຫາຕາມຊື່ ຫຼື ລະຫັດໂປຣໄຟລ໌, ອີເມວ, ທີ່ຢູ່",
    BOOKINGS_GROUP: "ຈຳນວນການຈອງເປັນກຸ່ມ",
    PROFILE_NUMBER: "{count} ລາຍການ",
    _GROUP: {
        CONFIRM_DELETE: "ຢືນຢັນການລຶບຂໍ້ມູນຂອງກຸ່ມ",
        DETAIL: "ລາຍລະອຽດໂປຣໄຟລ໌ຂອງທີມ",
        INFO: "ຂໍ້ມູນໂປຣໄຟລ໌",
        INFO_MANAGE: "ຂໍ້ມູນການຈັດການ",
        ASSIGN: "ມອບຫມາຍການເຮັດວຽກ",
        GROUP_PROFILE_NAME: "ຊື່ໂປຣໄຟລ໌",
        GROUP_PROFILE_NAME_OTHER: "ຊື່ອື່ນ",
        COMPANY_NAME: "ຊື່ບໍລິສັດ / ຕົວແທນ",
        DESCRIPTION: "ຄຳອະທິບາຍ",
        CONTACT_NAME: "ຊື່ຜູ້ແທນ",
        PHONE_NUMBER: "ເບີໂທ",
        PHONE_NUMBER_OTHER: "ເບີໂທອື່ນໆ",
        MANAGE_NAME: "ຊື່-ນາມສະກຸນຂອງຜູ້ຈັດການ",
        DETAIL_BOOKING: "ລາຍລະອຽດການຈອງເປັນກຸ່ມ",
        GROUP_INFO: "ຂໍ້ມູນກຸ່ມ",
        LEADER: "ຫົວໜ້າກຸ່ມ",
        PMS_CCODE: "ລະຫັດ PMS",
        CUS_OF_DAYS: "ຈຳນວນວັນກ່ອນກັດການ",
        CUT_OF_DATE: "ວັນກ່ອນກັດການ",
        PAYMENT_INFO: "ຂໍ້ມູນການຈ່າຍເງິນ",
        TOTAL: "ຈຳນວນລວມ",
        UPDATE_PROFILE: "ອັບເດດໂປຣໄຟລ໌ກຸ່ມ",
        PAYMENT_METHOD: "ວິທີການຈ່າຍເງິນ",
        PAYMENT_METHOD_BOOKING_RETAIL: "ວິທີຈ່າຍແບບລູກຄ້າລາຍບຸກຄົນ",
        BOOKING_GROUP_INFO: "ຂໍ້ມູນການຈອງເປັນກຸ່ມ",
        LEADER_NOT_PAY: "ຫົວໜ້າບໍ່ໄດ້ຈ່າຍເງິນ",
        LEADER_PAY_ONE_PART: "ຫົວໜ້າຈ່າຍເປັນສ່ວນໆ",
        LEADER_PAYS_ALL: "ຫົວໜ້າຈ່າຍທັງໝົດ",
        CHOOSE_PROFILE: "ເລືອກໂປຣໄຟລ໌ຂອງກຸ່ມ",
        TITLE: "ຄຳນຳໜ້າ"
    },
    ROOM_OF_LEADER: "ຫ້ອງຂອງຫົວໜ້າກຸ່ມ",
    NUMBER_OF_BOOKING: "ຈຳນວນການຈອງ",
    SUB_BOOKING_CODE: "ລະຫັດຍ່ອຍກຸ່ມ",
    UPDATE_INFO_BOOKING_GROUP: "ອັບເດດຂໍ້ມູນໄຟລ໌ການຈອງເປັນກຸ່ມ",
    ALLOW_OVERWRITING_INFOMATION_DOWN: "ອະນຸຍາດໃຫ້ຂໍ້ມູນຖືກທັບທົມ",
    FILTER: "ກັ່ນຕອງ",
    GROUP_PROFILE: "ໂປຣໄຟລ໌ກຸ່ມ",
    BOOKING_GROUP_PROFILE: "ການຈອງຂອງກຸ່ມ",
    ASSIGN_HOTEL: "ກຳນົດໂຮງແຮມ",
    ASSIGN_ROOM_TO_CATEGORY: "ກຳນົດຫ້ອງໃຫ້ໝວດໝູ່",
    UPDATE_ROOM_RATE_PMS: "ຕັ້ງລາຄາ PMS",
    UPDATE_ROOM_RATE_OTA: "ຕັ້ງລາຄາ OTA",
    BOOKING_UNMAP: "ຍົກເລີກການແມບການຈອງ",
    CONFIRM_DELETE_ROOM_CATEGORY: "ຢືນຢັນການລຶບໝວດໝູ່ຫ້ອງ",
    CHAIN_ROOM_CATEGORY_ALREADY_EXIST: "ໝວດໝູ່ຫ້ອງແຊນມີຢູ່ແລ້ວ",
    ROOM_CATEGORY_ALREADY_EXIST: "ໝວດໝູ່ຫ້ອງມີຢູ່ແລ້ວ",
    ASSIGN_OTA: "ກຳນົດຊ່ອງທາງຂາຍ",
    NOTE_ASIGN_OTA: "ໝາຍເຫດ: ຊ່ອງທາງຂາຍຈະຖືກກຳນົດໂດຍອັດຕະໂນມັດໃຫ້ໝວດໝູ່ຫ້ອງທີ່ເລືອກ ແລະຊິງໄປຫາໂຮງແຮມທີ່ໄດ້ສະໝັກຊ່ອງທາງນັ້ນ ຫາກທ່ານກົດບັນທຶກ",
    ACTION_TIME: "ເວລາອັບເດດ",
    PROCESS_TIME: "ເວລາປະມວນຜົນ",
    IGNORE: "ຂ້າມ",
    RESEND: "ສົ່ງອັບເດດໃໝ່",
    LIST_ACTION_PROCESS: "ການດຳເນີນງານທີ່ຍັງບໍ່ສົມບູນ",
    STATUS_PROCESSING: "ກຳລັງດຳເນີນງານ",
    STATUS_FAILED: "ລ້ມເຫຼວ",
    STATUS_DONE: "ສຳເລັດແລ້ວ",
    UPDATE_RATE: "ອັບເດດລາຄາ",
    UPDATE_RATE_SPECIAL: "ອັບເດດລາຄາລາຍວັນ",
    UPDATE_EXTRA_RATE: "ອັບເດດຄ່າບວກເຕີມ",
    UPDATE_EXTRA_SPECIAL_RATE: "ອັບເດດຄ່າບວກເຕີມລາຍວັນ",
    UPDATE_AVAIL: "ອັບເດດຫ້ອງວ່າງ",
    UPDATE_RESTRICTION: "ອັບເດດຂໍ້ຈຳກັດ",
    PROCESS_CAP: "0 ຂະບວນການ | 1 ຂະບວນການ | {count} ຂະບວນການ",
    CONFIRM_IGNORE: "ການປະຕິບັດທີ່ຜິດພາດຈະບໍ່ໄດ້ຖືກອັບເດດອີກຄັ້ງ. ທ່ານແນ່ໃຈວ່າຈະຂ້າມບໍ?",
    HOTEL_BOOKING_UNMAP_REPOST: "ໂພສການຈອງໃໝ່",
    UPDATE_RESTRICTION_MINSTAY: "ອັບເດດ Min Stay",
    UPDATE_RESTRICTION_MAXSTAY: "ອັບເດດ Max Stay",
    UPDATE_RESTRICTION_MINSTAYARRIVAL: "ອັບເດດ Min Stay ສຳລັບມາເຖິງ",
    UPDATE_RESTRICTION_MAXSTAYARRIVAL: "ອັບເດດ Max Stay ສຳລັບມາເຖິງ",
    UPDATE_RESTRICTION_MINBOOKINGWINDOW: "ອັບເດດຂັ້ນຕ່ຳກ່ອນຈອງ",
    UPDATE_RESTRICTION_MAXBOOKINGWINDOW: "ອັບເດດຂັ້ນສູງກ່ອນຈອງ",
    UPDATE_RESTRICTION_EXACTSTAY: "ອັບເດດ Exact Stay",
    UPDATE_RESTRICTION_EXACTSTAYARRIVAL: "ອັບເດດ Exact Stay ສຳລັບມາເຖິງ",
    UPDATE_RESTRICTION_CLOSEDONARRIVAL: "ອັບເດດບໍ່ອະນຸຍາດໃຫ້ເຂົ້າພັກ",
    UPDATE_RESTRICTION_CLOSEDONDEPARTURE: "ອັບເດດບໍ່ອະນຸຍາດໃຫ້ອອກ",
    UPDATE_RESTRICTION_CLOSED: "ອັບເດດຢຸດຂາຍ",
    DELETE_PRICE_SPECIAL: "ລຶບລາຄາລາຍວັນ",
    DELETE_EXTRA_RATE: "ລຶບຄ່າບວກເຕີມ",
    DELETE_EXTRA_SPECIAL_RATE: "ລຶບຄ່າບວກເຕີມລາຍວັນ",
    HOTEL_DASHBOARD_IGNORE_TASK: "ຂ້າມ",
    HOTEL_DASHBOARD_REUPDATE_TASK: "ອັບເດດໃໝ່",
    CHAIN_ROOM_UPDATE_QUANTITY: "ອັບເດດຈຳນວນຫ້ອງ (ແຊນ)",
    ROOM_UPDATE_QUANTITY: "ອັບເດດຈຳນວນຫ້ອງ",
    CHAIN_ROOM_CATEGORY: "ໝວດໝູ່ຫ້ອງ - ແຊນ",
    HOTEL_ROOM_CATEGORY: "ໝວດໝູ່ຫ້ອງ",
    HOTEL_RATE_CATEGORY: "ໝວດໝູ່ຫ້ອງ",
    CHAIN_RATE_CATEGORY: "ໝວດໝູ່ລາຄາ - ແຊນ",
    ERROR_CAUSE: "ເຫດຜົນຂອງຄວາມຜິດພາດ",
    INVENTORY_NOT_SYNC: "ຫ້ອງວ່າງບໍ່ໄດ້ຖືກຊິງ",
    UNKNOWN_ERROR: "ຂໍ້ຜິດພາດທີ່ບໍ່ຮູ້",
    BY_RATE: "ຕາມລາຄາຄົງທີ່",
    BY_FORMULA: "ຕາມສູດຄຳນວນ",
    CONFIG_TYPE: "ປະເພດການຕັ້ງຄ່າ",
    FOMULA_FROM_TO: "ສູດຄຳນວນລາຄາຈາກວັນຈັນເຖິງວັນອາທິດ",
    CONFIRM_DEACTIVE_DYNAMIC_RESTRICTION: "ຢືນຢັນການປິດໃຊ້ຂໍ້ຈຳກັດແບບຟລັກຊິບ້ວນ",
    EDIT_DYNAMIC_RESTRICTION: "ເບິ່ງຂໍ້ຈຳກັດແບບຟລັກຊິບ້ວນ",
    ADD_NEW_DYNAMIC_RESTRICTION: "ເພີ່ມແມ່ແບບຂໍ້ຈຳກັດໃໝ່",
    DYNAMIC_RESTRICTION: "ຂໍ້ຈຳກັດແບບຟລັກຊິບ້ວນ",
    CONFIRM_DELETE_DYNAMIC_RESTRICTION: "ຢືນຢັນການລຶບແມ່ແບບຂໍ້ຈຳກັດແບບຟລັກຊິບ້ວນ",
    DYNAMIC_RESTRICTION_NAME: "ຊື່ແມ່ແບບຂໍ້ຈຳກັດແບບຟລັກຊິບ້ວນ",
    DYNAMIC_RESTRICTION_DESCRIPTION: "ລາຍລະອຽດແມ່ແບບຂໍ້ຈຳກັດແບບຟລັກຊິບ້ວນ",
    RESTRICTION_CALCULATION_FORMULA: "ຂໍ້ມູນການຕັ້ງຄ່າ",
    NO_CHANGE: "ບໍ່ມີການປ່ຽນແປງ",
    ADULT_CAP: "0 ຜູ້ໃຫຍ່ | 1 ຜູ້ໃຫຍ່ | {count} ຜູ້ໃຫຍ່",
    CHILD_CAP: "0 ເດັກນ້ອຍ | 1 ເດັກນ້ອຍ | {count} ເດັກນ້ອຍ",
    BABY_CAP: "0 ເດັກອ່ອນ | 1 ເດັກອ່ອນ | {count} ເດັກອ່ອນ",
    USE_MODEL: "ຕັ້ງເປັນແມ່ແບບ",
    ADD_RANGE: "ເພີ່ມຊ່ວງ",
    MODEL_DESCRIPTION_RESTRICTION: "ລາຄາ / ສູດຄຳນວນລາຄາ / ຂອບເຂດຄວາມຈຸຄວາມ / ຂໍ້ຈຳກັດ ຈະຖືກກໍານົດລົງໄປຍັງປະເພດຫ້ອງ ແລະແພັກເກັດຂາຍທີ່ຢູ່ຂ້າງລຸ່ມຖ້າຖືກເລືອກ",
    MODEL_DESCRIPTION_PRICE: "ລາຄາ / ສູດຄຳນວນລາຄາ / ຂອບເຂດຄວາມຈຸຄວາມ / ຂໍ້ຈຳກັດ ຈະຖືກກໍານົດລົງໄປຍັງປະເພດຫ້ອງ ແລະແພັກເກັດຂາຍຂ້າງລຸ່ມ",
    NOTE_ROOM_RATE: "B: ລາຄາຂາຍຂອງປະເພດຫ້ອງນັ້ນໆ. ລາຄາຂາຍຈະຖືກສະແດງແລະອັບເດດໃນໜ້າຈໍຂາຍຫ້ອງ. ເມື່ອສ້າງລາຄາໃໝ່ ລາຄາເລີ່ມຕົ້ນຈະຖືກເອົາຈາກລາຄາໃນປະເພດຫ້ອງ",
    DYNAMIC_SALE: "ການຂາຍຫ້ອງປະເພດດາຍນາມ",
    NOTE_MODEL_PRICE: "ຜູ້ໃຊ້ສາມາດແກ້ໄຂປະເພດຫ້ອງທີ່ຖືກກໍານົດມາຈາກແມ່ແບບໄດ້",
    ACCOUNT_UPDATE: "ບັນຊີທີ່ຖືກອັບເດດ",
    ITEMS_PER_PAGE: "ຈຳນວນແຖວຕໍ່ໜ້າ",
    UPDATE_RATE_SPECIAL_FROM_CHAIN: "ອັບເດດລາຄາຈາກແຊນ",
    EQUIVALENT_TO_ROOM_NIGHT: "ທຽບເທົ່າກັບຄ່າຫ້ອງເຊົ່າຕໍ່ຄືນ",
    CREATED_BY_ACCOUNT: "ສ້າງໂດຍບັນຊີ",
    IS_LEGACY_ROOM_CLASS: "ບໍ່ສາມາດລຶບໄດ້ ເນື່ອງຈາກປະເພດຫ້ອງ ແລະ ແຜນລາຄາຖືກສືບມາ",
    ASSIGN_RATE_CATEGORY: "ກຳນົດໝວດໝູ່ລາຄາ",
    ASSIGN_ROOM_CATEGORY: "ກຳນົດໝວດໝູ່ຫ້ອງ",
    CUSTOMER_PHONE: "ເບີໂທລູກຄ້າ",
    CUSTOMER_MAIL: "ອີເມວຂອງລູກຄ້າທີ່ຈອງ",
    DU_DESCRIPTION_OF_ROOM_TYPE: "ການຈອງຫ້ອງພັກແບບໃຊ້ບໍ່ຄ້ານຄືນ (ມີວັນເຂົ້າ = ວັນອອກ)",
    DU_DESCRIPTION_OF_HOTEL: "ການຈອງໂຮງແຮມແບບໃຊ້ບໍ່ຄ້ານຄືນ (ມີວັນເຂົ້າ = ວັນອອກ)",
    OVERVIEW: "ພາບລວມ",
    INDEX_P: "ອັດຕາການໃຊ້ງານ (P)",
    INDEX_P_ROOM: "ຄວາມຈຸດຂອງປະເພດຫ້ອງພັກ",
    INDEX_P_HOTEL: "ອັດຕາການໃຊ້ງານຂອງໂຮງແຮມ",
    INDEX_A: "ຈຳນວນຫ້ອງທີ່ຂາຍໄດ້ (ລວມ ໃຊ້ບໍ່ຄ້ານຄືນ) (A)",
    INDEX_B: "ຈຳນວນຫ້ອງທີ່ສາມາດຂາຍໄດ້ (B)",
    INDEX_DU: "ຈຳນວນຫ້ອງທີ່ຂາຍໄດ້ແບບໃຊ້ບໍ່ຄ້ານຄືນ (DU)",
    INDEX_INV: "ຫ້ອງທີ່ວ່າງ",
    BY_ROOM: "ຕາມປະເພດຫ້ອງ",
    BY_HOTEL: "ຕາມໂຮງແຮມ",
    DYNAMIC_NAME_HAS_EXIST: "ຊື່ດາຍນາມມີຢູ່ແລ້ວ",
    ROOM_SALE_WITH_ROOM_TYPE: "ເບິ່ງປະເພດຫ້ອງ",
    ROOM_SALE_WITH_OTA: "ເບິ່ງຕາມຊ່ອງທາງຂາຍ",
    ROOM_FUND: "ຈຳນວນຫ້ອງສຳຮອງ",
    NODATA_2: "ກະລຸນາປ້ອນຕົວອັກສອນຫຼາຍກວ່າ 2 ຕົວ",
    CHOOSE_MARKET_SEGMENT: "ເລືອກຕະຫຼາດເປົ້າໝາຍ",
    MARKET_SEGMENT: "ຕະຫຼາດເປົ້າໝາຍ",
    TRAVEL_AGENT_SPEC: "ເອຈັນຈອງເຉົ້າສະເພາະ",
    SEGMENT_SPEC: "ຕະຫຼາດເປົ້າໝາຍສະເພາະ",
    SHOW_CARD_PAYMENT_INFO: "ສະແດງຂໍ້ມູນບັດເຄຣດິດ",
    ENTER_TO_SEARCH_MORE: "ກົດ Enter ເພື່ອຊອກຫາເພີ່ມເຕີມ",
    EMAIL_ACCESSTOKEN: "ອີເມວທີ່ຈະໄດ້ຮັບລະຫັດເຂົ້າເບິ່ງຂໍ້ມູນບັດ",
    TEXT_NOTIFY_EXPIRED_GROUP_OTA: "ຟັງຊັນ {channel} ໝົດອາຍຸໃນວັນທີ {date}",
    TEXT_NOTIFY_WILL_EXPIRE_GROUP_OTA: "ຟັງຊັນ {channel} ຈະໝົດອາຍຸໃນວັນທີ {date}",
    PLEASE_RENEW: ". ກະລຸນາຕິດຕໍ່ຜ່ານອີເມວ <u>hotro@ezcloud.vn</u> ຫຼືໂທ <u>1900 9013</u> ສໍາລັບການຊ່ວຍເຫຼືອ.",
    NOTIFY_OFF_MODULE: "ຟັງຊັນຂາຍຫ້ອງຕາມປະເພດຫ້ອງຈະຖືກຍຸດໃຊ້ໃນໄວໆນີ້. ກະລຸນາສົ່ງຄວາມຄິດເຫັນຂອງທ່ານໄປທີ່ <b>hotro@ezcloud.vn</b>",
    NEW_MESSAGE: "ຂໍ້ຄວາມໃໝ່",
    PAXONE: "ລາຄາສໍາລັບ 1 ຄົນ",
    PAXTOW: "ລາຄາສໍາລັບ 2 ຄົນ",
    PAXEXTRA: "ລາຄາຕໍ່ຄົນເພີ່ມ",
    MAP_PRODUCT: "ກໍານົດຜະລິດຕະພັນ",
    UPDATE_RESTRICTION_BY_RATE_PLAN: "ອັບເດດຂໍ້ຈໍາກັດ",
    CREATE_RESTRICTION: "ສ້າງຂໍ້ຈໍາກັດ",
    DELETE_ROOM_RATE: "ລຶບລາຄາຫ້ອງ",
    UPDATE_SPECIAL_RATE: "ອັບເດດລາຄາປະຈໍາວັນ",
    HERE: "ທີ່ນີ້",
    ACCESS_TOKEN_EMAIL_IS_NOT_EMPTY: "ກະລຸນາໃສ່ອີເມວເພື່ອຮັບລະຫັດເຂົ້າເບິ່ງຂໍ້ມູນບັດ",
    ADD_PROGRAM: "ເພີ່ມໂປຣແກຣມ",
    TYPE_APPLY_PROMOTION: "ລະບົບໂປຣໂມຊັນ",
    PROMOTION_CHARCE_COUPON: "ໂປຣໂມຊັນ, ລະຫັດສ່ວນຫຼຸດ",
    PROMOTION_CHARGE: "ໂປຣໂມຊັນທີ່ຖືກນໍາໃຊ້",
    COUPON_APPLY: "ລະຫັດສ່ວນຫຼຸດທີ່ນໍາໃຊ້",
    EZ_PROMOTION_NOT_SUPPORTED_PROMOTION_TYPE: "ລະບົບ ezPromotion ບໍ່ຮອງຮັບປະເພດໂປຣໂມຊັນນີ້",
    ERROR_EZ_PROMOTION: "ບໍ່ສາມາດເຊື່ອມຕໍ່ລະບົບ ezPromotion ໄດ້",
    CANCEL_PROMOTION_ERROR: "ຍົກເລີກໂປຣໂມຊັນບໍ່ສໍາເລັດ",
    CONFIRM_PROMOTION_ERROR: "ຢືນຢັນໂປຣໂມຊັນບໍ່ສໍາເລັດ",
    RELOAD: "ຣີເຟຣດ",
    WARNING: "ເຕືອນ",
    TXT_WARNING_OVER: "ເພື່ອຮັບປະກັນປະສິດທິພາບຂອງລະບົບ, ບໍ່ຄວນອັບເດດເກີນ 50 ແຖວຕໍ່ຄັ້ງ. ຂອບໃຈ!",
    CONFIRM_DELETE_DATA_ENTERED: "ທ່ານໄດ້ປ່ຽນແປງຂໍ້ມູນຜະລິດຕະພັນຫຼັກ. ທ່ານຕ້ອງການລຶບຂໍ້ມູນລາຄາທີ່ໄດ້ປ້ອນໄປບໍ?",
    ROOM_STATUS_1: "ຈອງແລ້ວ",
    ROOM_STATUS_2: "ເຂົ້າພັກແລ້ວ",
    ROOM_STATUS_3: "ອອກແລ້ວ",
    ROOM_STATUS_4: "ບໍ່ມາພັກ",
    ROOM_STATUS_5: "ຍົກເລີກແລ້ວ",
    BOOKING_HISTORY: "ປະຫວັດການຈອງ",
    BOOKING_STATUS_OTA: "ສະຖານະການຈອງຈາກ OTA",
    BOOKING_OTA_STATUS_0: "ການຈອງໃໝ່",
    BOOKING_OTA_STATUS_1: "ການຈອງຖືກປ່ຽນແປງ",
    BOOKING_OTA_STATUS_2: "ການຈອງຖືກຍົກເລີກ",
    BOOKING_OTA_STATUS_3: "ການຈອງຖືກສົ່ງຕໍ່",
    COPY_RATE: "ຄັດລອກແຜນລາຄາ",
    SALE_PACKAGE_CODE_NEW: "ລະຫັດແຜນລາຄາໃໝ່",
    SELLING_PACKAGE_NEW: "ຊື່ແຜນລາຄາໃໝ່",
    DUPLICATE: "ຊ້ໍາ",
    SALE_PACKAGE_CODE_OLD: "ລະຫັດແຜນລາຄາເກົ່າ",
    FAST_UPDATE: "ອັບເດດດ່ວນ",
    AUTO_CANCEL_PAYMENT_FAIL: "ອະນຸຍາດຍົກເລີກອັດຕະໂນມັດຖ້າການຈ່າຍເງິນລົ້ມເຫຼວ, ຫຼັງຈາກ",
    EZPAYREF: "ລະຫັດອ້າງອີງ",
    TOOLTIP_AUTO_CANCEL_PAYMENT_FAIL: "ຖ້າເປີດໃຊ້ຟັງຊັນນີ້, ຫຼັງຈາກທີ່ການຈອງມີສະຖານະ 'ຈ່າຍເງິນລົ້ມເຫຼວ' ໃນໄລຍະເວລາທີ່ກຳນົດ, ezCrs ຈະຍົກເລີກການຈອງນັ້ນໂດຍອັດຕະໂນມັດ. ເວລາເລີ່ມຕົ້ນແມ່ນ 30 ນາທີ. ຖ້າບໍ່ປ້ອນຂໍ້ມູນ ຈະໃຊ້ເປັນ 0 ນາທີ.<br> ໝາຍເຫດ: ເວລາຍົກເລີກອາດຈະຊ້າກວ່າເວລາທີ່ກຳນົດນິດໜ່ອຍຕາມການເຊື່ອມຕໍ່.",
    TOOLTIP_AUTO_CANCEL: "ສໍາລັບການຈອງທີ່ຕ້ອງການຈ່າຍເງິນລ່ວງໜ້າ, ຫາກລູກຄ້າຈ່າຍເງິນແຕ່ບໍ່ສາມາດບັນທຶກໄດ້ໃນ ezCrs (ເຊັ່ນ ເງິນສົດ ຫຼື ໂອນທາງທະນາຄານ), ໂຮງແຮມຕ້ອງຢືນຢັນການຈອງ. ຖ້າເປີດໃຊ້ຟັງຊັນນີ້, ezCrs ຈະຍົກເລີກການຈອງທີ່ບໍ່ໄດ້ຢືນຢັນໃນມື້ນັ້ນໂດຍອັດຕະໂນມັດ. ເວລາຍົກເລີກຈະຖືກກຳນົດໃນນະໂຍບາຍການຈ່າຍເງິນ.",
    CONFIG_BY: "ຕັ້ງຄ່າໂດຍ",
    LIST_FORMULAR: "ລາຍຊື່ສູດ",
    ROOM_TYPE_BASE: "ປະເພດຫ້ອງພື້ນຖານ",
    SALE_PACKAGE_BASE: "ນະໂຍບາຍລາຄາພື້ນຖານ",
    SALE_CHANNEL_BASE: "ຊ່ອງທາງຂາຍພື້ນຖານ",
    ROOM_TYPE_DERIVED: "ດຶງຂໍ້ມູນຈາກປະເພດຫ້ອງ",
    SALE_PACKAGE_DERIVED: "ດຶງຂໍ້ມູນແຜນລາຄາ",
    SALE_CHANNEL_DERIVED: "ດຶງຂໍ້ມູນຊ່ອງຂາຍ",
    HOTEL_LOG_derivationType: "ປະເພດສູດ",
    HOTEL_LOG_formulaType: "ປະເພດ",
    HOTEL_LOG_master: "ຫຼັກ",
    HOTEL_LOG_children: "ຍ່ອຍ",
    HOTEL_LOG_formula: "ສູດ",
    HOTEL_ROOM_TYPE_SPECIAL: "ປັບລາຄາຫ້ອງ",
    UPDATE_ROOM_TYPE: "ປັບປຸງປະເພດຫ້ອງ",
    TOOLTIP_BASE_ROOM_TYPE: "ຈະດຶງຂໍ້ມູນຕາມສູດ ສໍາລັບສິນຄ້າຂອງຫ້ອງທີ່ມີແຜນລາຄາ ແລະຊ່ອງຂາຍຄ້າຍກັນກັບປະເພດຫ້ອງ {value}",
    TOOLTIP_BASE_RATE_PLAN: "ຈະດຶງຂໍ້ມູນຕາມສູດ ສໍາລັບແຜນລາຄາທີ່ມີປະເພດຫ້ອງ ແລະຊ່ອງຂາຍຄ້າຍກັນກັບແຜນລາຄາ {value}",
    TOOLTIP_BASE_OTA: "ຈະດຶງຂໍ້ມູນຕາມສູດ ສໍາລັບຊ່ອງຂາຍທີ່ມີແຜນລາຄາ ແລະປະເພດຫ້ອງຄ້າຍກັນກັບ OTA {value}",
    VALUE_AND_PERSON_IS_REQUIRED: "ລາຄາແລະຈຳນວນເຂົາພັກບໍ່ສາມາດປ່ອນຫວ່າງໄດ້",
    PLS_CHOOSE_ONE_SELECT_BOX: "ກະລຸນາເລືອກຢ່າງໜ້ອຍ 1 ກ່ອງ 'ລຶບ' ເພື່ອປັບປຸງ",
    NOTE_DERIVED: "ສູດໃໝ່ທີ່ດຶງມາຈະທັບທຽບກັບສູດເກົ່າຖ້າມີການຕົກກັນໃນຜະລິດຕະພັນພື້ນຖານ ຫຼືສິນຄ້າທີ່ດຶງມາ",
    ROOM_QUANTITY_PARENT_NOT_SAME: "ຈໍານວນຫ້ອງຂອງແມ່ ແລະລູກຈະຕ້ອງເທົ່າກັນເພື່ອສ້າງໄດ້",
    IS_REDIRECTING: "ກຳລັງສົ່ງຕໍ່",
    MAP: "ແຜນທີ່",
    SYNC_FROM_PRICELABS: "ຊິງຂໍ້ມູນຈາກ Pricelabs",
    HOTEL_EXTRA_SPECIAL_RATE_DELETE: "ລຶບລາຄາເພີ່ມຕໍ່ມື້",
    HOTEL_EXTRA_SPECIAL_RATE_UPDATE: "ປັບປຸງລາຄາເພີ່ມຕໍ່ມື້",
    SYNC_DATA_TO_OTA: "ຊິງຂໍ້ມູນໄປຫາ OTA",
    MODULE_EZ_PAYMENT_NOT_ACTIVE: "ໂມດູນ ezPayment ບໍ່ໄດ້ເປີດໃຊ້ງານ",
    NOT_DELETE_ROOM_TYPE_CODE_HAS_SYNCED_TO_OTA: "ບໍ່ສາມາດລຶບປະເພດຫ້ອງທີ່ກຳລັງເຊື່ອມຕໍ່ກັບ OTA ໄດ້",
    ENABLE_SYNC_NOT_UPDATED: "ປະເພດຫ້ອງນີ້ກຳລັງເຊື່ອມກັບ OTA. ກະລຸນາດຳເນີນຕາມຂັ້ນຕອນຂ້າງລຸ່ມເພື່ອປ່ຽນຈຳນວນຄົນທີ່ພັກໃນຫ້ອງ, ເນື່ອງຈາກການປ່ຽນແປງອາດສົ່ງຜົນກະທົບຕໍ່ການເຊື່ອມຕໍ່:<br><br>\
    <span class=\"font-weight-bold\">ຂັ້ນຕອນ 1:</span> ເຂົ້າໄປທີ່ການຈັດການການຊິງ => ເລືອກ ezCms vela+ => ເຂົ້າໄປແຖບ OTA Mapping ແລະຕັດການເຊື່ອມຕໍ່ປະເພດຫ້ອງທີ່ຈະປ່ຽນອອກຈາກທຸກ OTA.<br>\
    <span class=\"font-weight-bold\">ຂັ້ນຕອນ 2:</span> ເຂົ້າໄປແຖບ Channels ແລະດຳເນີນການຕັດການເຊື່ອມຕໍ່ຂອງຫ້ອງນັ້ນ.<br>\
    <span class=\"font-weight-bold\">ຂັ້ນຕອນ 3:</span> ປ່ຽນຈຳນວນຄົນທີ່ພັກແລະເຊື່ອມຕໍ່ OTA ຄືນໃໝ່.<br><br>\
    <span class=\"font-weight-bold\">ໝາຍເຫດ:</span> ກະລຸນາປະຕິບັດຕາມຂັ້ນຕອນຢ່າງເປັນລຳດັບ ເພື່ອຫຼີກລ່ຽງຂໍ້ຜິດພາດການເຊື່ອມຕໍ່ທີ່ອາດຈະສົ່ງຜົນໃຫ້ເສຍລາຍໄດ້.<br>\
    ລາຍລະອຽດເພີ່ມເຕີມ: <a href=\"https://help.ezcms.vn/tich-hop-he-thong-ezcms-vela/\" target=\"_blank\"><u>ຄລິກທີ່ນີ້</u></a>",
    ENABLE_SYNC_NOT_CREATED: "ລະຫັດປະເພດຫ້ອງມີແລ້ວໃນລະບົບໂຮງແຮມ, ບໍ່ສາມາດປ່ຽນໄດ້ເນື່ອງຈາກການເຊື່ອມກັບ OTA. \
    ກະລຸນາປ່ຽນລະຫັດຫ້ອງ ຫຼື ປັບຈຳນວນຄົນໃນລະດັບໂຮງແຮມ ຫຼື ໂຮງແຮມໃນເຊັນນີ້.",
    UNDERSELL_LIMIT_TITLE: "ກຳນົດຂີດຈຳກັດຈຳນວນຫ້ອງທີ່ຂາຍໃຫ້ຊ່ອງທາງໃດໜຶ່ງ. ຖ້າຈຳນວນຫ້ອງຄົງເຫຼືອຢູ່ໃນຊ່ອງນັ້ນເທົ່າກັບ ຫຼື ຕໍ່າກວ່າຄ່ານີ້, ລະບົບຈະປິດການຂາຍຫ້ອງອັດຕະໂນມັດ.",
    SELL_LIMIT_TITLE: "ກຳນົດຂີດຈຳກັດຈຳນວນຫ້ອງຂາຍສູງສຸດສໍາລັບກຸ່ມຊ່ອງທາງ ເພື່ອຄວບຄຸມການຂາຍແລະພັດທະນາລາຍໄດ້ໃຫ້ຫຼາຍຂຶ້ນ.",
    ROOM_FOR_SALE: "ຫ້ອງທີ່ຂາຍ",
    NO_CHANNEL_GROUP: "ກະລຸນາເລືອກກຸ່ມຊ່ອງທາງເພື່ອປັບປຸງ",
    DATA_BLANK: "ຂໍ້ມູນປ້ອນໃສ່ບໍ່ຄວນວ່າງເປົ່າ",
    ROOM_QUANTITY_PARENT_NOT_SAME: "ຈຳນວນປະເພດຫ້ອງໃນຫ້ອງຕົ້ນແບບແລະຫ້ອງຍ່ອຍຕ້ອງເທົ່າກັນເພື່ອສ້າງໄດ້",
    VALUE_MUST_BE_LESS_THAN_24H: "ຄ່າຕ້ອງນ້ອຍກວ່າ 24 ຊົ່ວໂມງ",
    N_O: "ເລກທີ",
    MASTER_ROOM_TYPE: "ປະເພດຫ້ອງຕົ້ນແບບ",
    MASTER_RATE_PLAN: "ແຜນລາຄາຕົ້ນແບບ",
    MASTER_CHANNEL: "ຊ່ອງທາງຂາຍຕົ້ນແບບ",
    DERIVED_ROOM_TYPE: "ປະເພດຫ້ອງຍ່ອຍ",
    DERIVED_RATE_PLAN: "ແຜນລາຄາຍ່ອຍ",
    DERIVED_CHANNEL: "ຊ່ອງທາງຂາຍຍ່ອຍ",
    MASTER_PRODUCT: "ຜະລິດຕະພັນຕົ້ນແບບ",
    FORMULAR_LIST: "ລາຍການສູດລາຄາ",
    DERIVED_PRODUCT: "ຜະລິດຕະພັນຍ່ອຍ",
    PRICE_FORMULA: "ສູດລາຄາ",
    SELECT_TYPE: "ເລືອກປະເພດ",
    SHOW_MORE_FOMULA: "ສະແດງສູດລາຄາເພີ່ມເຕີມ",
    SELECT_TYPE_RESTRICTION: "ເລືອກປະເພດຂໍ້ຈຳກັດ",
    SETUP_FORMULAR_LIST: "ຕັ້ງຄ່າລາຍການສູດລາຄາ",
    APPLY_DATE: "ວັນທີ່ນຳໃຊ້",
    LIST_FROM: "ລາຍການຈາກ",
    TO: "ເຖິງ",
    IN: "ໃນ",
    NO_TYPE_SELECTED: "ກະລຸນາເລືອກແຜນລາຄາ ຫຼື ປະເພດຂໍ້ຈຳກັດໃດໜຶ່ງເພື່ອສ້າງສູດ",
    ROOM_TYPE_NOT_MATCH: "ບໍ່ມີສູດສາມາດຕັ້ງຄ່າໄດ້ ເນື່ອງຈາກແຜນລາຄາ ຫຼື ຊ່ອງທາງຂາຍບໍ່ກົງກັນລະຫວ່າງຜະລິດຕະພັນຕົ້ນແບບແລະຜະລິດຕະພັນຍ່ອຍ. ກະລຸນາກວດສອບ ຫຼື ສ້າງຜະລິດຕະພັນໃຫ້ກົງກັນ",
    SALE_PACKAGE_NOT_MATCH: "ບໍ່ມີສູດສາມາດຕັ້ງຄ່າໄດ້ ເນື່ອງຈາກປະເພດຫ້ອງ ຫຼື ຊ່ອງທາງຂາຍບໍ່ກົງກັນລະຫວ່າງຜະລິດຕະພັນຕົ້ນແບບແລະຜະລິດຕະພັນຍ່ອຍ",
    SALE_CHANNEL_NOT_MATCH: "ບໍ່ມີສູດສາມາດຕັ້ງຄ່າໄດ້ ເນື່ອງຈາກແຜນລາຄາ ຫຼື ປະເພດຫ້ອງບໍ່ກົງກັນລະຫວ່າງຜະລິດຕະພັນຕົ້ນແບບແລະຜະລິດຕະພັນຍ່ອຍ",
    CUSTOM_NOT_MATCH: "ບໍ່ສາມາດຕັ້ງຄ່າສູດໄດ້ ເນື່ອງຈາກຜະລິດຕະພັນຕົ້ນແບບແລະຜະລິດຕະພັນຍ່ອຍບໍ່ສອດຄ່ອງກັນທັງໃນດ້ານປະເພດຫ້ອງ, ແຜນລາຄາ ແລະຊ່ອງທາງ",
    CHANGE: "ປ່ຽນແປງ",
    CURRENT_FORMULA: "ສູດປະຈຸບັນ",
    NEW_FORMULA: "ສູດທີ່ສ້າງໃໝ່",
    MODIFIED_FORMULA: "ສູດທີ່ຖືກປ່ຽນແປງ",
    DELETED_FORMULA: "ສູດທີ່ຖືກລຶບ",
    DERIVED: "ຍ່ອຍ",
    LIST_FORMULAR_UPDATE: "ລາຍການສູດທີ່ອັບເດດ",
    BEFORE: "ກ່ອນ",
    AFTER: "ຫຼັງຈາກນັ້ນ",
    ROOM_RATE_DERIVATIONS_NOT_FOUND: "ບໍ່ພົບການດຶງຂໍ້ມູນລາຄາຫ້ອງພັກ",
    UPDATE_RESTRICTION_MINBOOKINGWINDOWBYHOUR: "ປັບປຸງກໍານົດໄລຍະເວລາຈອງຂັ້ນຕ່ຳ (ຕາມຊົ່ວໂມງ)",
    UPDATE_RESTRICTION_MAXBOOKINGWINDOWBYHOUR: "ປັບປຸງກໍານົດໄລຍະເວລາຈອງຂັ້ນສູງ (ຕາມຊົ່ວໂມງ)",
    UPDATE_RESTRICTION_SALEINVENTORY: "ປັບປຸງຈຳນວນຫ້ອງຂາຍ",
    UPDATE_RESTRICTION_SELLLIMIT: "ປັບປຸງຂໍ້ຈຳກັດການຂາຍ",
    NUMBER_OF_DAYS: "ຈຳນວນວັນ",
    NUMBER_OF_HOURS: "ຈຳນວນຊົ່ວໂມງ",
    REMOVE_DAYLY_RATE: "ລຶບລາຄາລາຍວັນ",
    ALLOW_CHECKIN: "ອະນຸຍາດໃຫ້ເຂົ້າພັກ",
    ALLOW_CHECKOUT: "ອະນຸຍາດໃຫ້ອອກຈາກຫ້ອງ",
    QUICK_UPDATE: "ປັບປຸງແບບດ່ວນ",
    BASE_PRICE_REQUIRED: "ກະລຸນາປັບລາຄາລາຍອາທິດກ່ອນ",
    CALENDAR_ROOM: "ເບິ່ງປະຕິທິນ",
    DATA_BLANK: "ຂໍ້ມູນປ້ອນໃສ່ບໍ່ຄວນວ່າງເປົ່າ",
    WARNING_EMAIL: "ອີເມວ",
    SAFE_PRICE_RANGE: {
        PROTECTION_RATE: "ອັດຕາປ້ອງກັນ",
        PROTECTION_RATE_TOOLTIP: "ອັດຕາປ້ອງກັນແມ່ນຊ່ວງລາຄາທີ່ຈະບໍ່ອະນຸຍາດໃຫ້ບັນທຶກ ຖ້າຂໍ້ມູນທີ່ໃສ່ໃນ roomsell ຕ່ໍາກວ່າຄ່າຕໍ່ໍ່າ ຫຼືສູງກວ່າຄ່າສູງສຸດທີ່ກໍານົດໄວ້",
        MINIMUM_RATE: "ອັດຕາຂັ້ນຕ່ໍາ",
        MAXIMUM_RATE: "ອັດຕາຂັ້ນສູງ",
        MINIMUM_RATE_INVALID: "ອັດຕາຂັ້ນຕ່ໍາບໍ່ສາມາດສູງກວ່າຂັ້ນສູງໄດ້",
        MAXIMUM_RATE_INVALID: "ອັດຕາຂັ້ນສູງບໍ່ສາມາດຕ່ໍາກວ່າຂັ້ນຕ່ໍາໄດ້",
        PROTECTION_RATE_INPUT_INVALID: "ຄ່າທີ່ໃສ່ບໍ່ສາມາດຕ່ໍາກວ່າ {priceMin} ຫຼືສູງກວ່າ {priceMax} ໄດ້",
        MINIMUM_RATE_INPUT_INVALID: "ຄ່າທີ່ໃສ່ບໍ່ສາມາດຕ່ໍາກວ່າ {priceMin} ໄດ້",
        MAXIMUM_RATE_INPUT_INVALID: "ຄ່າທີ່ໃສ່ບໍ່ສາມາດສູງກວ່າ {priceMax} ໄດ້"
    },
    PRICE_OUT_OF_BOUND: "ລາຄາທີ່ໃສ່ເກີນຊ່ວງທີ່ກຳນົດໄວ້",
    ROOM_TYPE_ON_SABRE_DUPLICATE: "ບໍ່ສາມາດຊໍ້າປະເພດຫ້ອງໃນຊ່ອງທາງຂາຍໄດ້",
    ROOM_PLAN_ON_SABRE_DUPLICATE: "ບໍ່ສາມາດຊໍ້າແຜນລາຄາໃນຊ່ອງທາງຂາຍໄດ້",
    PRICE_UPDATE_OUT_OF_BOUND: "ລາຄາຂາຍປັດຈຸບັນເກີນຂອບເຂດທີ່ປ້ອງກັນ",
    INCLUDED_TAX: "ລວມພາສີ",
    ACTIVATE: "ເປີດໃຊ້ງານ",
    NO_RANK: "ບໍ່ມີລະດັບດາວ",
    ONE_STAR: "1 ດາວ",
    TWO_STAR: "2 ດາວ",
    THREE_STAR: "3 ດາວ",
    FOUR_STAR: "4 ດາວ",
    FIVE_STAR: "5 ດາວ",
    EXAMPLE_INFO: `<p><i><u><span>ຕົວຢ່າງ:</span></u></i></p>
    <p>ໂຮງແຮມໃຊ້ສະກຸນເງິນ: <span>VND</span></p>
    <p>ຫ້ອງ Deluxe ມີລາຄາທີ່ປະກາດ: <span>900.000</span></p>
    <p>ອັດຕາ: <span>0.00005</span></p>
    <p>ຄວາມແຕກຕ່າງຂອງລາຄາ: <span>0.5</span></p>
    <p>ດັ່ງນັ້ນ ລາຄາຂອງຫ້ອງ Deluxe ໃນຊ່ອງ OTA ຫຼັງຈາກການຊິງຄ໌ຂໍ້ມູນຈະເປັນ: <span>(900.000 x 0.5) + 0.5 = 50 $</span></p>`,
    FREE_SALE_ALLOTMENT: "ຂາຍອິດສະລະຕາມວັນກຳນົດ",
    ACTIVITY_LOG: "0 ບັນທຶກ | 1 ບັນທຶກ | {count} ບັນທຶກ",
    TIPS: "ເຄັດລັບ",
    _CONFIGURATION: {
        MENU: "ເມນູ",
        WIDGET: "ວິເຈດ",
        THEME: "ຫົວຂໍ້",
        SCRIPT: "ສະກຣິບ",

        MENU_HEADER: "ເຫົາເມນູ",
        MENU_FOOTER: "ຟຸດເມນູ",

        LOGO: "ເຫົາຫົວຫົວ",
        HEADER: "ຫົວບົດ",
        BE_CONTENT: "BE ສາລະຫັບ",
        FOOTER: "ຟຸດ",
        FOOTER_BOTTOM: "ຟຸດລຸ່ມ",
        FOOTER_RIGHT: "ຟຸດຂວາ",
        WIDGET_FOOTER_RIGHT: "ວິເຈດ ຟຸດຂວາ",
        WIDGET_FOOTER_BOTTOM: "ວິເຈດ ຟຸດລຸ່ມ",

        WIDGET_SOCIAL_MEDIA_ICON: "ວິເຈດ: ອັກກະທົບ ສືບຕໍ່ສັງຄົມ",
        WIDGET_HTML_TEXT: "ວິເຈດ: ຂໍ້ຄວາມ HTML",
        SCRIPT_WILL_ADD_BODY: "ສະກຣິບຈະຖືກເພີ່ມໃນ <body>",
        SCRIPT_WILL_ADD_HEAD: "ສະກຣິບຈະຖືກເພີ່ມໃນ <head>",
        TEMPLATE: "ແມັບປະກອບ",
        BODY: "ລາຍລະອຽດ",
        BE_SUPPORT: `<p class="fs-14"><b>ວິທີ 1: ການປະກອບກັນຜ່ານຟອມທີ່ສ້າງລ້ຽງແລ້ວ</b></p>
        <p>ຟີເຈີນີ້ອະນຸຍາດໃຫ້ທ່ານເຊື່ອມຕໍ່ລະບົບຈອງຫ້ອງກັບເວັບໄຊຂອງທ່ານ, ໂດຍສະແດງແບບຟອມຈອງຫ້ອງຂອງລະບົບຈອງຫ້ອງຢູ່ໃນເວັບໄຊຂອງທ່ານ.</p>
        <img src="/script-BE.png">
        <br>
        <p><b>ຂັ້ນຕອນ 1:</b> ຄຳນຳຮູບໄວ້ຫົວຄຳຫຼັກໃນດາວລາຍຄຳຫຼາຍຂອງ HTML ກັບການນຳເປັນບົດຄວາມສ້າງກັບການສະແດງກັບການຕິດຕັ້ງຟອມຈອງ.</p>
        <div>
            <i>&lt;div class="booking-form"&gt;&lt;/div&gt;</i>
        </div>
        <div class="mt-3">
            <p><b>ຂັ້ນຕອນ 2:</b> ຄຳນຳຮູບໃນສະແດງສະເປັນແຕ່ຫົວຄຳສ້າງກັບກັບເວັບໄຊທ໌ຕິດກັບຜູ້ຊາວຮູບ.</p>
            <p>1. ກົບພູດຈຳຕິດກັບຈັກມືອອອກ!</p>
            <i> &emsp;&lt;script src="https://apps.oneinventory.com/plugins/ezbe-chain-jquery-5s.js"&gt;&lt;/script&gt; <br>
            &emsp;&lt;script&gt;<br>
            &emsp;&emsp;create_booking_form('XXXXXX', '.booking-form', 'vi', 'VND', 'horizontal', '#ffffff', '#fc5b62');<br>
            &emsp;&lt;/script&gt;<br></i>
        </div>
        <div class="mt-3">
            <p>2. ການມີ jQuery ໃນບົດເວັບຂອງທ່ານ (ເມື່ອມີຄວາມຂົວທັນຈາກສະແດງ):</p>
            <i>&emsp;&lt;script src="https://apps.oneinventory.com/plugins/ezbe-chain-5s.js"&gt;&lt;/script&gt; <br>
            &emsp;&lt;script&gt; <br>
            &emsp;&emsp;create_booking_form('XXXXXX', '.booking-form', 'vi', 'VND', 'horizontal', '#ffffff', '#fc5b62'); <br>
            &emsp;&lt;/script&gt; <br></i>
        </div>
        <br>
        <p><b>ຂັ້ນຕອນ 3:</b> ຕັ້ງຄ່າຕໍ່ກັບຕົວປ່ຽນໃນຟັງຊັນ <b>create_booking_form</b> ເພື່ອກຳຫນົດຄືກັບເວັບໄຊທ໌ຂອງທ່ານ ກ່ອນທີ່ຈະບັນທຶກ.</p>
        <p class="mb-1"><b>ຫົວຄຳ:</b> </p>
        <div class="ml-3">
            <p class="mb-1"><i>XXXXXX</i> : ລະຫັດຫົວຮ້ານຂອງທ່ານ (ຕ້ອງການ).</p>
            <p class="mb-1"><i>.booking-form</i> : ID (#) ຫຼື class (.) ຂອງທີ່ຢູ່ທີ່ສະແດງກັບການສ້າງກັບສະແດງກັບຝົນເພື່ອເງິນກັບເວັບໄຊທ໌.</p>
            <p class="mb-1"><i>vi</i> : ລະຫັດພາສາທີ່ຈະສະແດງທີ່ເປັນຕົວປະກອບ (ຕ້ອງການ). ສະເຫຼີມປິກ 2 ລະຫັດ:</p>
                <p class="mb-1 ml-5"><i>vi</i> : ພາສາຫວຽດນາມ</p>
                <p class="mb-1 ml-5"><i>en</i> : ພາສາອັງກິດ</p>
            <p class="mb-1"><i>VND</i> : ລະຫັດເງິນຕັວປະກອບທີ່ຈະສະແດງທີ່ມາດຕະຖານລະຫັດເງິນປະສົງຕິດຕັ້ງ.</p>
            <p class="mb-1"><i>horizontal</i>: ສະແດງຟອມຈອງຫັບດຳຮູບ (ສາມາດປັບປຸງໄດ້). ມີ 2 ປະເພດທີ່ສະແດງ:</p>
            <p class="mb-1 ml-5"><i>horizontal</i>: ສະແດງຫນັງສືເທົດ</p>
            <p class="mb-1 ml-5"><i>vertical</i>: ສະແດງດິນດອຍ</p>  
            <p class="mb-1"><i>#ffffff</i> : ສະແດງຄວາມທິບກັບປັບພິບວັນຫົວຈຳລາຍ.</p>
            <p class="mb-1"><i>#fc5b62</i> : ປົກກອບບັນວຸງຖາຍຫັບງຸດ.</p>
        </div>
        <hr>
        <p class="fs-14"><b>ວິທີ 2: ປະກອບກັບປະສົບສົບທີ່ກວງ</b></p>
        <p>ສະເຫຼີມປິກປອງຕິດຜະຫາດປົກກອບກັບໂຫົວເພື່ອເງິນ.</p>
        <div>
            <i>https://booking.ezcms.vn/hotel/BeDetailHotel?hotel_code=XXXXXX&check_in=2020-11-30&check_out=2020-12-01&num_of_rooms=1&num_of_adults=2&num_of_children=0&promo_code=&rate_code=&room_code=&lang=vi&amp;currency=VND</i>
        </div>
        <br>
        <p class="mb-1"><b>ຫົວຄຳ:</b> </p>
        <div class="ml-3">
            <p class="mb-1"><i>hotel_code</i>: ລະຫັດຫົວຮ້ານ (ຕ້ອງການ)</p>
            <p class="mb-1"><i>check_in</i>: ວັນທີມາ, ສະກຸນພາບ YYYY-MM-DD  (ຕ້ອງການ)</p>
            <p class="mb-1"><i>check_out</i>: ວັນທີຈອງພວກມູດ.</p> 
            <p class="mb-1"><i>num_of_rooms</i>: ຈຳນວນຫ້ອງ (ຕົວປະກອບ)</p>
            <p class="mb-1"><i>num_of_adults</i>: ຈຳນວນຄົນເຫົາ (ຕົວປະກອບ)</p>
            <p class="mb-1"><i>num_of_children</i>: ຈຳນວນດູເຫົາຄົນ (ຕົວປະກອບ)</p>
            <p class="mb-1"><i>room_code</i>: ລະຫັດຫົວຮ້ານຄັບພິມ (ຕົວປະກອບ)</p>
            <p class="mb-1"><i>rate_code</i>: ລະຫັດກຳຫນົດລາຄາ (ຕົວປະກອບ)</p>
            <p class="mb-1"><i>promo_code</i>: ລະຫັດສົດກອງ (ຕົວປະກອບ)</p>
            <p class="mb-1"><i>lang</i>: ລະຫັດພາສາສະແດງ (ຕົວປະກອບ)</p>
            <p class="mb-1"><i>currency</i>: ລະຫັດສະແດງຊຶດເງິນ (ຕົວປະກອບ)</p>
        </div>
        <hr>
        <p class="fs-14"><b>ວິທີ 3: ຕິດຕັ້ງໂດຍກົງໃສ່ເວັບໄຊຂອງໂຮງແຮມ</b></p>
        <p>ຟັງຊັນນີ້ຈະເຮັດໃຫ້ທ່ານສາມາດຕິດຕັ້ງ Booking Engine ລົງໃນເວັບໄຊໂດຍກົງ. ສະເພາະຄືການສະແດງລາຍການຫ້ອງພັກຂອງ Booking Engine ໃນເວັບໄຊຂອງໂຮງແຮມ.</p>
        <p class="mb-3">
            <b>ຂັ້ນຕອນ 1:</b> ກັດລອກຂໍ້ຄວາມ HTML ຕົວຢ່າງດ້ານລຸ່ມນີ້ ແລ້ວວາງໃສ່ຕຳແໜ່ງທີ່ຕ້ອງການສະແດງຟອມຈອງຫ້ອງໃນເວັບໄຊ:<br/>
            <i>&lt;div class="booking-form"&gt;&lt;/div&gt;</i>
        </p>
        <p class="mb-3">
            <b>ຂັ້ນຕອນ 2:</b> ກັດລອກສະກຣິບຕົວຢ່າງດ້ານລຸ່ມນີ້ ແລ້ວວາງໃສ່ສ່ວນ footer ຂອງເວັບໄຊ (ກ່ອນ &lt;/body&gt;):<br/>
            <i> &emsp;&lt;script src="https://app.oneinventory.com/booking-engine/plugins/ezbe-embed.js"&gt;&lt;/script&gt; <br>
                &emsp;&lt;script&gt;<br>
                &emsp;&emsp;window.initBookingForm({<br>
                &emsp;&emsp;&emsp; hotel: [{ hotelName: 'Hotel A', hotelCode: 'KSA' }],<br> 
                &emsp;&emsp;&emsp; target: '.booking-form',<br>
                &emsp;&emsp;&emsp; path: '/room-list',<br>
                &emsp;&emsp;&emsp; lang: 'lo',<br>
                &emsp;&emsp;&emsp; background: '#ffffff',<br>
                &emsp;&emsp;&emsp; buttonBackground: '#ff0000',<br>
                &emsp;&emsp;&emsp; buttonTextColor: 'white',<br>
                &emsp;&emsp;&emsp; textColor: '#333333'<br>
                &emsp;&emsp; });<br>
                &emsp;&lt;/script&gt;<br>
            </i>
        </p>
        <p class="mb-0">
            <b>ຂັ້ນຕອນ 3:</b> ປັບແຕ່ງຄ່າໃນຟັງຊັນ <b>window.initBookingForm</b> ໃຫ້ເໝາະສົມກັບເວັບໄຊຂອງໂຮງແຮມ ກ່ອນບັນທຶກ.
        </p>
        <div class="ml-3">
            <p class="mb-0"><b>ລາຍລະອຽດ:</b></p>
            <p class="mb-1">
                - <i>hotel</i> : ລາຍຊື່ໂຮງແຮມ. ສາມາດໃສ່ໄດ້ຫຼາຍໂຮງແຮມ. ແຕ່ລະໂຮງແຮມແມ່ນ object ໜຶ່ງ. (ຈຳເປັນ)<br/>
                <span style="padding-left: 12px;"><i>hotelName</i> : ຊື່ໂຮງແຮມ</span><br/>
                <span style="padding-left: 12px;"><i>hotelCode</i> : ລະຫັດໂຮງແຮມ</span><br/>
            </p>
            <p class="mb-1">
                - <i>target</i> : ID (#) ຫຼື class (.) ຂອງເອກະສານ HTML ທີ່ໃສ່ໄວ້ໃນຂັ້ນຕອນ 1 (ຈຳເປັນ)
            </p>
            <p class="mb-1">
                - <i>path</i> : ເສັ້ນທາງໄປຫາໜ້າລາຍການຫ້ອງ. ຖ້າບໍ່ກຳນົດຈະຊີ້ໄປທີ່ <code>https://booking.ezcms.vn (ຕົວປະກອບ)</code>.
            </p>
            <p class="mb-1">
                - <i>lang</i> : ພາສາທີ່ສະແດງໃນຟອມ ແລະລາຍການຫ້ອງ. ຖ້າບໍ່ກຳນົດຈະເປັນພາສາລາວໂດຍອັດຕະໂນມັດ. (ຕົວປະກອບ)<br/>
                <span style="padding-left: 12px;"><b>ຮອງຮັບ 7 ພາສາ:</b></span><br/>
                <span style="padding-left: 12px;"><i>vi</i> : ພາສາຫວຽດນາມ</span><br/>
                <span style="padding-left: 12px;"><i>en</i> : ພາສາອັງກິດ</span><br/>
                <span style="padding-left: 12px;"><i>ja</i> : ພາສາຍີ່ປຸ່ນ</span><br/>
                <span style="padding-left: 12px;"><i>ko</i> : ພາສາເກົາຫຼີ</span><br/>
                <span style="padding-left: 12px;"><i>lo</i> : ພາສາລາວ</span><br/>
                <span style="padding-left: 12px;"><i>km</i> : ພາສາຂະເມຣ</span><br/>
                <span style="padding-left: 12px;"><i>zh</i> : ພາສາຈີນ</span><br/>
                <span style="padding-left: 12px;"><b>ໝາຍເຫດ:</b> ຖ້າ Booking Engine ບໍ່ຮອງຮັບພາສາທີ່ເລືອກ ຈະສະແດງເປັນພາສາອັງກິດ.</span>
            </p>   
            <p class="mb-1">
                - <i>background</i> : ສີພື້ນຫຼັງຂອງຟອມ. ຄ່າຕັ້ງຕົ້ນ: #eee (ຕົວປະກອບ)
            </p>
            <p class="mb-1">
                - <i>buttonTextColor</i>: ສີຂອງຕົວອັກສອນໃນປຸ່ມ “ຊອກຫາຫ້ອງ”. ຄ່າຕັ້ງຕົ້ນ: #fff (ຕົວປະກອບ)
            </p>
            <p class="mb-1">
                - <i>buttonBackground</i>: ສີພື້ນຫຼັງຂອງປຸ່ມ “ຊອກຫາຫ້ອງ”. ຄ່າຕັ້ງຕົ້ນ: ສີແດງ (ຕົວປະກອບ)
            </p>
            <p class="mb-1">
                - <i>textColor</i>: ສີຂອງຂໍ້ຄວາມໃນຟອມ. ໃຊ້ຄ່າຕັ້ງຕົ້ນຂອງ browser. (ຕົວປະກອບ)
            </p>  
        </div>
        <p class="mt-3 mb-0">
            <b>ຂັ້ນຕອນ 4:</b> ໃນໜ້າລາຍການຫ້ອງທີ່ກຳນົດໄວ້ໃນ path ຂັ້ນຕອນ 3:
        </p>
        <p class="mb-0">
            ກັດລອກ HTML ຕົວຢ່າງດ້ານລຸ່ມນີ້ ແລ້ວວາງໃສ່ຈຸດທີ່ຈະສະແດງລາຍການຫ້ອງ:<br/>
            <i>&lt;div id="room-list"&gt;&lt;/div&gt;</i>
        </p>
        <p class="mb-3">
            ກັດລອກ Script ຕົວຢ່າງດ້ານລຸ່ມນີ້ ແລ້ວວາງໃສ່ footer (ກ່ອນປິດ &lt;/body&gt;)<br/>
            <i> &emsp;&lt;script src="https://app.oneinventory.com/booking-engine/plugins/ezbe-embed.js"&gt;&lt;/script&gt; <br>
                &emsp;&lt;script&gt;<br>
                &emsp;&emsp;window.initBookingEngine({<br>
                &emsp;&emsp;&emsp; target: '#room-list',<br>
                &emsp;&emsp;&emsp; scrollToTop: true,<br>
                &emsp;&emsp;&emsp; marginTop: 0<br>
                &emsp;&emsp;});<br>
                &emsp;&lt;/script&gt;<br>
            </i>
        </p>
        <p class="mb-0">
            <b>ຂັ້ນຕອນ 5:</b> ປັບຕົງຄ່າໃນ <b>window.initBookingEngine</b> ໃຫ້ເໝາະສົມ ກ່ອນບັນທຶກ.
        </p>
        <div class="ml-3">
            <p class="mb-0"><b>ລາຍລະອຽດ:</b></p>
            <p class="mb-1">
                - <i>target</i> : ID (#) ຫຼື class (.) ຂອງ HTML ໃນຂັ້ນຕອນ 4 (ຈຳເປັນ)
            </p>
            <p class="mb-1">
                - <i>scrollToTop</i> : ສະແດງ icon ຂຶ້ນຂ້າງເທິງໃນໜ້າ ເມື່ອ scroll ລົງຫຼາຍກວ່າ 500px. ເມື່ອ click ຈະກັບຂຶ້ນເທິງ. ຄ່າຕັ້ງຕົ້ນແມ່ນ false. (ຕົວປະກອບ)
            </p>
            <p class="mb-1">
                - <i>marginTop</i> : ສ້າງເນື້ອທີ່ຫ່າງຈາກດ້ານເທິງ. ຈຸດປະສົງແມ່ນເພື່ອປ້ອງກັນບໍ່ໃຫ້ເນື້ອຫາຖືກບັງໂດຍອົງປະກອບທີ່ຖືກກຳນົດໄວ້ທາງເທິງ, ເຊັ່ນ header ທີ່ຖືກກຳນົດໄວ້ໃນເວັບໄຊ (ເປັນຕົວເລືອກ).
            </p>
        </div>
        <p style="margin-top: 10px;"><b>ເຂົ້າໄປເບິ່ງ demo </b><a href="https://app.oneinventory.com/booking-engine" target="_blank">ທີ່ນີ້</a></p>`,
    },
    CONFIRM_TRANET_CONNECT: `{roomConfirm} ເກີນຈຳນວນຜູ້ຢູ່ອາໄສສູງສຸດ 18 ຄົນ. ຖ້າກົດແຜນທີ່ ອາດຈະເກີດຂໍ້ຜິດພາດ <span class="font-weight-bold">ລົ້ມເຫຼວໃນການແມບ</span>. ກະລຸນາກວດສອບອີກຄັ້ງ.`,
    _PROMOTION: {
        MEALS: {
            BREAKFAST: "ເຂົ້າເຊົ້າ",
            LUNCH: "ເຂົ້າທ່ຽງ",
            DINNER: "ເຂົ້າແລງ",
        },
        PROMOTION_TYPE_LIST: {
            EVERY_NIGHT: "ທຸກຄືນ",
            TOTAL_BOOKING: "ມູນຄ່າການຈອງທັງໝົດ",
            ORDER_BEFORE: "ສັ່ງຈອງ x ມື້ກ່ອນວັນເຂົ້າພັກ",
            ORDER_WITHIN: "ສັ່ງຈອງພາຍໃນ x ມື້ກ່ອນເຂົ້າພັກ",
            FREE_QUANTITY: "ສັ່ງ x ຈຳນວນ, ແຖມ y ຟຣີ",
            FREE_ON_TOTAL_VALUE: "ສັ່ງ x ຈຳນວນ, ແຖມ y ຟຣີ ຈາກລາຄາລວມ",
        },
        DISCOUNT_LIST: {
            DISCOUNT: "ສ່ວນຫຼຸດ",
            SURCHARGE: "ຄ່າໃຊ້ຈ່າຍເພີ່ມ",
        },
        TARGET_APPLY_LIST: {
            BY_AGENT_LEVEL: "ຕາມລະດັບຕົວແທນ",
            BY_AGENT: "ຕາມຕົວແທນ",
        },
        LEVEL_TARGET_APPLY: {
            LEVEL_1: "ລະດັບ 1",
            LEVEL_2: "ລະດັບ 2",
            LEVEL_3: "ລະດັບ 3",
            LEVEL_4: "ລະດັບ 4",
            LEVEL_5: "ລະດັບ 5",
        }
    },
    UTM_CODE: "ລະຫັດ UTM",
    ZOOM: "ຊູມ",
    ACCOUNT_IS_NOT_CONNECTED_TO_TRAVELOKA: "ບັນຊີບໍ່ໄດ້ເຊື່ອມຕໍ່ກັບ ezCms Traveloka",
    UPDATE_FAILED: "ການປັບປຸງລ້ມເຫຼວ",
    DELETE_FAILED: "ການລຶບລ້ມເຫຼວ",
    CREATE_FAILED: "ການສ້າງລ້ມເຫຼວ",
    UPLOAD_FAILED: "ການອັບໂຫຼດລ້ມເຫຼວ",
    USER_NOT_RIGHT: "ບໍ່ມີສິດໃນການເຂົ້າໃຊ້",
    USER_NOT_EXIST: "ບັນຊີບໍ່ມີຢູ່",
    EMAI_IS_EXIST: "ອີເມວນີ້ມີຢູ່ແລ້ວ",
    ACTIVE_SUCCESS: "ເປີດໃຊ້ງານສຳເລັດ",
    DEACTIVE_SUCCESS: "ຍົກເລີກການເຊື່ອມຕໍ່ສຳເລັດ",
    TODAY: "ມື້ນີ້",
    YESTERDAY: "ມື້ວານ",
    TOMORROW: "ມື້ຮື່ນ",
    LOGIN_FAILED: "ເຂົ້າລະບົບລ້ມເຫຼວ",
    ONEPAY_INLAND: "OnePay ໃນປະເທດ",
    ONEPAY_OVERSEA: "OnePay ຕ່າງປະເທດ",
    VN_PAY: "VN Pay",
    SUN: "ອາທິດ",
    MON: "ຈັນ",
    TUE: "ອັງຄານ",
    WED: "ພຸດ",
    THU: "ພະຫັດ",
    FRI: "ສຸກ",
    SAT: "ເສົາ",
    UNDER_MAX_GUEST: "ຈຳນວນແຂກເກີນຈຳນວນສູງສຸດທີ່ກຳນົດໄວ້ໃນນະໂຍບາຍລາຄາ",
    SAVE_RESULTS_WHEN_MAKING_CHANGES: "ບັນທຶກຜົນການປ່ຽນແປງຫຼັງຈາກແກ້ໄຂ",
    $vuetify: {
        badge: 'ເບັດ',
        close: 'ປິດ',
        dataIterator: {
            noResultsText: 'ບໍ່ພົບຂໍ້ມູນທີ່ກົງກັນ',
            loadingText: 'ກໍາລັງໂຫຼດລາຍການ...'
        },
        dataTable: {
            itemsPerPageText: 'ແຖວຕໍ່ໜ້າ:',
            ariaLabel: {
                sortDescending: 'ຈັດລຽງຈາກຫຼັງໄປໜ້າ.',
                sortAscending: 'ຈັດລຽງຈາກໜ້າໄປຫຼັງ.',
                sortNone: 'ບໍ່ໄດ້ຈັດລຽງ.',
                activateNone: 'ຄລິກເພື່ອຍົກເລີກການຈັດລຽງ.',
                activateDescending: 'ຄລິກເພື່ອຈັດລຽງຈາກຫຼັງໄປໜ້າ.',
                activateAscending: 'ຄລິກເພື່ອຈັດລຽງຈາກໜ້າໄປຫຼັງ.'
            },
            sortBy: 'ຈັດລຽງຕາມ'
        },
        dataFooter: {
            itemsPerPageText: 'ລາຍການຕໍ່ໜ້າ:',
            itemsPerPageAll: 'ທັງໝົດ',
            nextPage: 'ໜ້າຕໍ່ໄປ',
            prevPage: 'ໜ້າກ່ອນ',
            firstPage: 'ໜ້າທໍາອິດ',
            lastPage: 'ໜ້າສຸດທ້າຍ',
            pageText: '{0}-{1} ຈາກ {2}'
        },
        datePicker: {
            itemsSelected: 'ເລືອກ {0}',
            nextMonthAriaLabel: 'ເດືອນໜ້າ',
            nextYearAriaLabel: 'ປີໜ້າ',
            prevMonthAriaLabel: 'ເດືອນກ່ອນ',
            prevYearAriaLabel: 'ປີກ່ອນ',
        },
        noDataText: 'ບໍ່ມີຂໍ້ມູນ',
        carousel: {
            prev: 'ຮູບກ່ອນໜ້າ',
            next: 'ຮູບຕໍ່ໄປ',
            ariaLabel: {
                delimiter: 'ພາບສະໄລດ {0} ຈາກ {1}'
            }
        },
        calendar: {
            moreEvents: 'ອື່ນໆ {0}'
        },
        input: {
            clear: 'ລ້າງ {0}',
            prependAction: 'ການກະທໍາທີ່ສະແດງ {0}',
            appendAction: 'ການກະທໍາທີ່ເພີ່ມ {0}'
        },
        fileInput: {
            counter: 'ໄຟລ໌ {0}',
            counterSize: 'ໄຟລ໌ {0} ({1} ທັງໝົດ)'
        },
        timePicker: {
            am: 'ກ່ອນທ່ຽງ',
            pm: 'ຫຼັງທ່ຽງ'
        },
        pagination: {
            ariaLabel: {
                wrapper: 'ການນຳທາງໜ້າ',
                next: 'ໜ້າຕໍ່ໄປ',
                previous: 'ໜ້າກ່ອນ',
                page: 'ໄປທີ່ໜ້າ {0}',
                currentPage: 'ໜ້າປັດຈຸບັນ, ໜ້າ {0}'
            }
        },
        rating: {
            ariaLabel: {
                icon: 'ຄະແນນ {0} ຈາກ {1}'
            }
        },
        loading: 'ກໍາລັງໂຫຼດ...'
    },
    DAYS_OF_WEEK: {
        SUN: "ອາ.",
        MON: "ຈ.",
        TUE: "ອ.",
        WED: "พ.",
        THU: "ພະ.",
        FRI: "ສຸ.",
        SAT: "ເສົາ",
    },
    URL_INVALID: "URL ບໍ່ຖືກຕ້ອງ",
    SELECT_ROOM_TYPE: "ເລືອກປະເພດຫ້ອງ",
    OTA_CONNECTION_ERROR: "ການເຊື່ອມຕໍ່ OTA ຜິດພາດ",
    ROOM_RATE_TYPE: "ປະເພດຫ້ອງ {room} ແຜນລາຄາ {rate}",
    NOT_MATCH_GUEST_COUNT: "ຈຳນວນຄົນຂອງ ezCrs ແລະ Traveloka ບໍ່ກົງກັນ",
    STAFF_MANAGEMENT: "ການຄຸ້ມຄອງພະນັກງານ",
    FUNCTION_MANAGEMENT: "ການຄຸ້ມຄອງຫນ້າທີ່",
    SETUP_RATE_TYPE: "ກຳນົດປະເພດອັດຕາທີ່ຖືກສົ່ງຈາກຊ່ອງທາງໄປຫາ CM",
    INCLUDE_COMMISSION: "ລວມຄ່ານາຍໜ້າ",
    EXCLUDE_COMMISSION: "ບໍ່ລວມຄ່ານາຍໜ້າ",
    UNDEFINED_COMMISSION: "ບໍ່ໄດ້ກຳນົດ",
    EXTRA_DATA_TO_OTA: "ກຳນົດປະເພດຄ່າໃຊ້ຈ່າຍທີ່ສົ່ງຈາກຊ່ອງທາງໄປຫາ CM",
    ROOM_TYPE_SYNCED: "ປະເພດຫ້ອງນີ້ໄດ້ຖືກແມບກັບ OTA ແລ້ວ, ກະລຸນາກວດສອບອີກຄັ້ງ.",
    MANDATORY_LANGUAGE_REQUIRED: "ຈໍາເປັນຕ້ອງເລືອກພາສາຫວຽດນາມ ແລະພາສາອັງກິດ.",
    TOOLTIP_TOGGLE_LANGUAGE: "ໃນຂະນະທີ່ປ່ຽນພາສາສຳລັບການສະແດງ ກະລຸນາອັບເດດຂໍ້ມູນທີ່ເປັນຫຼາຍພາສາໃຫ້ຄົບ ເຊັ່ນ ຊື່ປະເພດຫ້ອງ, ຊື່ນະໂຍບາຍ ແລະອື່ນໆ.",
    TOOLTIP_INCLUDE_COMMISSION: `
        <span class="font-weight-bold fs-13">-ການຕັ້ງຄ່າ: ບໍ່ລວມຄ່ານາຍໜ້າ</span> – ຖ້າຊ່ອງທາງເປັນຜູ້ຮັບເງິນຊຳລະ ແລະ ລະບົບມີຂໍ້ມູນພຽງພໍ ezCrs ຈະຄຳນວນລາຄາຫ້ອງໃໝ່.<br/>
        <span class="font-weight-bold fs-13">-ການຕັ້ງຄ່າ: ລວມຄ່ານາຍໜ້າ</span> – ezCrs ຈະຮັກສາລາຄາຫ້ອງຕາມທີ່ຊ່ອງທາງສົ່ງມາແບບເດີມ.<br/>
        <span class="font-weight-bold fs-13">-ການຕັ້ງຄ່າ: ບໍ່ໄດ້ກຳນົດ</span> – ໃຊ້ເມື່ອລະບົບບໍ່ສາມາດກຳນົດໄດ້ວ່າລາຄາທີ່ຊ່ອງທາງສົ່ງມາໄດ້ລວມຄ່ານາຍໜ້າແລ້ວຫຼືບໍ່.
        ໃນກໍລະນີນີ້ ທັງ <span class="font-weight-bold fs-13">ລວມຄ່ານາຍໜ້າ</span> ແລະ <span class="font-weight-bold fs-13">ບໍ່ລວມຄ່ານາຍໜ້າ</span> ຈະຖືກສະແດງເປັນ <span class="font-weight-bold fs-13">ບໍ່ໄດ້ກຳນົດ</span>.`,
    TOOLTIP_INCLUDE_COMMISSION_AGODA: `
        <span class="font-weight-bold fs-13">-ການຕັ້ງຄ່າ: ລວມຄ່ານາຍໜ້າ</span> – ຖ້າລະບົບມີຂໍ້ມູນພຽງພໍ ezCrs ຈະຄຳນວນລາຄາຫ້ອງສຳລັບການຈອງໃໝ່.<br/>
        <span class="font-weight-bold fs-13">-ການຕັ້ງຄ່າ: ບໍ່ລວມຄ່ານາຍໜ້າ</span> – ezCrs ຈະຮັກສາລາຄາຫ້ອງຕາມທີ່ຊ່ອງທາງສົ່ງມາແບບເດີມ.<br/>
        <span class="font-weight-bold fs-13">-ການຕັ້ງຄ່າ: ບໍ່ໄດ້ກຳນົດ</span> – ໃຊ້ເມື່ອລະບົບບໍ່ສາມາດກຳນົດໄດ້ວ່າລາຄາທີ່ຊ່ອງທາງສົ່ງມາໄດ້ລວມຄ່ານາຍໜ້າແລ້ວຫຼືບໍ່. ໃນກໍລະນີນີ້
        ທັງ <span class="font-weight-bold fs-13">ລວມຄ່ານາຍໜ້າ</span> ແລະ <span class="font-weight-bold fs-13">ບໍ່ລວມຄ່ານາຍໜ້າ</span> ຈະຖືກສະແດງເປັນ <span class="font-weight-bold fs-13">ບໍ່ໄດ້ກຳນົດ</span>.`,
    INPUT_INVALID: "ເກີນຈຳນວນສູງສຸດ",
    GOOGLE_NOTE: "<strong>ໝາຍເຫດ:</strong> ອີງຕາມກົດລະບຽບຫຼ້າສຸດຂອງ Google, ໂຮງແຮມທີ່ໃຊ້ Google Hotel ຈຳເປັນຕ້ອງອັບເດດຂໍ້ມູນ <strong>ພາສີ ແລະ ຄ່າທຳນຽມ</strong> ໃຫ້ຖືກຕ້ອງ. ເພື່ອຮັບປະກັນຄວາມຖືກຕ້ອງຂອງລະບົບ ແລະຫຼີກເວັ້ນຄວາມຜິດພາດ ຈຳເປັນຕ້ອງມີ <strong>ພາສີ ຫຼື ຄ່າທຳນຽມ ຢ່າງນ້ອຍ 1 ລາຍການ ທີ່ມີຄ່າຫຼາຍກວ່າ 0</strong>।",
    INVOICE_REQUEST: "ຄຳຮ້ອງຂໍໃບບິນ",
    COMPANY_NAME_OR_BOOKER: "ຊື່ບໍລິສັດ/ຜູ້ຈອງ",
    HIDE_INFORMATION: "(ເຊື່ອງຂໍ້ມູນ)",
    SHOW_INFORMATION: "(ສະແດງຂໍ້ມູນ)",
    MODULE_EZ_PROMOTION_NOT_ACTIVE: "ໂມດູນສົ່ງເສີມການຂາຍບໍ່ໄດ້ເປີດໃຊ້ງານ",
    INCLUDE_COMMISSION_RATE: "ລວມຄ່ານາຍໜ້າ",
    EXCLUDE_COMMISSION_RATE: "ບໍ່ລວມຄ່ານາຍໜ້າ",
    COMMISSION_RATE_NOTE: "ໝາຍເຫດ: ຂໍ້ມູນຄ່ານາຍໜ້າລວມ ແລະ ບໍ່ລວມແມ່ນເພື່ອອ້າງອີງເທົ່ານັ້ນ",
    SETUP_RATE_TYPE_NOTE: "ໝາຍເຫດ:ການປ່ຽນແປງການຕັ້ງຄ່າ “ກຳນົດປະເພດອັດຕາທີ່ຖືກສົ່ງຈາກຊ່ອງທາງໄປຫາ CM” ສາມາດດຳເນີນໄດ້ ເມື່ອລະບົບມີປະເພດຫ້ອງພັກຢ່າງນ້ອຍ 1 (01) ທີ່ເຊື່ອມຕໍ່ສຳເລັດກັບ Channel ທີ່ກ່ຽວຂ້ອງແລ້ວເທົ່ານັ້ນ.",
}